/**
 * AUTO-GENERATED by scripts/split-tickets.ts · do NOT edit by hand.
 * Truth source: data/tickets/sprint-01..06.ts (full Ticket arrays).
 * Re-run `npx vite-node scripts/split-tickets.ts` after editing any sprint file.
 *
 * Contains all ticket metadata WITHOUT contentRef bodies (which live в _bodies/).
 * Used by Dashboard / Sprint / App for sync access (no async wait).
 */
import type { TicketMeta } from '@shared/schemas';

export const TICKET_META: ReadonlyArray<TicketMeta> = [
  {
    "id": "T00",
    "sprintId": "S01",
    "ord": 0,
    "type": "docs",
    "priority": "P0",
    "title": "Твоё первое задание",
    "estimateMin": 7,
    "ac": [
      {
        "id": "AC-01",
        "text": "Я понимаю, что такое тикет — карточка с одной задачей"
      },
      {
        "id": "AC-02",
        "text": "Я знаю три шага закрытия: галочки → вопрос → кнопка"
      },
      {
        "id": "AC-03",
        "text": "Могу открыть первый спринт"
      }
    ],
    "istqb": [],
    "skills": [],
    "quickCheck": {
      "id": "QC-T00",
      "prompt": "Проверка себя · Quick check",
      "question": "Что нужно сделать, чтобы закрыть любой тикет в курсе?",
      "options": [
        {
          "id": "a",
          "text": "Дочитать текст до конца — дальше всё произойдёт само"
        },
        {
          "id": "b",
          "text": "Отметить галочки в чеклисте, ответить на вопрос и нажать кнопку"
        },
        {
          "id": "c",
          "text": "Написать сообщение наставнику и ждать ответа"
        }
      ],
      "answer": "b",
      "explanation": "Правильно: <strong>галочки → вопрос → кнопка</strong>. Так закрывается каждый тикет в курсе. Если что-то не сделано — кнопка сама подскажет надписью «Осталось: …»."
    }
  },
  {
    "id": "MS-00",
    "sprintId": "S01",
    "ord": 1,
    "type": "docs",
    "priority": "P0",
    "title": "Почему за поиск ошибок платят",
    "estimateMin": 10,
    "ac": [
      {
        "id": "AC-01",
        "text": "Объясню за минуту, почему приложения ломаются — и почему это нормально"
      },
      {
        "id": "AC-02",
        "text": "Расскажу своими словами, чем тестировщик занят в обычный день"
      },
      {
        "id": "AC-03",
        "text": "В журнале есть моя первая запись — момент „странно работает\""
      },
      {
        "id": "AC-04",
        "text": "Понимаю, что даст курс к финалу"
      }
    ],
    "istqb": [],
    "skills": [
      "qa-concepts"
    ],
    "quickCheck": {
      "id": "QC-MS-00",
      "prompt": "Проверка себя · Quick check",
      "question": "Зачем команде тестировщик?",
      "options": [
        {
          "id": "a",
          "text": "Чтобы было кого спросить, кто виноват, когда что-то сломалось"
        },
        {
          "id": "b",
          "text": "Чтобы находить проблемы до того, как их увидят пользователи"
        },
        {
          "id": "c",
          "text": "Чтобы писать код быстрее разработчиков"
        }
      ],
      "answer": "b",
      "explanation": "Правильно: <strong>находить проблемы до пользователей</strong>. Тестировщик не ищет виноватых и не соревнуется с разработчиками — он защищает пользователя и репутацию продукта, задавая вопрос «а что, если?» раньше всех."
    }
  },
  {
    "id": "MS-01",
    "sprintId": "S01",
    "ord": 6,
    "type": "docs",
    "priority": "P0",
    "title": "Что такое тестирование — и три слова вокруг него",
    "estimateMin": 8,
    "ac": [
      {
        "id": "AC-01",
        "text": "Объясню своими словами, что такое тестирование и зачем оно"
      },
      {
        "id": "AC-02",
        "text": "Различаю QA, QC и Testing на простом примере"
      },
      {
        "id": "AC-03",
        "text": "Помню метафору пожара (предотвратить → проверить → ходить с датчиком)"
      },
      {
        "id": "AC-04",
        "text": "Понимаю, зачем джуну различать эти три слова"
      }
    ],
    "istqb": [],
    "skills": [
      "qa-concepts"
    ],
    "quickCheck": {
      "id": "QC-MS-01",
      "prompt": "Quick check",
      "question": "Команда заранее договаривается: «каждую новую форму проверяем по 5 критериям перед демо клиенту». Это какая активность?",
      "options": [
        {
          "id": "a",
          "text": "QC — контроль готового продукта"
        },
        {
          "id": "b",
          "text": "QA — договор о процессе предотвращения"
        },
        {
          "id": "c",
          "text": "Testing — один конкретный тест"
        }
      ],
      "answer": "b",
      "explanation": "Правильно: <strong>QA — договор о процессе предотвращения</strong>. QA — это про <em>процессы</em> и договорённости команды. Сама договорённость заранее не находит баг сейчас — она <em>предотвращает</em> попадание класса багов в готовый продукт. QC — это уже инспекция готовой формы. Testing — один конкретный шаг внутри QC."
    }
  },
  {
    "id": "MS-02",
    "sprintId": "S01",
    "ord": 7,
    "type": "docs",
    "priority": "P0",
    "title": "Реальный пример: мобильный банк",
    "estimateMin": 9,
    "ac": [
      {
        "id": "AC-01",
        "text": "Могу привести пример QA / QC / Testing на одном продукте (банк)"
      },
      {
        "id": "AC-02",
        "text": "Понимаю, как процессы (QA) защищают от типичных багов (которые иначе ловит QC)"
      },
      {
        "id": "AC-03",
        "text": "Объясню разницу между «правилом в Definition of Done» и «конкретным тест-кейсом»"
      },
      {
        "id": "AC-04",
        "text": "Нашёл (нашла) все 3 бага на экране формы перевода — моя первая проверка"
      },
      {
        "id": "AC-05",
        "text": "Рассортировал(а) все 7 событий дня по уровням QA / QC / Testing"
      }
    ],
    "istqb": [],
    "skills": [
      "qa-concepts"
    ],
    "quickCheck": {
      "id": "QC-MS-02",
      "prompt": "Quick check",
      "question": "QA-инженер вводит сумму перевода 0 ₽ в готовую форму и проверяет, что появляется ошибка «сумма должна быть больше нуля». Это какая активность?",
      "options": [
        {
          "id": "a",
          "text": "QA — построение процесса"
        },
        {
          "id": "b",
          "text": "Testing — конкретное действие проверки одного сценария"
        },
        {
          "id": "c",
          "text": "QC — контроль готового продукта"
        }
      ],
      "answer": "b",
      "explanation": "Правильно: <strong>Testing — конкретное действие проверки одного сценария</strong>. Testing — это <em>один конкретный шаг</em>: ввести значение, посмотреть на результат. QA — это весь процесс/правила вокруг качества. QC — это инспекция готового продукта <em>целиком</em> (например, прогон полного чек-листа из 50 пунктов). Один шаг внутри QC = Testing."
    }
  },
  {
    "id": "MS-HUNT",
    "sprintId": "S01",
    "ord": 2,
    "type": "docs",
    "priority": "P0",
    "title": "Как смотрит тестировщик — и твоя первая охота",
    "estimateMin": 12,
    "ac": [
      {
        "id": "AC-01",
        "text": "Называю, чем взгляд тестировщика отличается от пользователя"
      },
      {
        "id": "AC-02",
        "text": "Знаю четыре хода мышления: «а что если», края, глаз на детали, «не верь — проверь»"
      },
      {
        "id": "AC-03",
        "text": "Применяю их на охоте по карточке Артели: нахожу баги и отличаю их от норм"
      },
      {
        "id": "AC-04",
        "text": "Понимаю, что это привычка смотреть, а не врождённый талант"
      }
    ],
    "istqb": [],
    "skills": [
      "qa-concepts",
      "qa-mindset"
    ],
    "quickCheck": {
      "id": "QC-MS-HUNT",
      "prompt": "Проверка себя · Quick check",
      "question": "Пользователь и тестировщик открыли одну и ту же форму оплаты. Чем взгляд тестировщика отличается сильнее всего?",
      "options": [
        {
          "id": "a",
          "text": "Тестировщик быстрее печатает и лучше знает горячие клавиши"
        },
        {
          "id": "b",
          "text": "Тестировщик просто внимательнее по характеру — это врождённое"
        },
        {
          "id": "c",
          "text": "Тестировщик спрашивает «как это сломать» и специально идёт в края (пусто, странное, дважды), а не только привычным путём"
        }
      ],
      "answer": "c",
      "explanation": "Дело не в скорости и не в характере, а в вопросе: «как это сломать?» вместо «работает ли?». Тестировщик нарочно проверяет края и странные сценарии — там и живут баги. Это привычка смотреть, а не врождённый талант, — и она только что сработала у тебя на охоте."
    }
  },
  {
    "id": "MS-03",
    "sprintId": "S01",
    "ord": 8,
    "type": "docs",
    "priority": "P2",
    "title": "Мифы и правда о QA для новичков",
    "estimateMin": 8,
    "ac": [
      {
        "id": "AC-01",
        "text": "Могу назвать минимум 3 мифа о QA и почему они неверны"
      },
      {
        "id": "AC-02",
        "text": "Понимаю, что QA — отдельная специальность, не «временный билет в IT»"
      },
      {
        "id": "AC-03",
        "text": "Понимаю, что цель QA — отсутствие багов, а не их количество"
      },
      {
        "id": "AC-04",
        "text": "Понимаю, почему автоматизация не заменит manual в обозримом будущем"
      },
      {
        "id": "AC-05",
        "text": "Пройдено минимум 5 утверждений-тестов, правда прочитана"
      }
    ],
    "istqb": [],
    "skills": [
      "qa-concepts"
    ],
    "quickCheck": {
      "id": "QC-MS-03",
      "prompt": "Quick check",
      "question": "Junior QA говорит: «Я нашёл за неделю 47 багов, я молодец». Это правда или миф?",
      "options": [
        {
          "id": "a",
          "text": "Правда — больше багов = ценнее QA"
        },
        {
          "id": "b",
          "text": "Миф — много багов = симптом плохого процесса"
        }
      ],
      "answer": "b",
      "explanation": "Это <strong>миф (М3)</strong>. Цель QA — чтобы багов <em>не было</em>, а не чтобы их <em>находить</em>. Лучший QA — тот, после которого баги уходят на этап ревью требований (requirements review — где их фиксить в 100 раз дешевле), а не в production."
    }
  },
  {
    "id": "MS-SPHERES",
    "sprintId": "S01",
    "ord": 3,
    "type": "docs",
    "priority": "P0",
    "title": "Где работают тестировщики — пять сфер",
    "estimateMin": 12,
    "ac": [
      {
        "id": "AC-01",
        "text": "Называю пять сфер, где работают тестировщики, и что в каждой особенного"
      },
      {
        "id": "AC-02",
        "text": "Понимаю, чем отличаются пороги входа и почему старт — web"
      },
      {
        "id": "AC-03",
        "text": "Знаю, что мышление тестировщика переносится между сферами"
      }
    ],
    "istqb": [],
    "skills": [
      "qa-concepts"
    ],
    "quickCheck": {
      "id": "QC-MS-SPHERES",
      "prompt": "Проверка себя · Quick check",
      "question": "Чем на самом деле отличаются сферы тестирования?",
      "options": [
        {
          "id": "a",
          "text": "Инструментами: в каждой сфере свой особый браузер"
        },
        {
          "id": "b",
          "text": "Ценой ошибки и тем, что считается страшным багом: копейка в финтехе, прерывание в mobile, жизнь в медтехе — а мышление одно"
        },
        {
          "id": "c",
          "text": "Ничем — везде одинаковая работа за разные деньги"
        }
      ],
      "answer": "b",
      "explanation": "Правильно — вариант 2. Четыре хода мышления из охоты работают везде — от витрины Артели до тормозного контроллера. Меняются ставки и то, что считается «страшным багом». Поэтому вход через web ничего не закрывает: он открывает всё."
    }
  },
  {
    "id": "MS-CAREER",
    "sprintId": "S01",
    "ord": 4,
    "type": "docs",
    "priority": "P0",
    "title": "Сколько платят и куда расти",
    "estimateMin": 10,
    "ac": [
      {
        "id": "AC-01",
        "text": "Представляю стартовые вилки (с датой проверки) и три причины разброса"
      },
      {
        "id": "AC-02",
        "text": "Называю три дороги роста и когда приходит развилка"
      },
      {
        "id": "AC-03",
        "text": "Знаю про смежные роли — профессия не запирает"
      }
    ],
    "istqb": [],
    "skills": [
      "qa-concepts"
    ],
    "quickCheck": {
      "id": "QC-MS-CAREER",
      "prompt": "Проверка себя · Quick check",
      "question": "Почему два junior QA могут получать очень разные деньги?",
      "options": [
        {
          "id": "a",
          "text": "Сфера (цена ошибки), навыки (руками или ещё и кодом) и тип компании — три главных множителя"
        },
        {
          "id": "b",
          "text": "Дело только в удаче и связях"
        },
        {
          "id": "c",
          "text": "Разницы на самом деле нет — все вилки одинаковые"
        }
      ],
      "answer": "a",
      "explanation": "Правильно — вариант 1. И все три множителя — управляемые: сфера выбирается, навык автоматизации добирается (вторая половина курса), а первая компания — только первая. Вилка — это не приговор, а карта, где можно прибавить."
    }
  },
  {
    "id": "MS-COURSE",
    "sprintId": "S01",
    "ord": 5,
    "type": "docs",
    "priority": "P0",
    "title": "Что тебя ждёт на курсе",
    "estimateMin": 8,
    "ac": [
      {
        "id": "AC-01",
        "text": "Представляю весь путь курса — четыре ступени до junior QA"
      },
      {
        "id": "AC-02",
        "text": "Понимаю, что Артель — сквозной проект, на котором тренируюсь весь курс"
      },
      {
        "id": "AC-03",
        "text": "Знаю, что помогает в приложении: наставники, глоссарий, экзамены-вехи, охоты"
      },
      {
        "id": "AC-04",
        "text": "Понимаю, что будет в портфолио к финалу"
      }
    ],
    "istqb": [],
    "skills": [
      "qa-concepts"
    ],
    "quickCheck": {
      "id": "QC-MS-COURSE",
      "prompt": "Проверка себя · Quick check",
      "question": "Чем этот курс отличается от обычных видеолекций по тестированию?",
      "options": [
        {
          "id": "a",
          "text": "Ничем — это те же лекции, только текстом"
        },
        {
          "id": "b",
          "text": "Это тренажёр: с первого дня находишь баги и пишешь проверки на настоящем магазине «Артель», а к финалу у тебя портфолио, а не просто отметка о просмотре"
        },
        {
          "id": "c",
          "text": "Здесь только теория, а практика — отдельно и платно"
        }
      ],
      "answer": "b",
      "explanation": "Правильно — вариант 2. Курс — <strong>тренажёр</strong>, а не лекции: учишься деланием на сквозном проекте «Артель». Результат к финалу — портфолио настоящих проверок плюс база под автоматизацию и подготовка к сертификату CTFL."
    }
  },
  {
    "id": "MS-13",
    "sprintId": "S01",
    "ord": 9,
    "type": "docs",
    "priority": "P0",
    "title": "AI в этом спринте · Claude / ChatGPT помогает с QA",
    "estimateMin": 9,
    "ac": [
      {
        "id": "AC-01",
        "text": "Прочитаны 3 шаблона промптов"
      },
      {
        "id": "AC-02",
        "text": "Хотя бы один промпт опробован в Claude/ChatGPT"
      },
      {
        "id": "AC-03",
        "text": "Ясно: AI — усиление, не замена"
      },
      {
        "id": "AC-04",
        "text": "Знаю 3 антипаттерна использования AI"
      }
    ],
    "istqb": [],
    "skills": [
      "ai-workflow",
      "documentation"
    ],
    "quickCheck": {
      "id": "QC-MS-13",
      "prompt": "Quick check",
      "question": "Junior QA пишет тест-кейсы для оформления заказа. Какой способ использования AI правильный, а какой — антипаттерн?",
      "options": [
        {
          "id": "a",
          "text": "«Claude, напиши мне 20 тест-кейсов для оформления заказа» → копирую в систему кейсов → закрываю тикет"
        },
        {
          "id": "b",
          "text": "Сначала пишу 8-10 кейсов своей головой, потом «Claude, проверь мои кейсы и предложи 3 пропущенных крайних случая» — итерируем"
        },
        {
          "id": "c",
          "text": "«Claude, на собесе спросят про checkout — какие ответы заучить?» — заучиваю готовые формулировки без понимания"
        },
        {
          "id": "d",
          "text": "Не пользоваться AI вообще — индустрия скоро вернётся к ручному труду"
        }
      ],
      "answer": "b",
      "explanation": "Правильно: <strong>пишешь ты, AI проверяет</strong>. Это «AI как усилитель мозга», не замена. (a) — антипаттерн №1 «AI напиши за меня»: на собесе спросят про твоё мышление, а не про промпт. (c) — антипаттерн №2 «фальшивый прогресс»: ты не учишься, ты заучиваешь чужие ответы. (d) — индустриальный факт: больше половины junior QA уже используют AI ежедневно; не пользоваться = терять заметно в продуктивности. Главное правило: AI делает <em>рутину</em> и <em>проверку</em>, ты делаешь <em>мышление</em> и <em>контекст</em>."
    }
  },
  {
    "id": "MS-14",
    "sprintId": "S01",
    "ord": 10,
    "type": "mission",
    "priority": "P0",
    "title": "Миссия · Первый день в Артели",
    "estimateMin": 24,
    "ac": [
      {
        "id": "AC-01",
        "text": "Прохожу полный мини-цикл: нахожу баги на витрине → сортирую → оформляю один в мини-репорт"
      },
      {
        "id": "AC-02",
        "text": "Отличаю баг от нормы и от «надо уточнить»"
      },
      {
        "id": "AC-03",
        "text": "Оформляю находку по костяку «что + где + ожидалось/фактически»"
      },
      {
        "id": "AC-04",
        "text": "Выношу навык в реальность: фиксирую 1 настоящий баг в своём приложении"
      },
      {
        "id": "AC-05",
        "text": "Вижу пройденный участок Тропы и состав пути впереди"
      },
      {
        "id": "AC-06",
        "text": "Нахожу дыру во фрагменте настоящего ТЗ Артели (превью механики S02)"
      }
    ],
    "istqb": [],
    "skills": [
      "qa-concepts",
      "qa-mindset",
      "bug-report-writing"
    ]
  },
  {
    "id": "REQ-01",
    "sprintId": "S02",
    "ord": 1,
    "type": "docs",
    "priority": "P1",
    "title": "Требования — где рождаются баги",
    "estimateMin": 12,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю 4 типа требований (business / functional / non-functional / UI) и могу привести пример каждого"
      },
      {
        "id": "AC-02",
        "text": "Знаю минимум 3 документа, где живут требования (PRD, User Story, Tech Spec, Figma)"
      },
      {
        "id": "AC-03",
        "text": "Понимаю, почему QA подключается на этапе requirements, а не после разработки"
      },
      {
        "id": "AC-04",
        "text": "Помню факт «баг в требованиях ×100 дешевле бага в проде»"
      }
    ],
    "istqb": [
      "CTFL-Ch2",
      "CTFL-Ch3"
    ],
    "skills": [
      "requirements-analysis"
    ],
    "quickCheck": {
      "id": "QC-REQ-01",
      "prompt": "Quick check",
      "question": "PM пишет требование: «Страница каталога должна загружаться менее чем за 2 секунды при 10 000 одновременных пользователях». К какому типу требований это относится?",
      "options": [
        {
          "id": "a",
          "text": "Business — это про метрику, а метрики у бизнеса"
        },
        {
          "id": "b",
          "text": "Functional — описывает поведение системы"
        },
        {
          "id": "c",
          "text": "Non-functional — описывает качество (скорость + нагрузка), а не поведение"
        },
        {
          "id": "d",
          "text": "UI/UX — про то, как страница выглядит при загрузке"
        }
      ],
      "answer": "c",
      "explanation": "Правильно: <strong>Non-functional</strong>. Это требование описывает <em>как</em> система работает (скорость + нагрузка), а не <em>что</em> делает. Functional ответил бы на вопрос «что страница показывает» (товары, фильтры, цены). Business — про конечную цель («увеличить конверсию», «удержать юзера»). UI/UX — про макет, цвета, тексты. Performance + Load — классические non-functional атрибуты по ISO 25010, и QA часто ловит их пропуск в PRD на ревью."
    }
  },
  {
    "id": "TEAM-01",
    "sprintId": "S02",
    "ord": 2,
    "type": "docs",
    "priority": "P0",
    "title": "Как работает команда: Agile, спринты и место QA",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Объясняю суть Agile своими словами: короткие итерации и обратная связь вместо большого плана"
      },
      {
        "id": "AC-02",
        "text": "Узнаю в лицо Scrum (спринты, церемонии) и Kanban (поток, WIP-лимит)"
      },
      {
        "id": "AC-03",
        "text": "Знаю, где в круге место QA (на каждом шаге), и к кому идти с дырой, багом или упавшим стендом"
      }
    ],
    "istqb": [
      "CTFL-Ch1"
    ],
    "skills": [
      "qa-concepts",
      "agile"
    ],
    "quickCheck": {
      "id": "QC-TEAM-01",
      "prompt": "Quick check",
      "question": "Где место QA в Agile-команде?",
      "options": [
        {
          "id": "a",
          "text": "На каждом шаге круга: от чтения Story в бэклоге до голоса на ретро"
        },
        {
          "id": "b",
          "text": "В конце спринта — когда всё готово и можно проверять"
        },
        {
          "id": "c",
          "text": "Только на дейли — рассказать, сколько багов найдено"
        }
      ],
      "answer": "a",
      "explanation": "«QA в конце» — самый дорогой способ работать: баги находятся, когда чинить их уже больно. Весь этот спринт ты занимаешься ровно ранней частью круга — дырами в требованиях до старта кода."
    }
  },
  {
    "id": "REQ-03",
    "sprintId": "S02",
    "ord": 3,
    "type": "docs",
    "priority": "P1",
    "title": "User Story: заявка на фичу тремя строками",
    "estimateMin": 10,
    "ac": [
      {
        "id": "AC-01",
        "text": "Помню формат User Story: As a / I want / So that"
      },
      {
        "id": "AC-02",
        "text": "Могу собрать Story из живой жалобы за 3 шага (кто страдает / что нужно / зачем)"
      },
      {
        "id": "AC-03",
        "text": "Могу отличить хорошую Story от плохой по конкретике роли, действия и пользы"
      },
      {
        "id": "AC-04",
        "text": "Понимаю, что Story — это «обещание разговора», а не финальное ТЗ"
      }
    ],
    "istqb": [
      "CTFL-Ch2",
      "CTFL-Ch3"
    ],
    "skills": [
      "requirements-analysis"
    ],
    "quickCheck": {
      "id": "QC-REQ-03",
      "prompt": "Quick check",
      "question": "PM приносит на груминг Story: «As a user, I want the system to be more intuitive, so that I have a better experience». В чём главный изъян и что QA должен попросить?",
      "options": [
        {
          "id": "a",
          "text": "Формат «As a / I want / So that» соблюдён — Story валидна, можно брать в спринт"
        },
        {
          "id": "b",
          "text": "Слишком короткая — просим PM расписать на 2 страницы детально"
        },
        {
          "id": "c",
          "text": "Размытая роль («user» — кто?) + размытое действие («intuitive» — как измерить?) + размытая польза — просим уточнить роль, наблюдаемое поведение и метрику"
        },
        {
          "id": "d",
          "text": "Не указан scope в стори-поинтах — главное, чтобы PM добавил оценку"
        }
      ],
      "answer": "c",
      "explanation": "Правильно: <strong>размыто во всех трёх частях</strong>. «User» — кто именно? (новый / постоянный / B2B / B2C). «Intuitive» — это вкус, а не свойство; нужны observable behaviour + метрика («onboarding flow ≤ 3 шагов», «% юзеров проходят без подсказки ≥ 80%»). «Better experience» — субъективно. (a) — формат соблюдён, но содержание пустое. (b) — User Story НЕ должна быть «на 2 страницы»; это «обещание разговора», а не ТЗ (см. REQ-05 INVEST · буква N). (d) — стори-поинты добавляют после уточнения, не до. Главная работа QA на груминге — вернуть PM Story с конкретными вопросами, чтобы из неё стало можно написать AC."
    }
  },
  {
    "id": "REQ-04",
    "sprintId": "S02",
    "ord": 4,
    "type": "docs",
    "priority": "P1",
    "title": "Ловить до кода: зачем QA приходит раньше всех",
    "estimateMin": 14,
    "ac": [
      {
        "id": "AC-01",
        "text": "Объясняю принцип shift-left и связь с ISTQB Principle 3 (Early Testing Saves Time and Money)"
      },
      {
        "id": "AC-02",
        "text": "Помню лестницу стоимости фикса по фазам: ×1 (Requirements) → ×10 (Dev) → ×30 (Test) → ×100+ (Production)"
      },
      {
        "id": "AC-03",
        "text": "Знаю 5 категорий уточняющих вопросов QA на груминге (функциональность · валидация · security · краевые случаи · UX) и применяю как чек-лист"
      },
      {
        "id": "AC-04",
        "text": "Могу пройти 1 из 3 типичных груминг-историй (банк / e-commerce / B2B SaaS) и сгенерировать ≥7 вопросов по 5 категориям"
      },
      {
        "id": "AC-05",
        "text": "Нашёл (нашла) все 3 дыры в Story «Перевод между своими счетами» — мой первый поиск дыр в требованиях"
      },
      {
        "id": "AC-06",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ"
      }
    ],
    "istqb": [
      "CTFL-Ch2",
      "CTFL-Ch3"
    ],
    "skills": [
      "requirements-analysis"
    ],
    "quickCheck": {
      "id": "QC-REQ-04",
      "prompt": "Quick check",
      "question": "Команда работает по Agile / Scrum: в понедельник проходит груминг новых User Stories, во вторник Dev начинает кодить. Когда QA подключается к этим Stories по принципу shift-left?",
      "options": [
        {
          "id": "a",
          "text": "После того как Dev завершит код — на этапе Test, чтобы тестировать готовое"
        },
        {
          "id": "b",
          "text": "На груминге в понедельник — задать уточняющие вопросы PM по требованиям, до старта Dev"
        },
        {
          "id": "c",
          "text": "На demo в конце спринта — приёмка финального результата вместе с PO"
        },
        {
          "id": "d",
          "text": "Когда фича выйдет в production — отслеживать инциденты по логам"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: на груминге в понедельник.</strong> Shift-left = QA участвует на этапе требований, до старта разработки. На груминге задаёшь вопросы по 5 категориям (функциональность · валидация · security · краевые случаи · UX) и превращаешь размытую Story в конкретные требования <em>до</em> того, как Dev начнёт кодить. Остальные опции — варианты «test-after-dev»: <strong>после кода</strong> = классический не-shift-left, дефект уже в коде; <strong>на demo</strong> = ещё позже, фича уже собрана; <strong>в production</strong> = совсем поздно, цена дефекта по REQ-01 ×100 vs ×1 на груминге."
    }
  },
  {
    "id": "REQ-05",
    "sprintId": "S02",
    "ord": 5,
    "type": "docs",
    "priority": "P1",
    "title": "INVEST: шесть признаков рабочей Story",
    "estimateMin": 15,
    "ac": [
      {
        "id": "AC-01",
        "text": "Расшифровываю INVEST по буквам и понимаю, какая буква самая важная для QA (T — Testable)"
      },
      {
        "id": "AC-02",
        "text": "Для каждой из 6 букв могу привести пример провала из своего домена и инструкцию «как переписать»"
      },
      {
        "id": "AC-03",
        "text": "Различаю good vs bad Story на ≥ 2 разных доменах (web + mobile + B2B SaaS)"
      },
      {
        "id": "AC-04",
        "text": "Знаю минимум 2 уточняющих вопроса, которые QA задаёт PM на груминге по INVEST (Testable / Estimable)"
      },
      {
        "id": "AC-05",
        "text": "Прошёл (прошла) карусель «Какая буква страдает?» — 6 Story"
      },
      {
        "id": "AC-06",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ"
      }
    ],
    "istqb": [
      "CTFL-Ch2"
    ],
    "skills": [
      "requirements-analysis"
    ],
    "quickCheck": {
      "id": "QC-REQ-05",
      "prompt": "Quick check",
      "question": "PM приносит на груминг User Story: «As a user, I want a more reliable platform.» Какая буква INVEST у этой Story страдает сильнее всего, и почему именно она — главный сигнал для QA вернуть Story в доработку до старта Dev?",
      "options": [
        {
          "id": "a",
          "text": "I (Independent) — reliability обычно требует переделки нескольких сервисов"
        },
        {
          "id": "b",
          "text": "N (Negotiable) — формулировка «more reliable» закрытая, не приглашает к обсуждению"
        },
        {
          "id": "c",
          "text": "V (Valuable) — «more reliable» не содержит понятной пользы пользователю"
        },
        {
          "id": "d",
          "text": "T (Testable) — «more reliable» без метрики (uptime? error rate?) — нельзя сформулировать наблюдаемый критерий «фича готова»"
        }
      ],
      "answer": "d",
      "explanation": "Правильно: <strong>T (Testable)</strong>. Без числа («uptime ≥ 99.9%», «error rate &lt; 0.1%», «p95 latency &lt; 200ms») QA не может сформулировать наблюдаемый критерий приёмки, а команда — сказать «готово / не готово». На груминге QA первый возвращает такую Story PM с вопросом «как мы измерим <em>reliable</em>?». Остальные опции — тоже валидные проблемы Story (любая буква INVEST может страдать), но T — самая критичная для QA, потому что без неё ты не пишешь тесты вообще. I, N, V можно раскрыть на груминге через диалог; T требует <strong>конкретики от PM до старта Dev</strong>."
    }
  },
  {
    "id": "REQ-06",
    "sprintId": "S02",
    "ord": 6,
    "type": "docs",
    "priority": "P0",
    "title": "Критерии приёмки: как договориться, что такое «готово»",
    "estimateMin": 13,
    "ac": [
      {
        "id": "AC-01",
        "text": "Помню формулу AC: Given (предусловие) / When (действие) / Then (результат)"
      },
      {
        "id": "AC-02",
        "text": "Могу написать минимум 4 AC для одной User Story с покрытием happy + negative + edge + security"
      },
      {
        "id": "AC-03",
        "text": "Различаю хорошие и плохие AC по конкретике (числа, точный текст, наблюдаемые факты) и измеримости"
      },
      {
        "id": "AC-04",
        "text": "Знаю 4 вопроса-триггера для поиска пропущенных AC («поле пустое? интернет пропал? не авторизован? невалидные данные?»)"
      },
      {
        "id": "AC-05",
        "text": "Написал(а) свой AC-7 (повторный запрос ссылки) и сверил(ась) с образцом"
      }
    ],
    "istqb": [
      "CTFL-Ch3",
      "CTFL-Ch4"
    ],
    "skills": [
      "requirements-analysis",
      "documentation-practice"
    ],
    "quickCheck": {
      "id": "QC-REQ-06",
      "prompt": "Quick check",
      "question": "Junior пишет AC для login: «Когда пользователь ввёл правильный email и правильный пароль и нажал «Войти», открывается главный экран». Что не так с этой формулировкой?",
      "options": [
        {
          "id": "a",
          "text": "Всё нормально — это G/W/T в одной фразе, формат соблюдён"
        },
        {
          "id": "b",
          "text": "Не хватает явного Given (предусловие до действия — например, «пользователь на login page»). When и Then склеены, читать тяжело — лучше разнести на 3 строки"
        },
        {
          "id": "c",
          "text": "Это test case, не AC — AC должен быть абстрактным («высокого уровня»), а тут конкретные шаги"
        },
        {
          "id": "d",
          "text": "Не хватает security-аспекта — должен быть AC про SQL-инъекцию"
        }
      ],
      "answer": "b",
      "explanation": "Правильно: <strong>не хватает явного Given</strong>. AC в формате Given/When/Then требует <em>трёх отдельных частей</em>: <strong>Given</strong> (состояние ДО действия — «user на login page, не залогинен»), <strong>When</strong> (одно действие — «вводит email + пароль и жмёт Войти»), <strong>Then</strong> (наблюдаемый результат — «открывается главный экран»). Здесь Given пропущен (предусловие зашито внутри When), а When и Then склеены в одну фразу — читать тяжело, тестировать сложнее. (a) — формат как раз НЕ соблюдён. (c) — AC = это и есть конкретное условие приёмки, не «высокий уровень»; конкретика — норма. (d) — security-AC обычно отдельный, не часть основного happy-path AC."
    }
  },
  {
    "id": "REQ-07",
    "sprintId": "S02",
    "ord": 7,
    "type": "docs",
    "priority": "P1",
    "title": "Почини критерии: пять способов испортить AC",
    "estimateMin": 12,
    "ac": [
      {
        "id": "AC-01",
        "text": "Могу написать минимум 6 AC для Payment flow с фокусом на edge cases (privacy, idempotency, FX, 3DS)"
      },
      {
        "id": "AC-02",
        "text": "Могу написать минимум 6 AC для Filter products с фокусом на UI (empty state, stateful navigation, business rules)"
      },
      {
        "id": "AC-03",
        "text": "Распознаю 5 анти-паттернов AC (расплывчато / AC=test step / только happy / без security / решение вместо результата) и могу переписать пример каждого"
      },
      {
        "id": "AC-04",
        "text": "На code review AC PM-Story сразу замечаю минимум 1 из 5 анти-паттернов и предлагаю «как переписать»"
      },
      {
        "id": "AC-05",
        "text": "Починил(а) все 4 плохих AC в практике «Почини сам»"
      },
      {
        "id": "AC-06",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ"
      }
    ],
    "istqb": [
      "CTFL-Ch3",
      "CTFL-Ch4"
    ],
    "skills": [
      "requirements-analysis",
      "documentation-practice"
    ],
    "quickCheck": {
      "id": "QC-REQ-07",
      "prompt": "Quick check",
      "question": "User Story: «As a customer, I want to apply a promo code at checkout, so that I get a discount.» Все 4 AC ниже формально написаны в Given/When/Then. Один из них — анти-паттерн «расплывчатая формулировка», и QA должен вернуть его на доработку. Какой?",
      "options": [
        {
          "id": "a",
          "text": "Given валидный промокод, When нажимает Apply, Then скидка применяется к итогу заказа"
        },
        {
          "id": "b",
          "text": "Given промокод не существует, When нажимает Apply, Then показывается ошибка «Promo code not found»"
        },
        {
          "id": "c",
          "text": "Given промокод уже применён к заказу, When юзер вводит другой, Then приложение спрашивает «Replace current?»"
        },
        {
          "id": "d",
          "text": "Given юзер вводит промокод, When нажимает Apply, Then всё работает корректно и юзер доволен"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: четвёртый AC.</strong> «Всё работает корректно и юзер доволен» — субъективная пара формулировок: <em>«корректно»</em> и <em>«доволен»</em> нельзя превратить в тест. Это анти-паттерн АП-1 «расплывчатые слова». Лечение — заменить на наблюдаемые факты: точный текст в UI, конкретное состояние корзины, числовая метрика. Остальные три AC — рабочие: AC-1 (happy) — конкретное действие и результат; AC-2 (negative) — точный текст ошибки; AC-3 (edge) — поведение при конфликте с уже применённым промокодом."
    }
  },
  {
    "id": "REQ-08",
    "sprintId": "S02",
    "ord": 8,
    "type": "docs",
    "priority": "P1",
    "title": "MoSCoW: что делаем сейчас, а что — честно нет",
    "estimateMin": 10,
    "ac": [
      {
        "id": "AC-01",
        "text": "Расшифровываю MoSCoW: Must / Should / Could / Won't (have)"
      },
      {
        "id": "AC-02",
        "text": "Понимаю, как приоритет требования влияет на глубину тестирования (Must = глубоко + edge + security; Should = happy + negative; Could = smoke; Won't = 0)"
      },
      {
        "id": "AC-03",
        "text": "На собесе на вопрос «у вас 20 Stories, успеваете 12, что делаете?» отвечаю «сортирую по MoSCoW: сначала M, потом S по убыванию риска»"
      },
      {
        "id": "AC-04",
        "text": "Прошёл(шла) сортер: разложил(а) 6 историй доставки еды по корзинам MoSCoW"
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "requirements-analysis"
    ],
    "quickCheck": {
      "id": "QC-REQ-08",
      "prompt": "Quick check",
      "question": "PM банка приносит на спринт 3 Story для мобильного приложения: (A) push-уведомление о подозрительной операции — его требует регулятор, проверка через 2 недели; (B) тёмная тема — давняя просьба пользователей в отзывах; (C) кнопка «поделиться чеком в WhatsApp» — идея маркетинга. Команда из 4 человек, 2 недели спринта. Какая Story должна быть Must (M) по MoSCoW?",
      "options": [
        {
          "id": "a",
          "text": "A — уведомление о мошенничестве: без него банк не пройдёт проверку регулятора, срок жёсткий"
        },
        {
          "id": "b",
          "text": "B — тёмная тема: давняя просьба пользователей, рейтинг в сторе страдает"
        },
        {
          "id": "c",
          "text": "C — кнопка WhatsApp: маркетинг хочет, приводит новых пользователей"
        },
        {
          "id": "d",
          "text": "Все три Must — банк не может выпускать релиз с неполной фичей"
        }
      ],
      "answer": "a",
      "explanation": "<strong>Правильно: A — уведомление о мошенничестве.</strong> Must = «без этого релиза нет / последствия фатальны». Требование регулятора со сроком через 2 недели — жёсткое внешнее ограничение: провал проверки = штрафы, вплоть до отзыва лицензии. <strong>B (тёмная тема)</strong> — Should или Could: важно для удобства, но релиз не блокирует; рейтинг в сторе страдает постепенно, не катастрофически. <strong>C (кнопка WhatsApp)</strong> — Could или Won't: «приятная мелочь» маркетинга, основной поток работы не блокирует; «маркетинг хочет» ≠ «бизнес умрёт без этого». <strong>«Все три Must»</strong> — типичная ошибка новичка: три Must в спринте на 4 человека = провал по всем трём. Реальная приоритизация — это осознанный выбор, что отложить."
    }
  },
  {
    "id": "REQ-09",
    "sprintId": "S02",
    "ord": 9,
    "type": "docs",
    "priority": "P1",
    "title": "RTM: карта «требование → проверка»",
    "estimateMin": 15,
    "ac": [
      {
        "id": "AC-01",
        "text": "Объясняю, что такое RTM и какие 4 ситуации она помогает увидеть (passed / failed / partial / no tests)"
      },
      {
        "id": "AC-02",
        "text": "Знаю, что в маленьких командах RTM можно вести даже в Google Sheets, в больших — в TestRail / Jira / Xray"
      },
      {
        "id": "AC-03",
        "text": "Могу прочитать RTM на 10+ строк и назвать 3 первые проблемы для следующего стенд-апа"
      },
      {
        "id": "AC-04",
        "text": "Объясняю, как MoSCoW трансформируется в распределение времени QA в Test Plan (60-70% на M, 20-25% на S, 5-10% на C, 0% на W)"
      },
      {
        "id": "AC-05",
        "text": "Нашёл (нашла) оба блокера релиза в практике «пятница, 17:40» (Failed по авторизации + No tests)"
      },
      {
        "id": "AC-06",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ"
      }
    ],
    "istqb": [
      "CTFL-Ch3",
      "CTFL-Ch5"
    ],
    "skills": [
      "requirements-analysis"
    ],
    "quickCheck": {
      "id": "QC-REQ-09",
      "prompt": "Quick check",
      "question": "В RTM на 12 строк e-commerce проекта ты видишь распределение: 7 Passed · 2 Failed · 1 Partial · 2 No tests! Релиз через 3 дня. Какая категория сигнализирует о требованиях <em>без проверок вообще</em> и поэтому требует первого внимания QA до решения о релизе?",
      "options": [
        {
          "id": "a",
          "text": "7 Passed — провести повторную регрессию для уверенности"
        },
        {
          "id": "b",
          "text": "2 Failed — известные баги, надо идти к Dev для фикса до релиза"
        },
        {
          "id": "c",
          "text": "1 Partial — дописать оставшиеся тесты, чтобы поднять покрытие до Passed"
        },
        {
          "id": "d",
          "text": "2 No tests! — требование есть, проверок нет; неизвестно, есть ли там дефект"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: «No tests!».</strong> Это дыра в покрытии, которую RTM делает видимой <em>до</em> релиза: требование зафиксировано, проверка не написана, и продукт уходит в прод «слепым» по этой части функциональности. Реакция QA — немедленно завести задачу на TC и обсудить приоритет с тимлидом: либо допишем до релиза, либо MoSCoW-понизим эту часть scope. <strong>Failed</strong> и <strong>Partial</strong> — тоже работа, но в этих случаях проблема <em>уже идентифицирована</em>: для Failed — баг в Dev, для Partial — тесты в работе. <strong>Passed</strong> — закрытая зона; повторная регрессия нужна на release-candidate, но не «первое внимание сейчас»."
    }
  },
  {
    "id": "REQ-10",
    "sprintId": "S02",
    "ord": 10,
    "type": "ai",
    "priority": "P1",
    "title": "AI в требованиях — искать дыры и проверять выводы",
    "estimateMin": 11,
    "ac": [
      {
        "id": "AC-01",
        "text": "Запомнил(а) 3 шаблона промптов: дыры в Story · черновик AC · оценка по INVEST"
      },
      {
        "id": "AC-02",
        "text": "Прогнал(а) Промпт 1 на своей Story и записал(а) 3 вопроса в журнал"
      },
      {
        "id": "AC-03",
        "text": "Понимаю, что AI генерит гипотезы, а не истины — бизнес-специфику сверяю с PM/PRD"
      },
      {
        "id": "AC-04",
        "text": "Никогда не передаю AC от AI «как есть» — всегда правлю под реальный продукт"
      },
      {
        "id": "AC-05",
        "text": "Знаю чек-лист из 6 триггеров «когда обязательно проверить вывод AI у PM»"
      },
      {
        "id": "AC-06",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ"
      }
    ],
    "istqb": [
      "CTFL-Ch1"
    ],
    "skills": [
      "ai-workflow",
      "requirements-analysis"
    ],
    "quickCheck": {
      "id": "QC-REQ-10",
      "prompt": "Quick check",
      "question": "AI выдал тебе после Промпта 2 такой AC: «Given промокод применён к заказу, When юзер добавляет товар со скидкой в корзину, Then скидка промокода складывается со скидкой товара». Формат G/W/T корректен, формулировка <em>звучит правдоподобно</em>. Что должен сделать junior-QA до коммита этого AC в Jira?",
      "options": [
        {
          "id": "a",
          "text": "Скопировать AC в Jira как есть — формат правильный, AI обычно знает индустриальные стандарты"
        },
        {
          "id": "b",
          "text": "Удалить AC и перегенерировать через Промпт 1 — Промпт 2 ненадёжен на скидках"
        },
        {
          "id": "c",
          "text": "Спросить PM/PRD: «как промокоды должны взаимодействовать со скидками в нашем продукте?» — это бизнес-правило, AI не знает специфики"
        },
        {
          "id": "d",
          "text": "Передать AC разработчику — пусть он решит, как обрабатывать скидки в коде"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: спросить PM/PRD до коммита.</strong> Поведение «промокод × скидка» — это <em>бизнес-правило конкретного продукта</em>: в одном магазине промокоды складываются со скидками, в другом категорически нет. AI генерирует «среднюю по индустрии» гипотезу, не зная специфики твоего продукта (триггер галлюцинации из мини-кейса REQ-05). Опция 1 — подставляешь себя: PM подумает, что ты не разобрался(лась). Опция 2 — переключение промптов не решает проблему: гипотеза AI не становится истиной от прогона через другой промпт. Опция 4 — переложить бизнес-решение на Dev неверно: Dev реализует то, что зафиксировано в AC, а решение «как должно быть» принимает PM. Правило: <strong>AI = генератор вопросов и гипотез; PM/PRD = источник ответов на бизнес-правила</strong>."
    }
  },
  {
    "id": "REQ-11",
    "sprintId": "S02",
    "ord": 11,
    "type": "docs",
    "priority": "P1",
    "title": "Ревью без запуска: static против dynamic",
    "estimateMin": 13,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю Static и Dynamic Testing, могу привести 2 примера каждого"
      },
      {
        "id": "AC-02",
        "text": "Знаю минимум 5 типов артефактов, которые можно ревьюить статикой (Requirements / User Stories + AC / Design / Tech Spec / Test Cases / Test Plans / User Manuals)"
      },
      {
        "id": "AC-03",
        "text": "Понимаю связку «static testing → shift-left → ×100 cost saving» и могу объяснить эту экономику на собесе"
      },
      {
        "id": "AC-04",
        "text": "Прошёл (прошла) карусель «Static или Dynamic?» — 6 активностей"
      }
    ],
    "istqb": [
      "CTFL-Ch3"
    ],
    "skills": [
      "static-testing",
      "requirements-analysis"
    ],
    "quickCheck": {
      "id": "QC-REQ-11",
      "prompt": "Quick check",
      "question": "Команда QA выполняет 4 активности перед релизом. Какая из них относится к <em>Static Testing</em> по ISTQB Ch.3?",
      "options": [
        {
          "id": "a",
          "text": "Прогон 50 регрессионных тест-кейсов в TestRail на staging-окружении"
        },
        {
          "id": "b",
          "text": "Walkthrough новой User Story «Promo Code Apply» с PM на груминге, 30 минут разбора по чек-листу"
        },
        {
          "id": "c",
          "text": "Exploratory-сессия 60 минут на тестовом стенде по charter «модал Place Order»"
        },
        {
          "id": "d",
          "text": "Запуск Lighthouse audit на production-странице каталога для измерения FCP &lt; 1.5s"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: Walkthrough новой User Story.</strong> Static Testing — категория, в которой <em>код не запускается</em>: ты ревьюишь артефакт (User Story, дизайн, требования, код глазами) на ошибки, противоречия, неполноту. Walkthrough — одна из 4 формальных форм review (детали в REQ-12). Остальные 3 опции — <strong>Dynamic Testing</strong>: <em>прогон тест-кейсов</em> запускает код с входными данными; <em>exploratory сессия</em> — это запуск приложения и наблюдение фактического поведения; <em>Lighthouse audit</em> — запуск headless-браузера с замером метрик. На собесе вопрос «дайте пример static vs dynamic из вашей работы» — типовой; правильный пример static = «code review PR + walkthrough requirements», dynamic = «прогон smoke-tests на release candidate»."
    }
  },
  {
    "id": "REQ-12",
    "sprintId": "S02",
    "ord": 12,
    "type": "docs",
    "priority": "P1",
    "title": "Ревью на практике: от беглого взгляда до инспекции",
    "estimateMin": 14,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю 4 формы review (informal / walkthrough / technical / inspection) и их различия по формальности"
      },
      {
        "id": "AC-02",
        "text": "Помню 5 ролей в formal review (Author / Moderator / Reviewer / Scribe / Manager) и кто за что отвечает"
      },
      {
        "id": "AC-03",
        "text": "Могу определить, какая форма review подходит для конкретной ситуации (informal в чате vs walkthrough автором vs inspection формальная)"
      },
      {
        "id": "AC-04",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ"
      }
    ],
    "istqb": [
      "CTFL-Ch3"
    ],
    "skills": [
      "static-testing"
    ],
    "quickCheck": {
      "id": "QC-REQ-12",
      "prompt": "Quick check",
      "question": "Когда команде хватит беглого ревью, а когда нужна инспекция?",
      "options": [
        {
          "id": "a",
          "text": "Инспекция всегда лучше — чем формальнее, тем качественнее"
        },
        {
          "id": "b",
          "text": "Форма ревью подбирается под цену ошибки: беглое — для заметки в вики, инспекция — для платёжного модуля"
        },
        {
          "id": "c",
          "text": "Беглого чтения достаточно всегда, если читает senior"
        }
      ],
      "answer": "b",
      "explanation": "Ревью стоит времени команды, а время — деньги. Искусство не в максимальной строгости, а в том, чтобы строгость соответствовала риску. Заметку читают глазами; требования к оплате — по чек-листу и с протоколом."
    }
  },
  {
    "id": "REQ-14",
    "sprintId": "S02",
    "ord": 13,
    "type": "master",
    "priority": "P0",
    "title": "Миссия · Напиши критерии для фичи Артели",
    "estimateMin": 22,
    "ac": [
      {
        "id": "AC-01",
        "text": "Превращаю короткое требование в набор критериев приёмки по Given / When / Then"
      },
      {
        "id": "AC-02",
        "text": "Закрываю критериями не только основной сценарий, но и край (гость) и состояние (между визитами)"
      },
      {
        "id": "AC-03",
        "text": "Прогоняю свои критерии через самопроверку: проверяемость, «а что если», однозначность"
      },
      {
        "id": "AC-04",
        "text": "Сохраняю набор AC как первый артефакт своего портфолио"
      }
    ],
    "istqb": [
      "CTFL-Ch1"
    ],
    "skills": [
      "requirements-analysis",
      "documentation-practice"
    ]
  },
  {
    "id": "DOC-S3-00A",
    "sprintId": "S03",
    "ord": 1,
    "type": "docs",
    "priority": "P1",
    "title": "SDLC · полный цикл с возвратом",
    "estimateMin": 10,
    "ac": [
      {
        "id": "AC-01",
        "text": "Собран цикл из 6 фаз в тренажёре"
      },
      {
        "id": "AC-02",
        "text": "Раскрыто хотя бы 4 фазы из шести"
      },
      {
        "id": "AC-03",
        "text": "Понимаю, почему SDLC — это цикл, а не прямая"
      },
      {
        "id": "AC-04",
        "text": "Знаю, что Maintenance — самая длинная фаза"
      }
    ],
    "istqb": [
      "CTFL-Ch2"
    ],
    "skills": [
      "qa-concepts",
      "documentation"
    ],
    "quickCheck": {
      "id": "QC-S3-00A",
      "prompt": "Quick check",
      "question": "В какой фазе SDLC продукт проводит бОльшую часть своей жизни?",
      "options": [
        {
          "id": "a",
          "text": "Requirements — самая важная фаза"
        },
        {
          "id": "b",
          "text": "Development — кодим основную часть"
        },
        {
          "id": "c",
          "text": "Testing — много времени на проверки"
        },
        {
          "id": "d",
          "text": "Maintenance — поддержка после релиза"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Maintenance</strong> — самая длинная фаза. Это значит: основная часть твоей карьеры в QA — не «новые фичи», а поддержка живых продуктов: исправления багов, патчи безопасности, мониторинг production-багов."
    }
  },
  {
    "id": "DOC-S3-00B",
    "sprintId": "S03",
    "ord": 2,
    "type": "docs",
    "priority": "P1",
    "title": "4 модели разработки · Waterfall, Iterative, V-Model, Spiral",
    "estimateMin": 15,
    "ac": [
      {
        "id": "AC-01",
        "text": "Могу назвать 4 модели SDLC и одно отличие между ними"
      },
      {
        "id": "AC-02",
        "text": "Понимаю, почему Waterfall плохо терпит изменения"
      },
      {
        "id": "AC-03",
        "text": "Раскрыта хотя бы одна панель (когда работает Waterfall / traceability V-Model)"
      },
      {
        "id": "AC-04",
        "text": "Понимаю разницу между Iterative и Agile"
      },
      {
        "id": "AC-05",
        "text": "Пройдена карусель «Опознай модель» — 6 команд"
      }
    ],
    "istqb": [
      "CTFL-Ch2"
    ],
    "skills": [
      "qa-concepts",
      "documentation"
    ],
    "quickCheck": {
      "id": "QC-S3-00B",
      "prompt": "Quick check",
      "question": "Команда фиксирует все требования в начале, проходит этапы Design → Dev → Test, выкатывается клиенту через 9 месяцев. Какая модель разработки?",
      "options": [
        {
          "id": "a",
          "text": "Iterative"
        },
        {
          "id": "b",
          "text": "Waterfall"
        },
        {
          "id": "c",
          "text": "Scrum (Agile)"
        },
        {
          "id": "d",
          "text": "V-Model"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Waterfall</strong> — каскад: один длинный проход без возврата к предыдущему этапу. Работает в hardware, госзаказе, регулируемых индустриях. Главный недостаток — нельзя адаптироваться к изменениям требований."
    }
  },
  {
    "id": "DOC-S3-01",
    "sprintId": "S03",
    "ord": 3,
    "type": "docs",
    "priority": "P0",
    "title": "Уровни тестирования — кто и что проверяет",
    "estimateMin": 14,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю 5 уровней тестирования (Component / Component Integration / System / System Integration / Acceptance) и могу для каждого назвать «кто» и «что»."
      },
      {
        "id": "AC-02",
        "text": "Помню метафору Test Pyramid и могу объяснить, почему юнит-тестов должно быть больше всего."
      },
      {
        "id": "AC-03",
        "text": "Знаю минимум 4 формы Acceptance Testing (UAT / OAT / Alpha / Beta) и для чего они нужны."
      },
      {
        "id": "AC-04",
        "text": "Могу провести один баг через 5 уровней и объяснить, как растёт стоимость его исправления."
      },
      {
        "id": "AC-05",
        "text": "Распознаю anti-pattern «перевёрнутая пирамида» и понимаю, какие у него симптомы в проде."
      },
      {
        "id": "AC-06",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ."
      }
    ],
    "istqb": [
      "CTFL-Ch2"
    ],
    "skills": [
      "test-types"
    ],
    "quickCheck": {
      "id": "QC-DOC-S3-01",
      "prompt": "Quick check",
      "question": "Команда пишет юнит-тесты для класса <code>OrderCalculator</code>, изолируя его от БД и других модулей через моки. На каком уровне тестирования она работает?",
      "options": [
        {
          "id": "a",
          "text": "Component (Unit)"
        },
        {
          "id": "b",
          "text": "Component Integration"
        },
        {
          "id": "c",
          "text": "System"
        },
        {
          "id": "d",
          "text": "Acceptance"
        }
      ],
      "answer": "a",
      "explanation": "<strong>Правильно: Component (Unit).</strong> Тестируется один класс отдельно от остальных — это <em>Component (Unit) testing</em>. По ISTQB его обычно пишут разработчики. <strong>Component Integration</strong> — когда проверяется связка двух или более модулей вместе, например <code>OrderCalculator</code> работает с реальным <code>PricingEngine</code>. <strong>System</strong> — полная система через UI или API. <strong>Acceptance</strong> — приёмка по бизнес-требованиям, которую делает PO или заказчик."
    }
  },
  {
    "id": "DOC-S3-02",
    "sprintId": "S03",
    "ord": 4,
    "type": "docs",
    "priority": "P0",
    "title": "Функциональное и нефункциональное — что система делает и как она это делает",
    "estimateMin": 14,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю Functional Testing (что система делает) и Non-functional Testing (как она это делает) и могу привести 2 примера каждого."
      },
      {
        "id": "AC-02",
        "text": "Знаю 8 quality characteristics ISO/IEC 25010 (Functional Suitability, Performance Efficiency, Compatibility, Usability, Reliability, Security, Maintainability, Portability) и могу для каждой назвать тип теста."
      },
      {
        "id": "AC-03",
        "text": "Могу для одной фичи (например, Sign Up) сформулировать минимум 4 разных не-functional теста по разным категориям ISO 25010."
      },
      {
        "id": "AC-04",
        "text": "Понимаю, что «functional работает» ≠ «готово к релизу» — и знаю минимальный non-functional чек-лист для DoD."
      },
      {
        "id": "AC-05",
        "text": "Помню типичное распределение времени QA: ~70% functional + ~30% non-functional на средней фиче, со сдвигами по критичности."
      },
      {
        "id": "AC-06",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ."
      }
    ],
    "istqb": [
      "CTFL-Ch2"
    ],
    "skills": [
      "test-types"
    ],
    "quickCheck": {
      "id": "QC-DOC-S3-02",
      "prompt": "Quick check",
      "question": "Тест проверяет, что страница каталога загружается за &lt; 2 секунд при 1 000 одновременных пользователях. К какому типу тестирования он относится?",
      "options": [
        {
          "id": "a",
          "text": "Functional Testing"
        },
        {
          "id": "b",
          "text": "Non-functional Testing (Performance + Load)"
        },
        {
          "id": "c",
          "text": "Component (Unit) Testing"
        },
        {
          "id": "d",
          "text": "Acceptance Testing"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: Non-functional Testing (Performance + Load).</strong> Тест проверяет не «что система делает» (functional), а «как хорошо она это делает» — скорость + поведение под нагрузкой. По ISO 25010 это категория Performance Efficiency. <strong>Functional</strong> — про корректность поведения («товар добавился в корзину»). <strong>Component (Unit)</strong> и <strong>Acceptance</strong> — это <em>уровни</em> тестирования из T01, а не типы. Тест на performance под нагрузкой обычно гоняется на System level — но это другая ось таксономии. Запомни: уровни (где?), типы (что?) и подходы (как?) — три отдельные оси."
    }
  },
  {
    "id": "DOC-S3-02B",
    "sprintId": "S03",
    "ord": 5,
    "type": "practice",
    "priority": "P1",
    "title": "Практика · Разложи фичу на functional и non-functional",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Беру живую фичу и отделяю functional-проверки (что система делает) от non-functional (как хорошо делает)."
      },
      {
        "id": "AC-02",
        "text": "Для фичи «Вход (Login)» расписал(а) минимум по 2 проверки на 4 типа: Functional, Performance, Security, Accessibility."
      },
      {
        "id": "AC-03",
        "text": "Для фичи «Загрузка аватара» нашёл(шла) минимум 3 non-functional дыры, которые легко пропустить."
      },
      {
        "id": "AC-04",
        "text": "Закрепил(а) рефлекс «5 вопросов non-functional» (быстро · под нагрузкой · безопасно · удобно · доступно и везде) после каждой functional-проверки."
      },
      {
        "id": "AC-05",
        "text": "Прошёл (прошла) разминку-карусель «Functional или Non-functional?» — 6 проверок."
      },
      {
        "id": "AC-06",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ."
      }
    ],
    "istqb": [
      "CTFL-Ch2"
    ],
    "skills": [
      "test-types",
      "non-functional-testing"
    ],
    "quickCheck": {
      "id": "QC-DOC-S3-02B",
      "prompt": "Quick check",
      "question": "Ты проверяешь форму входа. Проверка «после 5 неверных попыток вход блокируется на минуту» — к какому типу относится?",
      "options": [
        {
          "id": "a",
          "text": "Functional — проверяет, что вход работает"
        },
        {
          "id": "b",
          "text": "Non-functional (Security) — защита от подбора пароля"
        },
        {
          "id": "c",
          "text": "Acceptance — приёмка бизнесом"
        },
        {
          "id": "d",
          "text": "Это вообще не тестирование"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: Non-functional (Security).</strong> Сам вход «работает / не работает» — это functional. А «защита от перебора паролей» — про то, насколько <em>безопасно</em> система делает свою работу, то есть non-functional, категория Security. <strong>Acceptance</strong> — это уровень тестирования (приёмка), а не тип. Запомни разрез: functional = «что делает», non-functional = «как хорошо делает»."
    }
  },
  {
    "id": "DOC-S3-03",
    "sprintId": "S03",
    "ord": 6,
    "type": "docs",
    "priority": "P1",
    "title": "Black / White / Gray-box — что видит QA при разном уровне доступа",
    "estimateMin": 12,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю White / Black / Gray-box подходы и могу для каждого назвать «кто», «что видит» и «на каком уровне работает»."
      },
      {
        "id": "AC-02",
        "text": "Знаю 3 уровня покрытия White-box (Statement / Branch / Path) и понимаю, почему 100% statement не равно 100% branch."
      },
      {
        "id": "AC-03",
        "text": "Помню 5 базовых Black-box техник тест-дизайна (EP / BVA / Decision Table / State Transition / Pairwise) — без деталей, как обзор перед Sprint 05."
      },
      {
        "id": "AC-04",
        "text": "Могу взять Black-box тест и расширить его до Gray-box, добавив 2-3 verifying-проверки (БД / Network / логи)."
      },
      {
        "id": "AC-05",
        "text": "Понимаю ловушку «читаю код = тестирую» и знаю правильный порядок: сначала сценарий, потом gray-box-верификация."
      },
      {
        "id": "AC-06",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ."
      }
    ],
    "istqb": [
      "CTFL-Ch2"
    ],
    "skills": [
      "test-types"
    ],
    "quickCheck": {
      "id": "QC-DOC-S3-03",
      "prompt": "Quick check",
      "question": "QA-инженер пишет тесты, читая исходный код функции и проверяя, что каждая ветка <code>if/else</code> пройдена хотя бы одним тестом. Какой подход он использует?",
      "options": [
        {
          "id": "a",
          "text": "Black-box"
        },
        {
          "id": "b",
          "text": "Gray-box"
        },
        {
          "id": "c",
          "text": "White-box"
        },
        {
          "id": "d",
          "text": "Это не тестирование, это code review"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: White-box.</strong> White-box — подход, при котором тестировщик видит исходный код и тестирует внутреннюю логику. «Каждая ветка if/else пройдена» — это <em>branch coverage</em>, классическая White-box-метрика. <strong>Black-box</strong> — без кода, только вход/выход. <strong>Gray-box</strong> — без чтения кода, но со знанием архитектуры (БД, API). <strong>Code review</strong> — это static testing review (Sprint 02, T07), отдельная категория. На собесе путают White-box и code review — White-box запускает код с проверкой покрытия, code review просто читает код глазами."
    }
  },
  {
    "id": "DOC-S3-04",
    "sprintId": "S03",
    "ord": 7,
    "type": "docs",
    "priority": "P0",
    "title": "Confirmation / Regression / Maintenance — тестирование изменений",
    "estimateMin": 14,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю Confirmation testing (re-test) и Regression testing — могу для каждого назвать цель и scope."
      },
      {
        "id": "AC-02",
        "text": "Знаю разницу между smoke (broad post-deploy) и sanity (narrow post-fix) и понимаю, что это industry shorthand, а не ISTQB-категории."
      },
      {
        "id": "AC-03",
        "text": "Помню 3 триггера Maintenance Testing (modification / migration / retirement) и могу для каждого привести пример."
      },
      {
        "id": "AC-04",
        "text": "Понимаю принцип impact analysis и могу для конкретного изменения предложить ограниченный scope регрессии вместо «прогоняем всё»."
      },
      {
        "id": "AC-05",
        "text": "Распознаю ловушку «маленькое изменение = маленький impact» и знаю, какие зоны кода требуют обязательной регрессии независимо от размера диффа."
      },
      {
        "id": "AC-06",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ."
      }
    ],
    "istqb": [
      "CTFL-Ch2"
    ],
    "skills": [
      "test-types"
    ],
    "quickCheck": {
      "id": "QC-DOC-S3-04",
      "prompt": "Quick check",
      "question": "Разработчик пофиксил баг BUG-123 «корзина не обновляется после добавления товара». QA повторяет точно те шаги из bug report'а — баг больше не воспроизводится. Какой тип тестирования был выполнен?",
      "options": [
        {
          "id": "a",
          "text": "Regression testing"
        },
        {
          "id": "b",
          "text": "Confirmation testing (re-test)"
        },
        {
          "id": "c",
          "text": "Smoke testing"
        },
        {
          "id": "d",
          "text": "Maintenance testing"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: Confirmation testing (re-test).</strong> Повторение <em>точных шагов</em> из bug report'а после фикса, чтобы доказать, что конкретный баг ушёл — это classic Confirmation. <strong>Regression</strong> — это широкая проверка вокруг фикса (что не сломалось ничего другого); часто Confirmation+Regression делают вместе после bug fix. <strong>Smoke</strong> — широкая поверхностная проверка после деплоя, не привязана к конкретному багу. <strong>Maintenance</strong> — тестирование уже работающей в проде системы при изменениях. На собесе путают Confirmation и Regression — это классический trap."
    }
  },
  {
    "id": "DOC-S3-04B",
    "sprintId": "S03",
    "ord": 8,
    "type": "practice",
    "priority": "P0",
    "title": "Практика · Что перепроверять после изменения",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Прошёл (прошла) карусель «Какое это решение?» — 6 ситуаций на Confirmation / Regression / Smoke / Sanity."
      },
      {
        "id": "AC-02",
        "text": "Для конкретного изменения провёл(а) impact analysis письменно: что регрессить и что НЕ трогать, с обоснованием — и сверил(ась) с образцом."
      },
      {
        "id": "AC-03",
        "text": "Различаю smoke (широко-поверхностно) и sanity (узко-глубоко) и выбираю нужное под ситуацию."
      },
      {
        "id": "AC-04",
        "text": "Понимаю правило «размер правки в коде ≠ размер последствий» — изменения в общем коде (оплата, авторизация) требуют регрессии даже на «мелочи»."
      },
      {
        "id": "AC-05",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ."
      }
    ],
    "istqb": [
      "CTFL-Ch2"
    ],
    "skills": [
      "test-types"
    ],
    "quickCheck": {
      "id": "QC-DOC-S3-04B",
      "prompt": "Quick check",
      "question": "Команда поменяла текст одной кнопки в шапке сайта. Junior говорит: «правка крошечная, регрессию можно не гонять». В чём ошибка рассуждения?",
      "options": [
        {
          "id": "a",
          "text": "Ошибки нет — мелкая правка не требует регрессии"
        },
        {
          "id": "b",
          "text": "Размер правки в коде не равен размеру последствий — кнопка может использоваться в нескольких местах"
        },
        {
          "id": "c",
          "text": "Любую правку нужно регрессировать полным набором из сотен тестов"
        },
        {
          "id": "d",
          "text": "Регрессию вообще не делают для текста"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: размер правки ≠ размер последствий.</strong> «Крошечное» изменение может задеть много мест (та же кнопка/компонент используется на разных страницах). Нужен impact analysis: что реально могло пострадать. <strong>Вариант «полный набор из сотен тестов»</strong> — другая крайность: гонять всё подряд дорого и обычно не нужно. Золотая середина — регрессировать то, что рядом с изменением и что использует общий код."
    }
  },
  {
    "id": "DOC-S3-05",
    "sprintId": "S03",
    "ord": 9,
    "type": "docs",
    "priority": "P1",
    "title": "Exploratory Testing — структурированное исследование без сценария",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю Scripted и Exploratory testing — могу для каждого назвать когда применять."
      },
      {
        "id": "AC-02",
        "text": "Знаю 3 шага SBTM (PRE / DURING / POST) и могу для каждого назвать артефакт."
      },
      {
        "id": "AC-03",
        "text": "Помню формат Чартер (mission / areas / duration / focus) и могу написать чартер для конкретной фичи в 5-7 строк."
      },
      {
        "id": "AC-04",
        "text": "Знаю минимум 2 эвристики из 4 (CRUD / SFDIPOT / «жестокие» сценарии / FEW-HICCUPPS) и могу применить их в сессии."
      },
      {
        "id": "AC-05",
        "text": "Понимаю метрику Bug/Session Ratio и могу оценить, окупается ли exploratory на проекте."
      },
      {
        "id": "AC-06",
        "text": "Распознаю anti-pattern «100% exploratory» и понимаю правильное распределение между scripted и exploratory."
      },
      {
        "id": "AC-07",
        "text": "Провёл (провела) мини-сессию «Проба сессии»: все 5 вердиктов по чартеру, 3 бага найдены."
      },
      {
        "id": "AC-08",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ."
      }
    ],
    "istqb": [
      "CTFL-Ch2"
    ],
    "skills": [
      "test-types",
      "exploratory-testing"
    ],
    "quickCheck": {
      "id": "QC-DOC-S3-05",
      "prompt": "Quick check",
      "question": "Junior начинает exploratory-сессию: открывает фичу и «начинает кликать что-то и смотреть, что произойдёт». Через 90 минут отчётов нет, баги отмечены в чате-Slack-разговоре. Что нарушено по SBTM?",
      "options": [
        {
          "id": "a",
          "text": "Только Чартер (цели сессии не было)"
        },
        {
          "id": "b",
          "text": "Только Time-box (90 минут — слишком долго)"
        },
        {
          "id": "c",
          "text": "Только Session Report (баги не оформлены структурно)"
        },
        {
          "id": "d",
          "text": "И Чартер, и Session Report — оба нарушены"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: И Чартер, и Session Report — оба нарушены.</strong> SBTM требует трёх обязательных элементов: Чартер (цель сессии — у нашего junior'а отсутствует), Time-box (60-90 минут — рекомендация SBTM, 90 минут <em>в норме</em>), Session Report (структурированный отчёт — отсутствует, баги в Slack-чате не считаются). Без Чартер сессия превращается в бессистемное тыкание; без Report находки теряются. Time-box — единственный элемент, выполненный правильно. Часто junior думает «90 минут — это слишком», но это верхняя граница нормы."
    }
  },
  {
    "id": "DOC-S3-06",
    "sprintId": "S03",
    "ord": 10,
    "type": "docs",
    "priority": "P1",
    "title": "Атрибуты качества: удобство, доступность, совместимость",
    "estimateMin": 17,
    "ac": [
      {
        "id": "AC-01",
        "text": "В двух словах различаю три темы: удобство (Usability), доступность (a11y), совместимость (Compatibility) — и могу для каждой привести один пример проблемы."
      },
      {
        "id": "AC-02",
        "text": "Знаю 4 категории особых потребностей (зрение / моторика / слух / когнитивные) и для каждой — минимум один типичный a11y-баг."
      },
      {
        "id": "AC-03",
        "text": "Помню, что у WCAG три уровня (A / AA / AAA) и что junior целится на AA."
      },
      {
        "id": "AC-04",
        "text": "Могу провести 5-минутный a11y-чек-лист (клавиатура / Lighthouse / Zoom 200%) на любой фиче."
      },
      {
        "id": "AC-05",
        "text": "Знаю два главных среза совместимости для junior — по браузерам и по устройствам — и чем их быстро проверить."
      },
      {
        "id": "AC-06",
        "text": "Понимаю, что доступность — это не «косметика», а часто и юридическое требование (EAA в EU, ADA в US)."
      },
      {
        "id": "AC-07",
        "text": "Прошёл (прошла) карусель «Какой атрибут страдает?» — 6 жалоб пользователей."
      },
      {
        "id": "AC-08",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ."
      }
    ],
    "istqb": [
      "CTFL-Ch2"
    ],
    "skills": [
      "test-types",
      "non-functional-testing"
    ],
    "quickCheck": {
      "id": "QC-DOC-S3-06",
      "prompt": "Quick check",
      "question": "Юзер с тремором рук жалуется: «Не могу нажать кнопку «Купить» на iPhone — слишком маленькая, попадаю мимо». Какой quality attribute и какой стандарт это покрывает?",
      "options": [
        {
          "id": "a",
          "text": "Usability — критерий Efficiency по Нильсену"
        },
        {
          "id": "b",
          "text": "Accessibility — WCAG 2.1 (требование touch-targets ≥ 44×44px)"
        },
        {
          "id": "c",
          "text": "Compatibility — cross-device (iOS Safari)"
        },
        {
          "id": "d",
          "text": "Performance — touch latency"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: Accessibility (WCAG 2.1).</strong> Это accessibility-проблема — пользователь с моторными нарушениями не может попасть пальцем по кнопке. WCAG 2.1 рекомендует размер touch-target ≥ 44×44 пикселей именно для таких случаев. <strong>Usability</strong> — про удобство для среднего пользователя без особенностей. <strong>Compatibility</strong> — про работу в разных средах (iOS Safari технически работает, кнопка отображается). <strong>Performance</strong> — про скорость отклика, а не размер элементов. Accessibility и usability пересекаются, но это разные категории — у accessibility есть юридическая сторона (ADA в США, EAA в EU с июня 2025)."
    }
  },
  {
    "id": "DOC-S3-06B",
    "sprintId": "S03",
    "ord": 11,
    "type": "docs",
    "priority": "P3",
    "title": "Бонус · Глубже: уровни WCAG, совместимость, матрица",
    "estimateMin": 12,
    "ac": [
      {
        "id": "AC-01",
        "text": "(бонус) Понимаю различие уровней WCAG A / AA / AAA и почему рабочий ориентир — AA."
      },
      {
        "id": "AC-02",
        "text": "(бонус) Знаю ещё два среза совместимости — по операционным системам и по разрешениям экрана."
      },
      {
        "id": "AC-03",
        "text": "(бонус) Могу прочитать и составить Compatibility Matrix (таблица «функция × среда») с pass / fail / known-issue."
      }
    ],
    "istqb": [
      "CTFL-Ch2"
    ],
    "skills": [
      "test-types",
      "non-functional-testing"
    ]
  },
  {
    "id": "DOC-S3-07",
    "sprintId": "S03",
    "ord": 12,
    "type": "docs",
    "priority": "P1",
    "title": "Risk-Based Testing — приоритизация по риску",
    "estimateMin": 16,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю Product Risk и Project Risk — могу для каждого назвать пример и сказать, чья это зона ответственности."
      },
      {
        "id": "AC-02",
        "text": "Помню матрицу 2×2 (вероятность × impact) и 4 категории (CRITICAL / IMPORTANT / MODERATE / LOW) с типичной стратегией для каждой."
      },
      {
        "id": "AC-03",
        "text": "Знаю 4 шага процесса RBT (Identify → Assess → Prioritize → Allocate) и могу провести этот процесс на 5-10 фичах."
      },
      {
        "id": "AC-04",
        "text": "Могу взять список из 5+ фич спринта и разложить их по матрице, обосновав выбор для каждой."
      },
      {
        "id": "AC-05",
        "text": "Понимаю типичное распределение времени QA по приоритетам (~60% CRITICAL / ~25% IMPORTANT-MODERATE / ~15% LOW) и могу назвать его на собесе."
      },
      {
        "id": "AC-06",
        "text": "Распознаю anti-pattern «лёгкие фичи первыми» и понимаю, почему критичное должно быть протестировано первым."
      },
      {
        "id": "AC-07",
        "text": "Откалибровал(а) 4 фичи по осям Вероятность × Импакт, включая обе контр-интуитивные ловушки."
      },
      {
        "id": "AC-08",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ."
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "test-types",
      "risk-based-testing"
    ],
    "quickCheck": {
      "id": "QC-DOC-S3-07",
      "prompt": "Quick check",
      "question": "В спринте 20 фич, до релиза 3 дня. Среди ещё непротестированных 8 фич — оплата через Apple Pay (новая интеграция, влияет на доход) и обновление текста на странице FAQ. Какой план тестирования QA должен предложить тимлиду?",
      "options": [
        {
          "id": "a",
          "text": "Тестировать в порядке поступления тикетов"
        },
        {
          "id": "b",
          "text": "Apple Pay — полное покрытие (functional + security + performance), FAQ — smoke"
        },
        {
          "id": "c",
          "text": "Пропустить оба, отметить «не покрыто» в Test Report"
        },
        {
          "id": "d",
          "text": "Тестировать только FAQ — быстрее закроем тикет"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: Apple Pay глубоко + FAQ smoke.</strong> По матрице Risk-Based Testing: Apple Pay = CRITICAL (новая интеграция × влияние на доход) — нужно полное покрытие. FAQ = LOW (статичный контент, низкий риск) — достаточно smoke-проверки. <strong>Опция 1</strong> «в порядке поступления» не учитывает приоритет рисков — можно не успеть до критичного. <strong>Опция 3</strong> «пропустить оба» — Apple Pay уйдёт в прод без проверки, а это деньги. <strong>Опция 4</strong> «только FAQ» закроет тикет быстрее, но критичная фича останется без покрытия. Правило Risk-Based Testing: сначала CRITICAL, потом по убыванию."
    }
  },
  {
    "id": "DOC-S3-08",
    "sprintId": "S03",
    "ord": 14,
    "type": "ai",
    "priority": "P1",
    "title": "AI в этом спринте — генератор тест-идей и cross-browser сценариев",
    "estimateMin": 12,
    "ac": [
      {
        "id": "AC-01",
        "text": "Запомнил(а) 3 шаблона промптов: test ideas по 5 типам · cross-browser scenarios · risk-areas analysis."
      },
      {
        "id": "AC-02",
        "text": "Прогнал(а) Промпт 1 на любой User Story (можно взять пример из тикета) и записал(а) 3 идеи в журнал."
      },
      {
        "id": "AC-03",
        "text": "Понимаю, что AI генерит гипотезы, а не истины — бизнес-специфику сверяю с PM/PRD."
      },
      {
        "id": "AC-04",
        "text": "Никогда не передаю test plan от AI «как есть» — всегда правлю под реальный продукт."
      },
      {
        "id": "AC-05",
        "text": "Знаю чек-лист из 6 триггеров «когда обязательно перепроверить вывод AI у PM»."
      },
      {
        "id": "AC-06",
        "text": "Знаю, на каких темах AI можно доверять с минимальной коррекцией (browser quirks, UX-эвристики, формальные процессы)."
      }
    ],
    "istqb": [
      "CTFL-Ch2"
    ],
    "skills": [
      "ai-workflow",
      "test-types"
    ]
  },
  {
    "id": "DOC-S3-09",
    "sprintId": "S03",
    "ord": 15,
    "type": "master",
    "priority": "P0",
    "title": "Миссия · Проведи Exploratory-сессию (60 минут по чартеру)",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Чартер записан до старта сессии в формате Mission / Areas / Duration / Focus."
      },
      {
        "id": "AC-02",
        "text": "Зафиксировал(а) наблюдения по результатам сессии — это могут быть баги, OK-проверки или открытые вопросы."
      },
      {
        "id": "AC-03",
        "text": "Применил(а) одну или несколько эвристик из T05 и отметил(а), какая помогла найти что."
      },
      {
        "id": "AC-04",
        "text": "Сравнил(а) свои наблюдения с output AI (Промпт 1 из T08) и записал(а), что AI заметил, а ты — нет (и наоборот)."
      },
      {
        "id": "AC-05",
        "text": "Ответил(а) на 3 рефлексионных вопроса в журнал (пропущенное наблюдение / слабый тип / Чартер продолжения)."
      }
    ],
    "istqb": [
      "CTFL-Ch4",
      "CTFL-Ch5"
    ],
    "skills": [
      "test-types",
      "exploratory-testing",
      "documentation-practice"
    ]
  },
  {
    "id": "DOC-S3-15",
    "sprintId": "S03",
    "ord": 13,
    "type": "docs",
    "priority": "P1",
    "title": "Синтез спринта — пирамида и трофей",
    "estimateMin": 14,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю Test Pyramid и Testing Trophy и понимаю разницу между ними."
      },
      {
        "id": "AC-02",
        "text": "Могу выбрать модель под контекст продукта (backend / frontend / microservices)."
      },
      {
        "id": "AC-03",
        "text": "Распознаю anti-pattern Ice Cream Cone (перевёрнутая пирамида) по описанию симптомов."
      },
      {
        "id": "AC-04",
        "text": "Понимаю связку: типы тестирования (S03) дают карту «что тестировать», техники тест-дизайна (S05) — «как выбрать минимум тестов»."
      },
      {
        "id": "AC-05",
        "text": "Прошёл (прошла) разминку-карусель «Какая модель / какой anti-pattern?» — 5 ситуаций."
      },
      {
        "id": "AC-06",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ."
      }
    ],
    "istqb": [
      "CTFL-Ch2"
    ],
    "skills": [
      "test-types"
    ],
    "quickCheck": {
      "id": "QC-DOC-S3-15",
      "prompt": "Quick check",
      "question": "Frontend-команда на React: 500 E2E на Selenium, 100 юнит-тестов на компоненты, 0 integration. Деплои в пятницу — кошмар, 30% E2E постоянно падают. Какой anti-pattern?",
      "options": [
        {
          "id": "a",
          "text": "Test Pyramid — правильная классическая модель"
        },
        {
          "id": "b",
          "text": "Testing Trophy — модель для frontend"
        },
        {
          "id": "c",
          "text": "Ice Cream Cone (перевёрнутая пирамида)"
        },
        {
          "id": "d",
          "text": "Test Diamond — integration-heavy"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: Ice Cream Cone.</strong> Признаки — много E2E (500), мало unit (100), ноль integration. Это перевёрнутая пирамида, классический anti-pattern. Симптомы (флакающие E2E, кошмарные деплои) типичны. <strong>Trophy</strong> для frontend имеет широкий integration-слой — а его у этой команды НЕТ. <strong>Diamond</strong> — тоже integration-heavy. Реакция QA: предложить постепенный сдвиг к Trophy (integration &gt; unit &gt; E2E для React)."
    }
  },
  {
    "id": "TD-01",
    "sprintId": "S04",
    "ord": 1,
    "type": "docs",
    "priority": "P0",
    "title": "Тест-документация — пирамида артефактов",
    "estimateMin": 12,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю 6 основных артефактов тест-документации (Test Plan / Test Scenario / Test Case / Test Suite / Bug Report / Checklist) и могу для каждого назвать «что внутри», «кто пишет», «уровень детализации»"
      },
      {
        "id": "AC-02",
        "text": "Понимаю пирамиду документации: сверху Test Plan (стратегия на релиз), внизу Bug Report (находки по факту); умею для одной User Story показать декомпозицию через все 6 уровней"
      },
      {
        "id": "AC-03",
        "text": "Помню 3 типичные ошибки уровня детализации (Scenario с шагами / Case без шагов / BR без воспроизводимости) и понимаю, как их избегать"
      },
      {
        "id": "AC-04",
        "text": "На собесе на вопрос «какие артефакты тест-документации знаете?» отвечаю через пирамиду + уровни + кто что пишет"
      },
      {
        "id": "AC-05",
        "text": "Понимаю аргумент про «документация ≠ бюрократия» — это инвестиция в память команды"
      },
      {
        "id": "AC-06",
        "text": "Раскрыто и подтверждено в Quick check"
      }
    ],
    "istqb": [
      "CTFL-Ch4",
      "CTFL-Ch5"
    ],
    "skills": [
      "test-documentation"
    ],
    "quickCheck": {
      "id": "QC-TD-01",
      "prompt": "Quick check",
      "question": "PM просит QA «составить Test Scenario для новой фичи поиска». Junior пишет документ на 2 страницы: 8 атомарных шагов с ожидаемыми результатами для каждого, тестовые данные, postcondition. Что не так?",
      "options": [
        {
          "id": "a",
          "text": "Всё правильно — Test Scenario должен быть детальным"
        },
        {
          "id": "b",
          "text": "Junior смешал уровни: то, что он написал, это Test Case (детальная инструкция с шагами), а Test Scenario — высокоуровневое описание ЧТО тестировать в 1-2 строки без шагов"
        },
        {
          "id": "c",
          "text": "Документ слишком короткий — нужно добавить Test Plan и Bug Report"
        },
        {
          "id": "d",
          "text": "Test Scenario вообще не нужен — достаточно Test Case"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: junior смешал уровни.</strong> Test Scenario — это <em>высокоуровневое</em> описание (1-2 строки, формат «Verify [что] for [контекст]»), без шагов. Шаги, тестовые данные, expected result — это атрибуты <strong>Test Case</strong>, который находится на следующем уровне детализации в пирамиде. То, что junior написал — это полноценный TC, который ошибочно назвал Scenario. Правильно было бы либо переименовать в Test Case, либо написать настоящий TS «Verify search returns matching products by keyword» (одна строка) и отдельно ниже — детальные TC. <strong>Опция 1</strong> неверна — детализация противоположна определению Scenario. <strong>Опция 3</strong> мешает уровни. <strong>Опция 4</strong> неверна — Scenario нужен как мост между AC и TC, особенно когда из одного AC выходит 5-10 TC и нужен промежуточный «зонт». На собесе путаница уровней — типичный провал junior'а."
    }
  },
  {
    "id": "TD-02",
    "sprintId": "S04",
    "ord": 2,
    "type": "docs",
    "priority": "P0",
    "title": "Сценарий тестирования (Test Scenario) — высокоуровневое «что тестируем»",
    "estimateMin": 14,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю 8 полей Test Scenario template (ID / Title / Description / Modules / Test Cases / Preconditions / Expected Outcome / Notes) и могу заполнить каждое для конкретной фичи"
      },
      {
        "id": "AC-02",
        "text": "Понимаю правило 5-15 TC на Scenario и могу определить, нужно ли split / merge / переписать в TC"
      },
      {
        "id": "AC-03",
        "text": "Распознаю 3 анти-паттерна (слишком широкий / слишком узкий / Description как тавтология) и знаю, как их фиксить"
      },
      {
        "id": "AC-04",
        "text": "Могу написать Test Scenario для регистрации в Garanti BBVA mobile (или эквивалентной фичи) с полными 8 полями и списком декомпозированных TC"
      },
      {
        "id": "AC-05",
        "text": "Понимаю связку Test Scenario с Test Plan (Plan ссылается на Scenarios, не на TC) и с AC (один AC обычно даёт 2-3 Scenarios)"
      },
      {
        "id": "AC-06",
        "text": "Раскрыто и подтверждено в Quick check"
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "test-documentation"
    ],
    "quickCheck": {
      "id": "QC-TD-02",
      "prompt": "Quick check",
      "question": "QA-инженер написал Test Scenario «TS-005: Verify checkout works». Из него вытекает 2 Test Cases. Что не так со сценарием по эвристике уровня детализации?",
      "options": [
        {
          "id": "a",
          "text": "Всё нормально — Scenario может быть любого размера"
        },
        {
          "id": "b",
          "text": "Title слишком абстрактный — нужно «Verify checkout flow with credit card» или подобное"
        },
        {
          "id": "c",
          "text": "Scenario слишком узкий: 2 TC — это уровень Test Case, не Scenario. По эвристике 5-15 TC на Scenario нужно либо расширить scope (добавить негативные / edge cases / cross-browser кейсы), либо переписать как один полноценный TC"
        },
        {
          "id": "d",
          "text": "Нужно добавить Test Plan и Bug Report"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: Scenario слишком узкий.</strong> По эвристике «5-15 TC на Scenario» сценарий с 2 TC — на уровне Test Case, не Scenario. Это анти-паттерн АП-2 «слишком узкий Scenario». Решения два: <em>(а) расширить scope</em> — добавить TC на негативные сценарии (пустая корзина, fail на оплате, double-click), edge cases (Black Friday-нагрузка), cross-browser (Safari iOS), и Scenario сам собой вырастет до 8-12 TC; <em>(б) переписать как один полноценный TC</em> и положить под другой более широкий Scenario («Verify e-commerce checkout module»). <strong>Опция 1</strong> неверна — есть рабочая эвристика, размер Scenario не «любой». <strong>Опция 2</strong> отчасти права (title абстрактный), но это не главная проблема — главная в уровне детализации. <strong>Опция 4</strong> мешает уровни. На собесе вопрос «как вы определяете границу между Scenario и Test Case» — junior с ответом «по правилу 5-15 TC на Scenario, иначе пересматриваю scope» сразу выглядит подготовленным."
    }
  },
  {
    "id": "TD-03",
    "sprintId": "S04",
    "ord": 3,
    "type": "docs",
    "priority": "P0",
    "title": "Тест-кейс (Test Case) — структура IEEE 829, атомарные шаги, два стиля",
    "estimateMin": 16,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю 9 полей IEEE 829 simplified Test Case (ID / Title / Priority / Type / Preconditions / Test Data / Steps / Expected / Postcondition) и могу заполнить каждое для конкретного теста"
      },
      {
        "id": "AC-02",
        "text": "Понимаю принцип атомарности шагов — каждый шаг одно действие, воспроизводимое незнакомым QA"
      },
      {
        "id": "AC-03",
        "text": "Различаю atomic-style (один TC = одна проверка) и scenario-style (один TC = весь user-флоу), знаю когда какой применять"
      },
      {
        "id": "AC-04",
        "text": "Распознаю 4 анти-паттерна (не-атомарные шаги / размытый Expected / Test Data в Steps / Title без Verify) и могу сразу зафиксить на review"
      },
      {
        "id": "AC-05",
        "text": "Могу написать полный TC по шаблону для логина в Garanti BBVA mobile (или эквивалентной фичи)"
      },
      {
        "id": "AC-06",
        "text": "Понимаю связку AC → TC через RTM (прочитал живую матрицу REQ → AC → TS → TC → BR) и могу для одного AC сгенерировать 2-5 TC"
      },
      {
        "id": "AC-07",
        "text": "Раскрыто и подтверждено в Quick check"
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "test-documentation"
    ],
    "quickCheck": {
      "id": "QC-TD-03",
      "prompt": "Quick check",
      "question": "Junior написал TC: «Title: Login. Steps: 1. Залогиниться валидными данными. Expected: Login работает». Сколько проблем по чек-листу анти-паттернов?",
      "options": [
        {
          "id": "a",
          "text": "1 проблема — нет Type"
        },
        {
          "id": "b",
          "text": "2 проблемы — нет Test Data и Postcondition"
        },
        {
          "id": "c",
          "text": "3+ проблемы: (а) Title без Verify и контекста — АП-4; (б) шаг не атомарный «Залогиниться» — АП-1; (в) Test Data отсутствует — АП-3; (г) Expected размыт «работает» — АП-2. Также пропущены Priority, Type, Preconditions, Postcondition"
        },
        {
          "id": "d",
          "text": "0 проблем — TC валидный"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: 3+ проблемы — все 4 анти-паттерна одновременно + пропущены критичные поля.</strong> Это <em>классический failed TC junior'а</em>. Чтобы починить: (а) Title → «Verify successful login with valid email and password (registered user, mobile app)». (б) Шаг 1 разбить на атомарные: «1. Открыть приложение. 2. На стартовом экране нажать \"Войти\". 3. В поле Email ввести `test@example.com`. 4. В поле Password ввести `Test2024!`. 5. Нажать кнопку Login.» (в) Test Data отдельным полем: «Email: `test@example.com` / Password: `Test2024!`». (г) Expected конкретно: «Переход на /dashboard в ≤2 сек. Заголовок \"Welcome, Test User\". Аватар в правом верхнем углу. Никаких error-сообщений.». Плюс добавить Priority (P0 для smoke), Type (Functional/Smoke), Preconditions (тестовый юзер существует, не залогинен, чистые cookies). На собесе попросят показать пример TC — если показать вот такой junior-вариант, разговор быстро закончится. <strong>Опции 1, 2</strong> сильно недооценивают глубину проблем. <strong>Опция 4</strong> — анти-паттерн «всё в порядке», классический самообман junior'а."
    }
  },
  {
    "id": "TD-04",
    "sprintId": "S04",
    "ord": 4,
    "type": "docs",
    "priority": "P1",
    "title": "User Story и Use Case — в чём разница",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю User Story и Use Case по 9 осям (формат / длина / аудитория / detail level / focus / AC / процесс / диаграмма / инструменты)"
      },
      {
        "id": "AC-02",
        "text": "Понимаю, что это два разных формата с разными философиями (Agile «обсудим» vs Waterfall «зафиксируем»), не «один с разной длиной»"
      },
      {
        "id": "AC-03",
        "text": "Могу для одной фичи (Add to Cart) показать оба варианта — Story 1 строка + AC и Use Case 1-2 страницы со всеми flows"
      },
      {
        "id": "AC-04",
        "text": "Знаю 4 фактора выбора между ними (процессная модель / размер фичи / аудитория / compliance)"
      },
      {
        "id": "AC-05",
        "text": "Могу с первого взгляда на документ распознать, Story это или Use Case, и сделать вывод о SDLC-модели проекта"
      },
      {
        "id": "AC-06",
        "text": "Понимаю, что они могут сосуществовать на hybrid-проектах — UC на этапе требований, Story для итеративной разработки"
      },
      {
        "id": "AC-07",
        "text": "Раскрыто и подтверждено в Quick check"
      },
      {
        "id": "AC-08",
        "text": "Собрана корректная User Story из частей (роль / действие / ценность) с отбраковкой вариантов уровня Use Case; написана своя история для выбранной фичи"
      }
    ],
    "istqb": [
      "CTFL-Ch2",
      "CTFL-Ch4"
    ],
    "skills": [
      "test-documentation",
      "requirements-analysis"
    ],
    "quickCheck": {
      "id": "QC-TD-04",
      "prompt": "Quick check",
      "question": "Тебя как junior QA позвали на новый проект — банковское мобильное приложение для регулируемого рынка EU. Лидирующий BA пишет требования в Confluence на 2-3 страницы каждое, с разделами «Actor / Preconditions / Main Flow / Alternate Flows / Postconditions» и UML-диаграммами. Какой формат требований используется и какая SDLC-модель скорее всего?",
      "options": [
        {
          "id": "a",
          "text": "User Story в Agile / Scrum"
        },
        {
          "id": "b",
          "text": "Use Case в Waterfall / V-Model / hybrid (формальная документация для регулируемого рынка)"
        },
        {
          "id": "c",
          "text": "Это произвольный формат, не привязан к процессной модели"
        },
        {
          "id": "d",
          "text": "Это Test Case, не требование"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: Use Case в Waterfall / V-Model / hybrid.</strong> Несколько маркеров: <em>(а) формат</em> — Actor / Preconditions / Main Flow / Alternate Flows / Postconditions — это canonical Use Case structure (UC-формат). <em>(б) длина</em> — 2-3 страницы на требование указывает на формальный документ, не короткую Story. <em>(в) UML-диаграммы</em> — Use Case Diagrams часто сопровождают формальный UC. <em>(г) контекст</em> — банковское приложение для регулируемого рынка EU предполагает compliance с EU regulations (PSD2, GDPR), которые требуют formal traceability и detailed documentation. <em>(д) автор</em> — BA в Confluence, не PO в Jira. <strong>Опция 1</strong> неверна — User Story в Agile была бы короткой записью в Jira с AC в Given/When/Then, без UML и без 3 страниц. <strong>Опция 3</strong> неверна — формат всегда косвенно связан с процессной моделью. <strong>Опция 4</strong> мешает уровни — Test Case это от QA по требованию, не само требование. На собесе вопрос «вот тебе документ — что это и как с ним работать?» — junior с правильным распознаванием Use Case + Waterfall сразу выглядит подготовленным."
    }
  },
  {
    "id": "TD-05",
    "sprintId": "S04",
    "ord": 5,
    "type": "docs",
    "priority": "P1",
    "title": "Структура Use Case — 10 полей и флоу",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю 10 полей fully-dressed Use Case (ID / Name / Actors × 2 / Description / Preconditions / Trigger / Main Flow / Alternate Flows / Postconditions) и могу заполнить каждое"
      },
      {
        "id": "AC-02",
        "text": "Понимаю 3 уровня формализации Use Case (Brief / Casual / Fully Dressed) и когда какой применять"
      },
      {
        "id": "AC-03",
        "text": "Различаю Main Flow и Alternate Flows и понимаю, как Alternate Flows становятся готовыми negative-Test Cases"
      },
      {
        "id": "AC-04",
        "text": "Могу прочитать fully-dressed UC и сделать декомпозицию в 10+ TC (main flow + alternate flows + variations + postcondition checks)"
      },
      {
        "id": "AC-05",
        "text": "Знаю про UML Use Case Diagram (actors слева, UCs в центре, include/extend relationships) на recognition-уровне"
      },
      {
        "id": "AC-06",
        "text": "Понимаю anti-pattern «UC-fatigue на Agile-проектах» и когда UC оправдан, а когда нет"
      },
      {
        "id": "AC-07",
        "text": "Раскрыто и подтверждено в Quick check"
      },
      {
        "id": "AC-08",
        "text": "Разобран UC-CHECKOUT-001 на тест-кейсы: каждый flow / extension / postcondition → TC; видно, что из одного UC выходит 13 TC, из них 6 негативных"
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "test-documentation",
      "requirements-analysis"
    ],
    "quickCheck": {
      "id": "QC-TD-05",
      "prompt": "Quick check",
      "question": "У UC-CHECKOUT-001 «Place Order» (см. выше) указано Main Flow из 8 шагов и 4 Alternate Flows (Address validation fails, Payment declined, Payment timeout, No saved addresses). Сколько Test Cases минимум родит этот UC при базовом покрытии?",
      "options": [
        {
          "id": "a",
          "text": "1 TC — для Main Flow"
        },
        {
          "id": "b",
          "text": "5 TC — Main Flow + 4 Alternate Flows"
        },
        {
          "id": "c",
          "text": "10+ TC — Main Flow + 4 Alternate Flows + variations (delivery method × payment method) + postcondition verifications (email content, inventory decrement). Использование UC даёт «готовые» negative-сценарии, не нужен grooming с PM"
        },
        {
          "id": "d",
          "text": "0 TC — UC не источник для тестов"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: 10+ TC.</strong> Каждый flow в UC становится 1+ TC: Main Flow → 1 TC + variations (Express delivery, Apple Pay, Google Pay) → 3 дополнительных TC = 4 TC только для main path. Каждый Alternate Flow → 1-2 TC: 4 alt × 1.5 = 6 TC. Postcondition verifications (email contents, inventory decrement, audit log, cart cleared) → 3-4 TC. Итого 13+ TC, как в практике-декомпозиции выше. <strong>Опция 1</strong> (только 1 TC) недопустима — игнорирует все alternate flows и upstream/downstream проверки. <strong>Опция 2</strong> (5 TC) — минимум, но без variations и postcondition checks; недостаточно для серьёзного покрытия. <strong>Опция 4</strong> (0 TC) — анти-паттерн «UC только для BA»; на самом деле UC специально пишется так, чтобы быть source для тестов. На собесе вопрос «как использовать Use Case для написания тестов?» — junior с ответом «каждый flow → 1+ TC, каждое extension → negative TC, postconditions → verification TC» сразу выглядит зрелым."
    }
  },
  {
    "id": "TD-06",
    "sprintId": "S04",
    "ord": 6,
    "type": "docs",
    "priority": "P0",
    "title": "Bug Report — структура и качество",
    "estimateMin": 20,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю 11+1 полей Bug Report (ID / Title / Severity / Priority / Steps / Expected / Actual / Environment / Preconditions / Frequency / Attachments / Business Impact) и могу заполнить каждое для реального бага"
      },
      {
        "id": "AC-02",
        "text": "Применяю формулу Title «что + где + когда» и могу с первого взгляда отличить хороший Title от плохого"
      },
      {
        "id": "AC-03",
        "text": "Распознаю 3 анти-паттерна (без воспроизводимости / эмоциональная оценка / Title как причина) и сразу фикщу при review"
      },
      {
        "id": "AC-04",
        "text": "Понимаю, что severity (QA-зона, техническое влияние) и priority (PO/PM-зона, бизнес-impact) — разные оси (deep — следующий тикет T07)"
      },
      {
        "id": "AC-05",
        "text": "Знаю про bug lifecycle на тизер-уровне (workflow states) и понимаю, что полный process — Sprint 07"
      },
      {
        "id": "AC-06",
        "text": "Могу написать полный BR-145 для реальной находки на staging с воспроизводимостью 100%, всеми полями и attachments"
      },
      {
        "id": "AC-07",
        "text": "Понимаю принцип «BR Confirmation Rate ≥ 90%» — качество важнее количества"
      },
      {
        "id": "AC-08",
        "text": "Раскрыто и подтверждено в Quick check"
      },
      {
        "id": "AC-09",
        "text": "Починен сырой Bug Report поле за полем (Title по формуле, Severity, атомарные шаги, конкретные Expected/Actual, доказательства, дозаполненные поля) и пройдена самостоятельная тренировка на трёх дополнительных багах"
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "test-documentation",
      "bug-report-writing"
    ],
    "quickCheck": {
      "id": "QC-TD-06",
      "prompt": "Quick check",
      "question": "Junior пишет Bug Report со следующими полями: «Title: Корзина баг. Severity: -. Steps: тестировал корзину, ломается. Expected: должна работать. Actual: не работает. Attachments: нет.». Сколько обязательных полей пропущено или некорректно заполнено?",
      "options": [
        {
          "id": "a",
          "text": "0 — всё нормально"
        },
        {
          "id": "b",
          "text": "2-3 поля"
        },
        {
          "id": "c",
          "text": "5+ полей: Title не по формуле что+где+когда (АП-3 + АП с эмоциями), Severity пропущен, Steps не атомарные (АП-1 без воспроизводимости), Expected/Actual размытые (АП-2 эмоциональная оценка), Attachments отсутствуют. Также пропущены Priority, Environment, Preconditions, Frequency, Business Impact"
        },
        {
          "id": "d",
          "text": "Только Attachments"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: 5+ полей пропущены или некорректны.</strong> Это <em>классический failed BR junior'а</em>, который Dev сразу вернёт «Need more info». Чтобы починить: (а) Title по формуле «Корзина теряет товары на странице каталога при переключении категории в Chrome 124»; (б) Severity (Critical/Major/Minor — определить по влиянию); (в) Steps атомарными до 100% воспроизводимости; (г) Expected/Actual конкретно («После переключения категории — товары в корзине сохраняются» / «После переключения — корзина пустая, в Console error `localStorage.cart is null`»); (д) Минимум 1 screenshot. Плюс заполнить Priority, Environment (browser+OS+URL+build), Preconditions, Frequency, Business Impact. На собесе junior показывает свой пример BR — если такой формат, разговор быстро закончится. <strong>Опции 1, 2, 4</strong> сильно недооценивают глубину проблем — это анти-паттерн «всё в порядке» классического junior-самообмана."
    }
  },
  {
    "id": "TD-07",
    "sprintId": "S04",
    "ord": 7,
    "type": "docs",
    "priority": "P0",
    "title": "Severity и Priority — калибровка матрицы",
    "estimateMin": 16,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю Severity (техническое влияние, QA-зона) и Priority (бизнес-срочность, PO/PM-зона) и могу для каждого назвать критерий определения"
      },
      {
        "id": "AC-02",
        "text": "Знаю 4 уровня Severity (Critical / Major / Minor / Trivial) с конкретными примерами"
      },
      {
        "id": "AC-03",
        "text": "Знаю 4 уровня Priority (P0 / P1 / P2 / P3) с типичным action для каждого"
      },
      {
        "id": "AC-04",
        "text": "Понимаю матрицу S × P 4×4 и могу для конкретного бага определить, типичная ли это комбинация или контр-интуитивная (требующая обоснования)"
      },
      {
        "id": "AC-05",
        "text": "Распознаю 5 типичных ошибок калибровки severity (всё Critical / Severity = Priority / эмоциональный impact / без workaround / без users impact)"
      },
      {
        "id": "AC-06",
        "text": "Могу обосновать контр-интуитивные комбинации (Trivial × P0 для typo на главной, Critical × P3 для умирающей фичи)"
      },
      {
        "id": "AC-07",
        "text": "На собесе на trap-question «severity или priority важнее?» отвечаю «они не сравнимы, это разные оси»"
      },
      {
        "id": "AC-08",
        "text": "Раскрыто и подтверждено в Quick check"
      },
      {
        "id": "AC-09",
        "text": "Откалибровано 5 баг-кейсов по обеим осям (Severity × Priority), включая контр-интуитивные (Trivial × P0, Critical × P3), типичные vs контр-интуитивные комбинации распознаны"
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "test-documentation",
      "bug-report-writing"
    ],
    "quickCheck": {
      "id": "QC-TD-07",
      "prompt": "Quick check",
      "question": "QA нашёл баг: на главной странице e-commerce-сайта в названии компании опечатка — «Garranti» вместо «Garanti» (фирменное имя бренда). Функционал не нарушен. Какие severity и priority корректны?",
      "options": [
        {
          "id": "a",
          "text": "Critical Severity + P0 Priority — это бренд-критично"
        },
        {
          "id": "b",
          "text": "Trivial Severity + P3 Priority — typo, не критично"
        },
        {
          "id": "c",
          "text": "Trivial Severity + P0 Priority — функционал не нарушен (typo = Trivial по техническому критерию), но место visibility = main page + бренд = репутационный риск, hot-fix"
        },
        {
          "id": "d",
          "text": "Major Severity + P1 Priority — серьёзный баг на главной"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: Trivial Severity + P0 Priority.</strong> Это <em>классический пример контр-интуитивной комбинации</em>, который проверяет, понимает ли junior разделение осей. <strong>Severity Trivial</strong> — потому что это typo, функционал не нарушен, по техническому критерию это категория Trivial. <strong>Priority P0</strong> — потому что место visibility (главная страница, фирменное имя бренда) делает эту опечатку <em>репутационным риском</em>: каждый посетитель сайта видит ошибку в названии компании, доверие падает, hot-fix немедленно. <strong>Опция 1</strong> ошибочно завышает Severity — пытается выразить «важность» через severity, игнорируя технический критерий. <strong>Опция 2</strong> ошибочно занижает Priority — игнорирует бизнес-impact. <strong>Опция 4</strong> сбивает обе оси. На собесе junior, отвечающий по этому примеру правильно (Trivial × P0 с обоснованием), сразу выглядит middle-ready."
    }
  },
  {
    "id": "TD-08",
    "sprintId": "S04",
    "ord": 8,
    "type": "docs",
    "priority": "P1",
    "title": "Test Plan — 6 секций IEEE 829",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю 6 секций Test Plan IEEE 829 simplified (Scope / Strategy / Entry / Exit / Schedule / Risks &amp; Mitigations) и могу заполнить каждую"
      },
      {
        "id": "AC-02",
        "text": "Понимаю критическую важность секции Out of Scope как защиты от post-release конфликтов"
      },
      {
        "id": "AC-03",
        "text": "Различаю Test Plan и Test Strategy — Strategy это секция внутри Plan (на junior-проектах)"
      },
      {
        "id": "AC-04",
        "text": "Могу написать measurable Exit Criteria («100% P0 + 95% P1 PASS, 0 Critical / 0 Major open»), а не размытые («всё работает»)"
      },
      {
        "id": "AC-05",
        "text": "Могу написать Risks &amp; Mitigations с конкретным mitigation для каждого риска (не «риск: что-то пойдёт не так»)"
      },
      {
        "id": "AC-06",
        "text": "Могу составить mini Test Plan для модуля Wishlist на 5 дней × 1 QA по образцу"
      },
      {
        "id": "AC-07",
        "text": "Понимаю связь Test Plan с GO/NO-GO решением на release meeting через Exit Criteria"
      },
      {
        "id": "AC-08",
        "text": "Раскрыто и подтверждено в Quick check"
      },
      {
        "id": "AC-09",
        "text": "Разобран живой Test Plan «Wishlist v1.0» по 6 секциям; в практике measurable Exit Criteria отличены от размытых пожеланий"
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "test-documentation",
      "test-plan"
    ],
    "quickCheck": {
      "id": "QC-TD-08",
      "prompt": "Quick check",
      "question": "QA-инженер написал Exit Criteria для Test Plan: «Все тесты PASS, нет багов». Что не так с этими Exit Criteria?",
      "options": [
        {
          "id": "a",
          "text": "Всё нормально — Exit Criteria короткие и ясные"
        },
        {
          "id": "b",
          "text": "Не measurable: «все тесты PASS» — все P0/P1/P2/P3 или только P0/P1? «Нет багов» — реально достижимо ноль? Или ноль Critical / ноль Major? Без конкретных порогов команда не может объективно сказать «закрыли тестирование» или «не закрыли»"
        },
        {
          "id": "c",
          "text": "Не хватает Schedule"
        },
        {
          "id": "d",
          "text": "Слишком много пунктов"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: Exit Criteria не measurable.</strong> «Все тесты PASS» — слишком широко: реально на проекте всегда есть P3 кейсы, которые могут оставаться FAILED после релиза (low priority, фиксим следующим спринтом). «Нет багов» — недостижимо: ноль багов в продукте — миф. Правильные measurable Exit Criteria: «100% P0 + 95% P1 test cases PASS, 0 Critical / 0 Major bugs open, 0 P2 без mitigation plan, sign-off от QA Lead и PO». Каждый пункт — конкретный порог, который можно проверить да/нет. <strong>Опция 1</strong> — анти-паттерн «короткие и ясные = хорошие». Краткость без measurability бесполезна для GO/NO-GO решения. <strong>Опции 3, 4</strong> мимо — главная проблема не в Schedule и не в количестве, а в measurability. На собесе junior с пониманием measurable Exit Criteria сразу выглядит зрелым."
    }
  },
  {
    "id": "TD-09",
    "sprintId": "S04",
    "ord": 9,
    "type": "ai",
    "priority": "P1",
    "title": "AI генерирует тест-документацию — TC, BR, Test Plan",
    "estimateMin": 14,
    "ac": [
      {
        "id": "AC-01",
        "text": "Запомнено 3 шаблона промптов: TC из User Story с AC · BR rewrite (улучши плохой) · Test Plan skeleton для нового модуля"
      },
      {
        "id": "AC-02",
        "text": "Прогнан Промпт 1 на Story с Atelier sandbox (discount code); 3 ценных TC записаны в журнал"
      },
      {
        "id": "AC-03",
        "text": "Понимаю 3 правила работы с output AI: сверь бизнес-правила с PM · перепиши под свой продукт + terminology · отметь AI-assisted в commit"
      },
      {
        "id": "AC-04",
        "text": "Знаю, в чём AI силён (структура шаблонов, базовые edge cases, анти-паттерны, type categorization) и в чём галлюцинирует (бизнес-правила, технические детали, internal terminology, related requirements)"
      },
      {
        "id": "AC-05",
        "text": "Понимаю принцип «AI = черновик, junior = автор + assistant, ответственность за финальный документ — junior'а»"
      },
      {
        "id": "AC-06",
        "text": "Никогда не передаю TC/BR/Plan от AI «как есть» — всегда правлю, сверяю, коммичу с указанием AI-assistance"
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "ai-workflow",
      "test-documentation"
    ],
    "quickCheck": {
      "id": "QC-TD-09",
      "prompt": "Quick check",
      "question": "AI сгенерировал 15 Test Cases по твоему промпту. Среди них один кейс с бизнес-правилом «промокод применяется ДО НДС». Что обязан сделать junior до коммита TC в репозиторий?",
      "options": [
        {
          "id": "a",
          "text": "Скопировать как есть — AI обычно прав в business rules"
        },
        {
          "id": "b",
          "text": "Сверить бизнес-правило с PM/PRD (AI часто галлюцинирует на domain-specific rules), переписать под terminology своего продукта, отметить «AI-assisted» в commit message"
        },
        {
          "id": "c",
          "text": "Удалить кейс — раз AI его сгенерировал, он подозрителен"
        },
        {
          "id": "d",
          "text": "Отправить весь output PM на review без правок"
        }
      ],
      "answer": "b",
      "explanation": "Правильно: <strong>сверить с PM + переписать + пометить AI-assisted</strong>. AI силён в структуре шаблонов, базовых edge cases и type categorization, но <em>галлюцинирует на business rules</em>, internal terminology и related requirements (см. AC-04). «Промокод до или после НДС» — это конкретное бизнес-правило, которое AI мог придумать, или взять из чужого продукта. (a) — anti-pattern «слепое доверие AI»: ответственность за TC лежит на тебе, не на AI. (c) — overcorrection; AI-output это <em>черновик</em>, не мусор. (d) — PM не должен править твои TC: правишь ты, PM подтверждает business rules."
    }
  },
  {
    "id": "TD-10",
    "sprintId": "S04",
    "ord": 10,
    "type": "lab",
    "priority": "P2",
    "title": "Practice Lab — упражнения с разбором",
    "estimateMin": 8,
    "ac": [
      {
        "id": "AC-01",
        "text": "Понимаю, что Practice Lab — это упражнения с разбором: сначала решаю самостоятельно в поле для ответа, потом раскрываю готовое решение и сравниваю"
      },
      {
        "id": "AC-02",
        "text": "Знаю, что Lab опциональны (не блокируют Sprint Review), но дают глубину через сравнение своего решения с разбором"
      },
      {
        "id": "AC-03",
        "text": "Знаю 3 Lab-упражнения Sprint 04 (Test Case по требованию / Bug Report rewrite / Test Plan для Wishlist) и какие тикеты они закрепляют"
      },
      {
        "id": "AC-04",
        "text": "Понимаю разницу Lab (с разбором) vs Backlog HW (самостоятельно) и могу выбрать, что делать"
      },
      {
        "id": "AC-05",
        "text": "Сделан минимум 1 Lab из 3 в Sprint 04 — навык закреплён через сравнение с разбором"
      }
    ],
    "istqb": [
      "CTFL-Ch4",
      "CTFL-Ch5"
    ],
    "skills": [
      "test-documentation",
      "practice-lab"
    ]
  },
  {
    "id": "TD-11",
    "sprintId": "S04",
    "ord": 11,
    "type": "master",
    "priority": "P0",
    "title": "Миссия · полная документация фичи",
    "estimateMin": 30,
    "ac": [
      {
        "id": "AC-01",
        "text": "Выбрана одна фича на Atelier sandbox (не весь сайт), записан scope"
      },
      {
        "id": "AC-02",
        "text": "User Story записан в формате As a / I want / So that"
      },
      {
        "id": "AC-03",
        "text": "4-6 Acceptance Criteria записаны в Given/When/Then с покрытием 4 типов"
      },
      {
        "id": "AC-04",
        "text": "3-5 Test Scenarios записаны по шаблону T02 (ID + Title + краткое Description)"
      },
      {
        "id": "AC-05",
        "text": "3 полных Test Cases записаны по шаблону T03 IEEE 829, привязанные к одному из TS"
      },
      {
        "id": "AC-06",
        "text": "3 TC прогнаны на Atelier sandbox, результат записан (PASS/FAIL + комментарий)"
      },
      {
        "id": "AC-07",
        "text": "1 Bug Report по шаблону T06 (или гипотетический с пометкой)"
      },
      {
        "id": "AC-08",
        "text": "Mini Test Plan на 3-дневный релиз × 1 QA по 6 секциям T08"
      },
      {
        "id": "AC-09",
        "text": "AI-сравнение записано (что AI заметил → я пропустил, и наоборот)"
      },
      {
        "id": "AC-10",
        "text": "Все артефакты сохранены в Дневнике тестировщика как single coherent документ для портфолио"
      }
    ],
    "istqb": [
      "CTFL-Ch4",
      "CTFL-Ch5"
    ],
    "skills": [
      "test-documentation",
      "bug-report-writing",
      "test-plan"
    ]
  },
  {
    "id": "MGT-01",
    "sprintId": "S05",
    "ord": 1,
    "type": "design",
    "priority": "P0",
    "title": "Тест-дизайн — три семейства техник и как выбрать под задачу",
    "estimateMin": 17,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю три семейства техник тест-дизайна (Black-box / White-box / Experience-based) и могу для каждого назвать 2-3 типичные техники"
      },
      {
        "id": "AC-02",
        "text": "Знаю 6 основных Black-box техник (EP / BVA / Decision Table / State Transition / Pairwise / Use Case Testing) и для каждой могу назвать «когда применять»"
      },
      {
        "id": "AC-03",
        "text": "Понимаю decision tree выбора: ввод → EP+BVA, бизнес-правила → Decision Table, состояния → State Transition, много параметров → Pairwise, есть Use Case → Use Case Testing, нестандартное → Exploratory + Error Guessing"
      },
      {
        "id": "AC-04",
        "text": "На задаче с несколькими «природами» (форма + правила + состояния) могу спроектировать комбинацию из 2-4 техник, не пытаясь применить одну ко всему"
      },
      {
        "id": "AC-05",
        "text": "Понимаю, что техники применимы на всех уровнях (Component → Acceptance из S03) и типах (Functional / Non-functional из S03) — они универсальны"
      },
      {
        "id": "AC-06",
        "text": "На собесе на вопрос «какие техники тест-дизайна знаете» отвечаю через 3 семейства + конкретные техники + связку с задачей"
      },
      {
        "id": "AC-07",
        "text": "Прошёл (прошла) карусель «Какая техника?» — 6 задач"
      },
      {
        "id": "AC-08",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ"
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "test-design"
    ],
    "quickCheck": {
      "id": "QC-MGT-01",
      "prompt": "Quick check",
      "question": "PM попросил протестировать форму бронирования отеля: даты check-in / check-out, количество гостей (1-10), тип номера (Standard/Deluxe/Suite), есть ли промокод (да/нет). Какая комбинация техник лучше всего покроет фичу?",
      "options": [
        {
          "id": "a",
          "text": "Только EP — это поля ввода, остальные техники не нужны"
        },
        {
          "id": "b",
          "text": "EP + BVA для каждого поля + Decision Table для правил «есть промокод × тип номера → итоговая цена» (если правила есть) + State Transition если у бронирования есть статусы (Created → Confirmed → Cancelled)"
        },
        {
          "id": "c",
          "text": "Pairwise — единственный способ, потому что много параметров"
        },
        {
          "id": "d",
          "text": "White-box техники — нужно проверить покрытие кода"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: EP + BVA + Decision Table + State Transition в комбинации.</strong> Это типичная задача с несколькими «природами»: поля ввода (даты, гости — для них <strong>EP+BVA</strong>: классы валидно/невалидно, граничные значения 1, 10, 11 для гостей), бизнес-правила (промокод × тип номера → цена — для них <strong>Decision Table</strong>: 4 комбинации, expected result для каждой), состояния (Created → Confirmed → Cancelled — <strong>State Transition</strong>: валидные + невалидные переходы). <strong>Опция 1</strong> — слишком узкая, упускает Decision Table и State Transition. <strong>Опция 3</strong> — Pairwise здесь избыточен: параметров не настолько много, чтобы полный перебор был невозможен; EP+BVA по полям уже сократит. <strong>Опция 4</strong> — White-box не для junior QA на manual-фичах, это unit-тесты разработчика. На собесе ответ через комбинацию техник демонстрирует, что junior понимает, как разные техники дополняют друг друга, а не выбирает одну."
    }
  },
  {
    "id": "MGT-02",
    "sprintId": "S05",
    "ord": 2,
    "type": "design",
    "priority": "P0",
    "title": "Equivalence Partitioning — разделение входов на классы",
    "estimateMin": 17,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю принцип EP: разделение входов на классы эквивалентности, один тест из каждого класса покрывает класс целиком"
      },
      {
        "id": "AC-02",
        "text": "Могу для конкретного поля выделить все классы (валидный + несколько под-классов невалидных по природе ошибки)"
      },
      {
        "id": "AC-03",
        "text": "Понимаю требование «классы непересекающиеся» и могу проверить таблицу на пересечения (АП-3)"
      },
      {
        "id": "AC-04",
        "text": "Распознаю 3 анти-паттерна (только valid+invalid / один тест на «всю invalid» / пересекающиеся классы) и знаю, как их фиксить"
      },
      {
        "id": "AC-05",
        "text": "Применяю EP не только к числам, но и к строкам, перечислениям, файлам — везде, где есть «одинаковое поведение системы на группе входов»"
      },
      {
        "id": "AC-06",
        "text": "Понимаю, что EP почти всегда применяется в связке с BVA — EP даёт классы, BVA проверяет границы классов"
      },
      {
        "id": "AC-07",
        "text": "Перед применением EP задаю уточняющие вопросы PM/разработчику (поведение на дробных, null, Unicode, граничных случаях)"
      },
      {
        "id": "AC-08",
        "text": "Разложил(а) все 8 значений сортера по классам (валидно / мимо лимитов / не формат)"
      },
      {
        "id": "AC-08",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ"
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "test-design"
    ],
    "quickCheck": {
      "id": "QC-MGT-02",
      "prompt": "Quick check",
      "question": "QA пишет EP для поля «Имя пользователя» (валидно: 3-20 символов, латиница + цифры, без спецсимволов). Junior выдаёт 2 класса: «valid: 3-20 символов» и «invalid: всё остальное». Что не так?",
      "options": [
        {
          "id": "a",
          "text": "Всё правильно — EP это два класса (valid и invalid)"
        },
        {
          "id": "b",
          "text": "Анти-паттерн АП-2: один класс «invalid» — слишком grubo. Нужно разбить invalid по природе: длина &lt; 3 / длина &gt; 20 / спецсимволы / кириллица / пустое поле — каждое со своим ожидаемым сообщением. Получится 5-6 классов, не 2"
        },
        {
          "id": "c",
          "text": "Нужно добавить BVA — без него EP не работает"
        },
        {
          "id": "d",
          "text": "Нужно нарисовать диаграмму"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: анти-паттерн АП-2 «один класс invalid».</strong> Корректное EP разбивает invalid на под-классы по природе ошибки: <em>длина &lt; 3</em> → сообщение «Слишком короткое имя»; <em>длина &gt; 20</em> → «Слишком длинное имя»; <em>содержит спецсимволы</em> (@, !, $) → «Только латиница и цифры»; <em>содержит кириллицу</em> (Иван) → «Только латиница и цифры» (либо отдельное сообщение); <em>пустое поле</em> → «Поле обязательно». Поведение системы на каждом из этих классов <strong>разное</strong>: разные сообщения, разная локализация, разная валидация (UI vs backend). Один тест-представитель из каждого класса = 5-6 тестов вместо 2. <strong>Опция 1</strong> — слишком grubo, упускает разнообразие невалидных вариантов. <strong>Опция 3</strong> — про BVA правильно, но это отдельный шаг (T03), не «причина что не так с EP». <strong>Опция 4</strong> — диаграмма не обязательна для EP, таблица вполне хватает. На собесе разделение invalid на под-классы — признак подготовленного junior'а."
    }
  },
  {
    "id": "MGT-03",
    "sprintId": "S05",
    "ord": 3,
    "type": "design",
    "priority": "P0",
    "title": "BVA — тестирование границ диапазонов, 3-value по CTFL 4.0",
    "estimateMin": 17,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю принцип BVA: дефекты концентрируются на границах, 3-value (boundary-1, boundary, boundary+1) покрывает обе стороны границы"
      },
      {
        "id": "AC-02",
        "text": "По CTFL 4.0 применяю 3-value формат по умолчанию; понимаю отличие от 2-value (legacy)"
      },
      {
        "id": "AC-03",
        "text": "Для каждой границы класса EP пишу отдельный 3-value набор; не забываю про обе границы"
      },
      {
        "id": "AC-04",
        "text": "Понимаю разницу между включающими (`≥`) и исключающими (`&gt;`) границами, уточняю у PM"
      },
      {
        "id": "AC-05",
        "text": "Применяю EP + BVA как единый рабочий шаблон в 5 шагов"
      },
      {
        "id": "AC-06",
        "text": "Распознаю 3 анти-паттерна (1-value / тест на одной границе / BVA вместо EP)"
      },
      {
        "id": "AC-07",
        "text": "Применяю BVA к строкам (длина, byte vs char для Unicode)"
      },
      {
        "id": "AC-08",
        "text": "Собрал(а) оба 3-value набора в практике «Выбери границы», включая раунд с шагом 0.01"
      },
      {
        "id": "AC-09",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ"
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "test-design"
    ],
    "quickCheck": {
      "id": "QC-MGT-03",
      "prompt": "Quick check",
      "question": "QA пишет BVA для поля «Возраст» (18-65). Junior выдаёт 4 теста: 17, 18, 65, 66. Что не так по CTFL 4.0?",
      "options": [
        {
          "id": "a",
          "text": "Всё правильно — 4 теста на 2 границы"
        },
        {
          "id": "b",
          "text": "Это 2-value BVA (boundary-1 и boundary без boundary+1). По CTFL 4.0 рекомендуется 3-value: нужно добавить 19 (после нижней границы) и 64 (перед верхней). Итого 6 тестов"
        },
        {
          "id": "c",
          "text": "Нужно тестировать только 18 и 65 — границы валидны"
        },
        {
          "id": "d",
          "text": "BVA не нужен, хватит EP"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: это 2-value, по CTFL 4.0 нужен 3-value — добавить 19 и 64.</strong> Junior выдал по 2 значения на границу — это <em>2-value формат</em>, который ISTQB syllabus 4.0 считает <strong>устаревшим</strong>. Современный 3-value требует трёх значений на каждую границу: boundary-1, boundary, boundary+1. Итого 6 тестов, не 4. Причина: 3-value покрывает <em>обе стороны</em> границы, что ловит баги в условиях типа `&gt;=` vs `&gt;` в обе стороны. На экзамене CTFL 4.0 правильный ответ — 3-value. <strong>Опция 1</strong> неверна — это 2-value, не 3-value standard. <strong>Опция 3</strong> неверна — пропускает по обе стороны. <strong>Опция 4</strong> мешает техники — EP даёт классы, BVA проверяет границы; они дополняют."
    }
  },
  {
    "id": "MGT-04",
    "sprintId": "S05",
    "ord": 4,
    "type": "design",
    "priority": "P0",
    "title": "Decision Table — таблица решений для бизнес-логики",
    "estimateMin": 19,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю формат Decision Table: условия в строках, rules в колонках, Expected Result для каждого rule"
      },
      {
        "id": "AC-02",
        "text": "Считаю количество rules как 2^N для N бинарных условий (4 условия = 16 rules)"
      },
      {
        "id": "AC-03",
        "text": "Минимизирую полную таблицу до уникальных Expected Results через приоритезацию бизнес-правил"
      },
      {
        "id": "AC-04",
        "text": "Понимаю, что приоритезация — это <em>бизнес-решение</em>, согласовываю с PM"
      },
      {
        "id": "AC-05",
        "text": "Использую колонку Reachability и помечаю недостижимые через UI rules (тестирую их через API напрямую)"
      },
      {
        "id": "AC-06",
        "text": "Распознаю 3 анти-паттерна (без минимизации / без согласования приоритета / без Reachability)"
      },
      {
        "id": "AC-07",
        "text": "Применяю Decision Table к бизнес-правилам с 2-5 условиями; не применяю к простым полям (там EP+BVA) или к flow (там State Transition)"
      },
      {
        "id": "AC-08",
        "text": "Прошёл (прошла) карусель «Какое правило сработает?» — 6 ситуаций, включая ловушку «Спросить PM»"
      },
      {
        "id": "AC-09",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ"
      }
    ],
    "istqb": [
      "CTFL-Ch4",
      "CTFL-Ch5"
    ],
    "skills": [
      "test-design"
    ],
    "quickCheck": {
      "id": "QC-MGT-04",
      "prompt": "Quick check",
      "question": "Junior строит Decision Table для расчёта скидки в e-commerce: 3 условия (VIP / промокод / сумма &gt; 5000 ₽). Получает 8 rules. Не минимизирует, не помечает Reachability, при множественной скидке (VIP + промокод + большая сумма) самостоятельно решает: «применяем максимальную одну». Пишет 8 Test Cases. Что не так?",
      "options": [
        {
          "id": "a",
          "text": "Всё правильно — 8 rules → 8 TC"
        },
        {
          "id": "b",
          "text": "Сразу 3 проблемы: (а) отсутствует минимизация — часть rules может давать одинаковую скидку; (б) приоритезация при множественной скидке не согласована с PM (бизнес-правило: суммируются ли скидки или применяется максимальная?); (в) Reachability не проверена"
        },
        {
          "id": "c",
          "text": "Нужно сделать 16 rules — junior пропустил половину"
        },
        {
          "id": "d",
          "text": "Decision Table не подходит для скидок, нужно использовать EP"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: 3 проблемы — отсутствует минимизация, не согласована приоритезация, не проверена Reachability.</strong> На скидках классическая ловушка — это <em>правила суммирования</em>. PM может решить: «скидки суммируются» (VIP 10% + промокод 5% + большая сумма 5% = 20%), либо «применяется максимальная» (max из VIP / промокод / сумма), либо «применяется фиксированная при сочетании» (VIP + промокод = 15% независимо от ставок). Junior, который сам выбрал «максимальная одна», будет тестировать <em>не то поведение</em>, что в проде. <strong>Опция 1</strong> упускает все 3 проблемы. <strong>Опция 3</strong> — 8 rules для 3 условий правильно (2³ = 8). <strong>Опция 4</strong> — Decision Table идеально для скидок (бизнес-правила с комбинациями условий — её основной use case)."
    }
  },
  {
    "id": "MGT-05",
    "sprintId": "S05",
    "ord": 5,
    "type": "design",
    "priority": "P0",
    "title": "State Transition — переходы между состояниями + security невалидных переходов",
    "estimateMin": 19,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю принцип State Transition: рисую диаграмму состояний, выписываю валидные переходы, обязательно ищу невалидные"
      },
      {
        "id": "AC-02",
        "text": "Для каждого перехода указываю <em>триггер</em> (что вызывает переход) и пишу Test Case с шагами"
      },
      {
        "id": "AC-03",
        "text": "Понимаю, что невалидные переходы — это security territory: тестирую их <strong>через API напрямую</strong> (Postman / curl), потому что UI можно обойти"
      },
      {
        "id": "AC-04",
        "text": "Применяю принцип defense in depth: backend должен валидировать independent от UI"
      },
      {
        "id": "AC-05",
        "text": "Знаю 3 подхода к тестированию time-based переходов без реального ожидания: config-override / fake clock / DB manipulation"
      },
      {
        "id": "AC-06",
        "text": "Распознаю 3 анти-паттерна (только валидные / без триггеров / без direct API) и знаю, как их фиксить"
      },
      {
        "id": "AC-07",
        "text": "Применяю Risk-Based Testing к State Transition: критичные переходы покрываются глубже (UI + API + DB)"
      },
      {
        "id": "AC-08",
        "text": "Прошёл (прошла) карусель «Валидный или невалидный?» — 6 переходов"
      },
      {
        "id": "AC-09",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ"
      }
    ],
    "istqb": [
      "CTFL-Ch4",
      "CTFL-Ch5"
    ],
    "skills": [
      "test-design"
    ],
    "quickCheck": {
      "id": "QC-MGT-05",
      "prompt": "Quick check",
      "question": "Junior рисует State Transition диаграмму для аккаунта (Active / Suspended / Blocked / Deleted), выписывает 6 валидных переходов и пишет 6 TC. На вопрос про невалидные переходы говорит: «они не нужны, потому что UI не позволяет их сделать». Что не так?",
      "options": [
        {
          "id": "a",
          "text": "Всё правильно — UI блокирует невалидные переходы"
        },
        {
          "id": "b",
          "text": "Невалидные переходы обязательно тестируются через прямой API (Postman / curl), потому что UI можно обойти: атакующий модифицирует JS на стороне клиента, или race condition между UI-блокировкой и backend-валидацией. Backend должен валидировать independent от UI — defense in depth"
        },
        {
          "id": "c",
          "text": "Невалидные переходы не существуют в State Transition"
        },
        {
          "id": "d",
          "text": "Нужно нарисовать диаграмму красивее"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: невалидные переходы тестируются через API напрямую.</strong> Это критическое понимание State Transition: UI-блокировки <em>недостаточно</em> для безопасности. Атакующий может: <em>(а)</em> модифицировать JS на стороне клиента и убрать UI-проверку; <em>(б)</em> вызвать API напрямую через Postman / curl, минуя UI; <em>(в)</em> поймать race condition между UI-блокировкой и backend-валидацией (200ms окна часто хватает). Backend должен валидировать <strong>independent от UI</strong> — это принцип defense in depth. На каждый невалидный переход в нашей диаграмме (Deleted → Active, Blocked → Suspended, Suspended → Active без timeout, и т.д.) пишем отдельный API-test через Postman: попытка сделать невалидный переход → ожидание 4xx или 403. Если получаем 200 OK — это критический security-баг. <strong>Опция 1</strong> упускает principle defense in depth. <strong>Опция 3</strong> неверна — невалидные переходы и есть основа security-тестирования State Transition. <strong>Опция 4</strong> мешает темы. На собесе junior, упомянувший «UI блокирует, но я обязательно проверю через API» — выглядит как middle."
    }
  },
  {
    "id": "MGT-06",
    "sprintId": "S05",
    "ord": 6,
    "type": "design",
    "priority": "P1",
    "title": "Pairwise — все пары значений вместо всех комбинаций",
    "estimateMin": 12,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю принцип Pairwise: покрытие всех пар значений параметров вместо всех комбинаций; большинство багов проявляются на парах"
      },
      {
        "id": "AC-02",
        "text": "Применяю Pairwise когда параметров много (5+) с независимыми значениями и полный перебор невозможен"
      },
      {
        "id": "AC-03",
        "text": "Не применяю Pairwise когда параметров мало (&lt;3), есть бизнес-правила между параметрами (Decision Table эффективнее), или критичны тройные взаимодействия"
      },
      {
        "id": "AC-04",
        "text": "Использую инструменты: PICT (CLI от Microsoft) или pairwise.yuuniworks.com (онлайн-генератор) для автоматической генерации таблицы"
      },
      {
        "id": "AC-05",
        "text": "Понимаю trade-off Pairwise: тройные взаимодействия не гарантированы, конкретные обязательные комбинации добавляю руками поверх Pairwise"
      },
      {
        "id": "AC-06",
        "text": "Выписываю constraints перед запуском инструмента (некоторые комбинации физически невозможны)"
      },
      {
        "id": "AC-07",
        "text": "Понимаю, что Pairwise — это стратегический уровень test-дизайна, не отменяет EP+BVA на отдельном поле или Decision Table на бизнес-правилах"
      },
      {
        "id": "AC-08",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ"
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "test-design"
    ],
    "quickCheck": {
      "id": "QC-MGT-06",
      "prompt": "Quick check",
      "question": "Junior тестирует регистрацию с 5 параметрами (тип счёта × валюта × план подписки × регион × promo code) — каждый по 4 значения. Полный перебор: 4⁵ = 1024 комбинации. В спринте на это 1 день. Что выбрать?",
      "options": [
        {
          "id": "a",
          "text": "Полный перебор всех 1024 — иначе не покроем"
        },
        {
          "id": "b",
          "text": "Pairwise через PICT / pairwise.yuuniworks.com — получим ~16 тестов вместо 1024 (сокращение в 60+ раз). Покроем все пары значений, но нужно учесть constraints (например, «promo code только для plan Premium»). Дополнительно — выбрать вручную 3-5 «обязательных» комбинаций (наиболее частые у клиентов) поверх Pairwise"
        },
        {
          "id": "c",
          "text": "Decision Table — 4⁵ = 1024 rules, но минимизация поможет"
        },
        {
          "id": "d",
          "text": "EP+BVA — этого достаточно"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: Pairwise через PICT с учётом constraints + 3-5 обязательных комбинаций руками.</strong> Это классический use case Pairwise: 5 параметров × 4 значения = 1024 полный перебор → ~16 pairwise-тестов покрывают все пары. Но junior должен <em>(а)</em> выписать constraints (некоторые комбинации физически невозможны или запрещены — promo code только для Premium, валюта зависит от региона); <em>(б)</em> поверх pairwise-сгенерированного набора добавить 3-5 «обязательных» комбинаций — самые частые сценарии у клиентов (например, «basic + USD + US + no promo» — типичный новый юзер). <strong>Опция 1</strong> — полный перебор невозможен в спринте. <strong>Опция 3</strong> — Decision Table эффективна для бизнес-правил, но 4⁵ = 1024 rules — это та же проблема, минимизация не поможет. <strong>Опция 4</strong> — EP+BVA на уровне отдельного поля (например, «значения promo code»), не на уровне комбинаций параметров. На собесе ответ через Pairwise + constraints + обязательные комбинации = подготовленный junior+."
    }
  },
  {
    "id": "MGT-07",
    "sprintId": "S05",
    "ord": 7,
    "type": "design",
    "priority": "P1",
    "title": "Use Case Testing — выводим Test Cases из Use Case структуры",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Понимаю различие Use Case as artifact (S04 T05) vs Use Case Testing as technique (S05 T07): artifact описывает требование, technique выводит из него тесты"
      },
      {
        "id": "AC-02",
        "text": "Применяю принцип «1 шаг Main Flow = 1+ TC»; «1 Alternate Flow = 1+ TC»; «1 Extension = 1+ TC»; итого ~20-25 TC из одного среднего UC"
      },
      {
        "id": "AC-03",
        "text": "Покрываю обязательно все три части Use Case — Main Flow (happy) + AF (валидные альтернативы) + Extensions (исключения / negative)"
      },
      {
        "id": "AC-04",
        "text": "Выполняю review UC перед началом Use Case Testing — если AF/Extensions не описаны, запрашиваю у PM полный UC либо предлагаю свой список и согласовываю"
      },
      {
        "id": "AC-05",
        "text": "Распознаю 3 анти-паттерна (только Main Flow / TC копирует UC без конкретики / UC без review) и знаю, как их фиксить"
      },
      {
        "id": "AC-06",
        "text": "Применяю Use Case Testing когда есть formal UC и фича — последовательность шагов; не применяю для маленьких фич без UC (EP+BVA) или бизнес-правил без шагов (Decision Table)"
      },
      {
        "id": "AC-07",
        "text": "Понимаю, что Use Case Testing — структурированное покрытие, но не заменяет exploratory: после Use Case TC провожу 30-мин exploratory-сессию для blind spots"
      },
      {
        "id": "AC-08",
        "text": "Разобрал(а) UC-RESET-001 на все 10 тест-кейсов в практике-декомпозиции (7 негативных)"
      },
      {
        "id": "AC-09",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ"
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "test-design",
      "requirements-analysis"
    ],
    "quickCheck": {
      "id": "QC-MGT-07",
      "prompt": "Quick check",
      "question": "QA получил Use Case «Reset Password» с Main Flow (5 шагов) и Postcondition («password reset email sent»). Alternate Flows и Extensions <em>не описаны</em>. Junior сразу пишет 5 TC по Main Flow и считает работу завершённой. Что не так?",
      "options": [
        {
          "id": "a",
          "text": "Всё правильно — Main Flow покрыт, этого хватит"
        },
        {
          "id": "b",
          "text": "АП-1 + АП-3: Main Flow покрывает только happy path; пропущены Alternate Flows (например, reset через SMS вместо email) и Extensions (rate limiting на повторные запросы, истёкшая ссылка, попытка reset для несуществующего email — security territory). Перед написанием TC junior должен запросить у PM полный UC с AF и Extensions либо предложить свой список и согласовать"
        },
        {
          "id": "c",
          "text": "Нужно использовать Decision Table"
        },
        {
          "id": "d",
          "text": "Reset Password — это не Use Case"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: АП-1 (только Main Flow) + АП-3 (UC принят без review).</strong> Reset Password — это типичная фича с <em>множеством</em> Alternate Flows и Extensions: AF-1 reset через SMS, AF-2 reset через security questions, AF-3 reset через biometric (на mobile); Extensions — rate limiting на повторные запросы (anti-bot), истёкшая ссылка (24h timeout), попытка reset для несуществующего email (security: показывать ту же страницу, чтобы не раскрывать, существует ли email), попытка использовать токен повторно. Без этих частей UC <em>неполный</em>, и junior должен <strong>либо запросить у PM</strong> расширенный UC, <strong>либо предложить свой список AF/Extensions</strong> на review. Писать TC только по Main Flow = пропустить security gaps. <strong>Опция 1</strong> — упускает security implications. <strong>Опция 3</strong> — Decision Table эффективна для бизнес-правил с комбинациями условий, но reset password — это user-journey, не таблица условий. <strong>Опция 4</strong> — reset password идеально подходит под Use Case (есть actor, шаги, alternate flows). На собесе junior, который начал бы с «Main Flow покрывает только идеальный путь, обязательно нужны AF и Extensions» — выглядит как middle."
    }
  },
  {
    "id": "MGT-08",
    "sprintId": "S05",
    "ord": 8,
    "type": "metrics",
    "priority": "P0",
    "title": "Метрики QA — 6 ключевых + Test Summary Report + GO/NO-GO",
    "estimateMin": 19,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю 6 ключевых метрик QA (Pass Rate / Test Coverage / Defect Density / DDP / Defect Leakage / Bug Reopen Rate), их формулы и benchmarks"
      },
      {
        "id": "AC-02",
        "text": "Считаю метрики после прогона тест-цикла, оформляю в Test Summary Report (1 страница)"
      },
      {
        "id": "AC-03",
        "text": "Применяю GO / GO-with-conditions / NO GO framework recommendation с конкретным обоснованием и минимумом для следующего GO"
      },
      {
        "id": "AC-04",
        "text": "Понимаю, что метрики смотрят <em>в связке</em> — одна метрика без контекста обманчива (Pass Rate 95% при Coverage 60% = NO GO)"
      },
      {
        "id": "AC-05",
        "text": "Знаю, что Defect Leakage считается через временное окно (1 неделя — критические, 1 месяц — major, 3 месяца — все)"
      },
      {
        "id": "AC-06",
        "text": "Распознаю 3 анти-паттерна (метрики для оценки людей / gaming метрик через KPI / одна метрика без контекста) и Goodhart's law"
      },
      {
        "id": "AC-07",
        "text": "Понимаю, что 6 метрик — это junior level; глубокие метрики (MTTD/MTTR, Cost of Quality, ROI) — отложены на S08+ scope"
      },
      {
        "id": "AC-08",
        "text": "Принял(а) все 5 решений в карусели «Твоё решение?», включая обе ловушки (зелёный Pass Rate при дыре покрытия · Critical за процентами)"
      },
      {
        "id": "AC-09",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ"
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "test-design",
      "istqb-knowledge"
    ],
    "quickCheck": {
      "id": "QC-MGT-08",
      "prompt": "Quick check",
      "question": "QA после прогона цикла видит: Pass Rate 95%, но Test Coverage 60%, выполнено 30 TC из 50, 1 Critical bug open. Junior пишет в Test Summary Report «GO — Pass Rate 95% выше benchmark». Что не так?",
      "options": [
        {
          "id": "a",
          "text": "Всё правильно — высокий Pass Rate говорит о готовности"
        },
        {
          "id": "b",
          "text": "АП-3 + критическая проблема: Pass Rate 95% обманчив без контекста — выполнено только 30 из 50 TC (Coverage 60% — далеко от benchmark 85%) и есть 1 Critical bug open. Это NO GO. Recommendation должна указывать минимум: закрытие Critical bug + поднятие Coverage до 85%+ через прогон оставшихся 20 TC + проверка Pass Rate после полного цикла"
        },
        {
          "id": "c",
          "text": "Нужно посчитать Defect Leakage"
        },
        {
          "id": "d",
          "text": "Bug Reopen Rate важнее"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: АП-3 «одна метрика без контекста» + Critical bug open → NO GO.</strong> Это классическая ловушка Pass Rate. 95% выглядит хорошо, но если выполнено только 30 из 50 TC, мы знаем результат только по 60% запланированного покрытия. <em>Что в оставшихся 20 TC?</em> Может быть, там лежат критические сценарии, которые провалятся. Junior должен <em>(а)</em> прогнать все 50 TC до считаемого Pass Rate; <em>(б)</em> закрыть Critical bug перед GO (1 Critical = blocker для релиза); <em>(в)</em> поднять Test Coverage до 85%+ benchmark; <em>(г)</em> только тогда писать GO recommendation. Это пример того, почему метрики смотрят <strong>в связке</strong>: Pass Rate + Coverage + Open Critical = полная картина. <strong>Опция 1</strong> — Pass Rate без Coverage обманчив. <strong>Опция 3</strong> — Defect Leakage не считается до релиза, для текущей recommendation не релевантно. <strong>Опция 4</strong> — Bug Reopen Rate важен, но не первая забота при 1 Critical open. На собесе junior, который ответил «Pass Rate 95% не значит готовность — давай посмотрим Coverage и Open bugs» — выглядит на уровне middle."
    }
  },
  {
    "id": "MGT-09",
    "sprintId": "S05",
    "ord": 9,
    "type": "ai",
    "priority": "P1",
    "title": "AI как ассистент тест-дизайна — 3 промпта (good/weak/dangerous)",
    "estimateMin": 14,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю 3 типа промптов: good (с конкретной спецификацией → корректный output), weak (нечёткая постановка → бесполезный generic), dangerous («всё сразу» без бизнес-правил → AI галлюцинирует)"
      },
      {
        "id": "AC-02",
        "text": "Применяю 3 правила работы с AI-output: сверь бизнес-правила со спецификацией / перепиши под свой продукт / отметь AI-assisted"
      },
      {
        "id": "AC-03",
        "text": "Понимаю AI calibration: AI силён в форме (EP/BVA-таблица, Decision Table 2^N), галлюцинирует на содержимом (бизнес-правила, точные сообщения, тестовые данные)"
      },
      {
        "id": "AC-04",
        "text": "На сложной фиче разбиваю запрос на части (Промпт A для EP, B для Decision Table, C для State Transition) с явной спецификацией для каждой"
      },
      {
        "id": "AC-05",
        "text": "Помечаю AI-assisted Test Cases в Description для прозрачности на code review"
      },
      {
        "id": "AC-06",
        "text": "Раскрыл(а) Quick check и подтвердил(а) правильный ответ"
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "test-design",
      "ai-workflow"
    ],
    "quickCheck": {
      "id": "QC-MGT-09",
      "prompt": "Quick check",
      "question": "Junior просит AI: «Сделай Decision Table для checkout с купоном, доставкой, налогами». AI выдаёт красивую таблицу 16×8 со ВСЕМИ комбинациями. Что junior обязан сделать ДО прогона тестов?",
      "options": [
        {
          "id": "a",
          "text": "Прогнать таблицу как есть — 16 комбинаций исчерпывающие, AI не ошибается на математике"
        },
        {
          "id": "b",
          "text": "Сократить до 4 строк — 16 слишком много, наверняка лишнее"
        },
        {
          "id": "c",
          "text": "Сверить бизнес-правила в каждой строке с PRD/PM (AI часто галлюцинирует на «купон до НДС или после», «доставка для VIP free или нет»), переписать формулировки под terminology своего продукта, отметить «AI-assisted» для code review"
        },
        {
          "id": "d",
          "text": "Удалить таблицу — Decision Table нельзя автоматизировать"
        }
      ],
      "answer": "c",
      "explanation": "Правильно: <strong>сверка → переписать → отметить</strong>. AI силён в <em>форме</em> (комбинаторика 2^N, структура таблицы) и галлюцинирует на <em>содержимом</em> (точные business rules: «купон применяется до или после налогов?», «free shipping для VIP с какого порога?»). Это AI calibration: используй AI для скелета, проверяй по своей спецификации. (a) — anti-pattern «слепое доверие»; цена ошибки в checkout = деньги. (b) — overcorrection: 16 строк это правильно для 4 binary условий, не «много». (d) — Decision Table это классическая техника тест-дизайна (ISTQB Ch.4.3), её НЕ удаляют, её адаптируют."
    }
  },
  {
    "id": "MGT-10",
    "sprintId": "S05",
    "ord": 10,
    "type": "lab",
    "priority": "P1",
    "title": "Practice Lab — 3 углублённых упражнения с разбором",
    "estimateMin": 8,
    "ac": [
      {
        "id": "AC-01",
        "text": "Понимаю, что 3 Lab упражнения — это углублённые разборы техник (EP+BVA / Decision Table / State Transition), отдельные от Mission и HW"
      },
      {
        "id": "AC-02",
        "text": "Понимаю, что карточка в этом тикете — обзор: само упражнение с разбором открывается в разделе Lab"
      },
      {
        "id": "AC-03",
        "text": "Понимаю связку HW (быстрая практика на typical случае) + Lab (углубленный разбор на edge case) — они дополняют, не дублируют"
      },
      {
        "id": "AC-04",
        "text": "Знаю, что Lab опционален — не блокирует Sprint Review; бейдж «Lab Rat» при ≥2 закрытых Lab"
      },
      {
        "id": "AC-05",
        "text": "Выбрал(а) первое Lab-упражнение и запланировал(а) на него 30-45 минут на этой неделе"
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "test-design"
    ]
  },
  {
    "id": "MGT-11",
    "sprintId": "S05",
    "ord": 11,
    "type": "master",
    "priority": "P0",
    "title": "Миссия · Спроектируй тесты для одной фичи end-to-end (4 техники + метрики)",
    "estimateMin": 30,
    "ac": [
      {
        "id": "AC-01",
        "text": "Выбрана одна фича на Atelier sandbox (не весь сайт), записан scope и обоснование выбора"
      },
      {
        "id": "AC-02",
        "text": "EP + BVA применены к минимум 2 полям фичи (с классами и 3-value boundaries по CTFL 4.0)"
      },
      {
        "id": "AC-03",
        "text": "Decision Table построена если применима (с минимизацией) ИЛИ обоснованно «не применима»"
      },
      {
        "id": "AC-04",
        "text": "State Transition построена если применима (валидные + невалидные переходы) ИЛИ обоснованно «не применима»"
      },
      {
        "id": "AC-05",
        "text": "8-15 Test Cases прогнаны на Atelier sandbox, результаты записаны (PASS/FAIL + комментарий)"
      },
      {
        "id": "AC-06",
        "text": "1 Bug Report по шаблону S04 T06 (12 полей, включая Title по формуле и Business Impact). Если багов не нашёл — гипотетический BR с пометкой"
      },
      {
        "id": "AC-07",
        "text": "4 метрики (Pass Rate / Test Coverage / Bug Reopen Rate / Defect Density для фичи) посчитаны с интерпретацией"
      },
      {
        "id": "AC-08",
        "text": "Mini Test Summary Report на 1 страницу с GO/NO-GO recommendation"
      },
      {
        "id": "AC-09",
        "text": "AI-сравнение записано (что AI заметил → я пропустил, и наоборот)"
      },
      {
        "id": "AC-10",
        "text": "Все артефакты сохранены в Дневнике тестировщика как single coherent документ для портфолио"
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "test-design",
      "ai-workflow",
      "istqb-knowledge"
    ]
  },
  {
    "id": "CTFL-01",
    "sprintId": "S06",
    "ord": 1,
    "type": "docs",
    "priority": "P0",
    "title": "Карта силлабуса CTFL 4.0 — 6 глав, 5 из них ты уже прошёл",
    "estimateMin": 15,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю 6 глав syllabus 4.0 и могу назвать тему каждой"
      },
      {
        "id": "AC-02",
        "text": "Помню в каком Sprint 01-05 закрылась каждая основная глава (Ch.1-Ch.5)"
      },
      {
        "id": "AC-03",
        "text": "Помню процентное распределение вопросов на экзамене по главам (Ch.1 10% · Ch.2 25% · Ch.3 10% · Ch.4 25% · Ch.5 25% · Ch.6 5%)"
      },
      {
        "id": "AC-04",
        "text": "Знаю 6 категорий инструментов Ch.6 и могу привести минимум 2 примера в каждой"
      },
      {
        "id": "AC-05",
        "text": "Понимаю 3 оси classification (область / intrusive vs non-intrusive / open-source vs commercial)"
      },
      {
        "id": "AC-06",
        "text": "Quick check раскрыт, правильный ответ подтверждён"
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "istqb-knowledge"
    ],
    "quickCheck": {
      "id": "QC-CTFL-01",
      "prompt": "Quick check",
      "question": "PM попросил протестировать форму бронирования отеля: даты check-in / check-out, количество гостей (1-10), тип номера (Standard/Deluxe/Suite), есть ли промокод (да/нет). Какая комбинация техник лучше всего покроет фичу?",
      "options": [
        {
          "id": "a",
          "text": "Pairwise — единственный способ, потому что много параметров"
        },
        {
          "id": "b",
          "text": "Только EP — это поля ввода, остальные техники не нужны"
        },
        {
          "id": "c",
          "text": "EP + BVA для каждого поля + Decision Table для правил «есть промокод × тип номера → итоговая цена» (если правила есть) + State Transition если у бронирования есть статусы (Created → Confirmed → Cancelled)"
        },
        {
          "id": "d",
          "text": "White-box техники — нужно проверить покрытие кода"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: EP + BVA + Decision Table + State Transition в комбинации.</strong> Это типичная задача с несколькими «природами»: поля ввода (даты, гости — для них <strong>EP+BVA</strong>: классы валидно/невалидно, граничные значения 1, 10, 11 для гостей), бизнес-правила (промокод × тип номера → цена — для них <strong>Decision Table</strong>: 4 комбинации, expected result для каждой), состояния (Created → Confirmed → Cancelled — <strong>State Transition</strong>: валидные + невалидные переходы). <strong>Опция 2</strong> — слишком узкая, упускает Decision Table и State Transition. <strong>Опция 1</strong> — Pairwise здесь избыточен: параметров не настолько много, чтобы полный перебор был невозможен; EP+BVA по полям уже сократит. <strong>Опция 4</strong> — White-box не для junior QA на manual-фичах, это unit-тесты разработчика. На собесе ответ через комбинацию техник демонстрирует, что junior понимает, как разные техники дополняют друг друга, а не выбирает одну."
    }
  },
  {
    "id": "CTFL-02",
    "sprintId": "S06",
    "ord": 2,
    "type": "master",
    "priority": "P0",
    "title": "Глоссарий 199 терминов — словарный фундамент экзамена и тренажёр",
    "estimateMin": 25,
    "ac": [
      {
        "id": "AC-01",
        "text": "Помню определения и K-level максимум для всех 199 терминов Block 1; могу за 30 секунд дать определение любого из 7 confusing pairs (Severity vs Priority · Verification vs Validation · Smoke vs Sanity · Re-testing vs Regression · Defect vs Bug vs Failure · Inspection vs Walkthrough · EP vs BVA)"
      },
      {
        "id": "AC-02",
        "text": "Понимаю K-level distinction: K1 (recall, ≤30 сек ответ), K2 (understand, ≤90 сек), K3 (apply, ≤2.5 мин)"
      },
      {
        "id": "AC-03",
        "text": "Глоссарий-тренажёр пройден минимум 1 раз по всем терминам; карточек «не помню» ≤20 на старте Mock #1"
      },
      {
        "id": "AC-04",
        "text": "Знаю распределение терминов с тегом главы: 24 Ch.1 + 38 Ch.2 + 19 Ch.3 + 21 Ch.4 + 27 Ch.5 + 17 Ch.6 (146 экзамен-привязанных) + 53 общих/курсовых = 199 терминов Block 1"
      },
      {
        "id": "AC-05",
        "text": "Quick check раскрыт, правильный ответ подтверждён"
      }
    ],
    "istqb": [
      "CTFL-Ch1"
    ],
    "skills": [
      "istqb-knowledge"
    ],
    "quickCheck": {
      "id": "QC-CTFL-02",
      "prompt": "Quick check",
      "question": "QA пишет EP для поля «Имя пользователя» (валидно: 3-20 символов, латиница + цифры, без спецсимволов). Junior выдаёт 2 класса: «valid: 3-20 символов» и «invalid: всё остальное». Что не так?",
      "options": [
        {
          "id": "a",
          "text": "Анти-паттерн АП-2: один класс «invalid» — слишком grubo. Нужно разбить invalid по природе: длина &lt; 3 / длина &gt; 20 / спецсимволы / кириллица / пустое поле — каждое со своим ожидаемым сообщением. Получится 5-6 классов, не 2"
        },
        {
          "id": "b",
          "text": "Нужно нарисовать диаграмму"
        },
        {
          "id": "c",
          "text": "Всё правильно — EP это два класса (valid и invalid)"
        },
        {
          "id": "d",
          "text": "Нужно добавить BVA — без него EP не работает"
        }
      ],
      "answer": "a",
      "explanation": "<strong>Правильно: анти-паттерн АП-2 «один класс invalid».</strong> Корректное EP разбивает invalid на под-классы по природе ошибки: <em>длина &lt; 3</em> → сообщение «Слишком короткое имя»; <em>длина &gt; 20</em> → «Слишком длинное имя»; <em>содержит спецсимволы</em> (@, !, $) → «Только латиница и цифры»; <em>содержит кириллицу</em> (Иван) → «Только латиница и цифры» (либо отдельное сообщение); <em>пустое поле</em> → «Поле обязательно». Поведение системы на каждом из этих классов <strong>разное</strong>: разные сообщения, разная локализация, разная валидация (UI vs backend). Один тест-представитель из каждого класса = 5-6 тестов вместо 2. <strong>Опция 3</strong> — слишком grubo, упускает разнообразие невалидных вариантов. <strong>Опция 4</strong> — про BVA правильно, но это отдельный шаг (T03), не «причина что не так с EP». <strong>Опция 2</strong> — диаграмма не обязательна для EP, таблица вполне хватает. На собесе разделение invalid на под-классы — признак подготовленного junior'а."
    }
  },
  {
    "id": "CTFL-03",
    "sprintId": "S06",
    "ord": 3,
    "type": "exam",
    "priority": "P0",
    "title": "Mock Exam #1 — первая проверка готовности · 40 вопросов · 60 минут",
    "estimateMin": 60,
    "ac": [
      {
        "id": "AC-01",
        "text": "Mock #1 пройден за ≤60 минут без перерывов (таймер можно скрыть, но не остановить)"
      },
      {
        "id": "AC-02",
        "text": "Score ≥26/40 (65%) → переход к T04 Стратегия + T05 AI-повторение (по желанию) + T06 Mission"
      },
      {
        "id": "AC-03",
        "text": "Score &lt;26/40 → T05 AI-помощник строит план точечного повторения; пересдача Mock #1 без штрафа и без лимита попыток"
      },
      {
        "id": "AC-04",
        "text": "Объяснения всех неправильных ответов прочитаны (в разборе включи фильтр «только ошибки»), угаданных 50/50 — тоже"
      },
      {
        "id": "AC-05",
        "text": "Понимаю распределение результата по 6 главам и 3 K-уровням — выявлены свои 2-3 слабые главы для повторения"
      },
      {
        "id": "AC-06",
        "text": "Применяю flowchart решения вопроса из T04 (stem → trap-сигналы → 4 опции → уверен? → выбор/флаг)"
      }
    ],
    "istqb": [
      "CTFL-Ch1",
      "CTFL-Ch3",
      "CTFL-Ch4",
      "CTFL-Ch5"
    ],
    "skills": [
      "istqb-knowledge"
    ],
    "quickCheck": {
      "id": "QC-CTFL-03",
      "prompt": "Quick check",
      "question": "QA пишет BVA для поля «Возраст» (18-65). Junior выдаёт 4 теста — 17, 18, 65, 66 — и называет это «3-value BVA». Что не так по CTFL 4.0?",
      "options": [
        {
          "id": "a",
          "text": "Нужно тестировать только 18 и 65 — это и есть 3-value"
        },
        {
          "id": "b",
          "text": "BVA не нужен, хватит EP"
        },
        {
          "id": "c",
          "text": "Названо верно — 4 значения это 3-value BVA"
        },
        {
          "id": "d",
          "text": "Это 2-value BVA: граница + ближайший сосед из соседнего класса. В 3-value у каждой границы ТРИ точки — добавились бы 19 и 64, итого 6 тестов. Обе версии равноправны в силлабусе 4.0 — в вопросе экзамена всегда сказано, какая нужна"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: набор 17-18-65-66 — это 2-value BVA, а не 3-value.</strong> Силлабус 4.0 описывает <em>обе</em> версии техники как равноправные: <strong>2-value</strong> — граница и её ближайший сосед из соседнего класса (для 18-65 это 17, 18, 65, 66 — ровно набор junior'а); <strong>3-value</strong> — граница и ОБА соседа (добавляются 19 и 64, итого 6 тестов). 3-value строже: ловит дефекты типа «if (x = 10)» вместо «if (x ≤ 10)», которые 2-value пропустит. Ловушка экзамена не в том, «какая версия правильная», а в чтении вопроса: <em>в задании всегда указано, какую BVA применить</em> — посчитай точки покрытия той версии, которую просят. <strong>Опция 3</strong> неверна — название перепутано. <strong>Опция 1</strong> — только сами границы не дают 100% покрытия ни в одной версии. <strong>Опция 2</strong> мешает техники — EP даёт классы, BVA проверяет их границы; они дополняют друг друга."
    }
  },
  {
    "id": "CTFL-04",
    "sprintId": "S06",
    "ord": 4,
    "type": "docs",
    "priority": "P1",
    "title": "Стратегия экзамена — тайминг, 6 типовых ловушек, чек-лист",
    "estimateMin": 15,
    "ac": [
      {
        "id": "AC-01",
        "text": "Помню тайминг: 60 мин ÷ 40 Q = 1.5 мин/вопрос; first pass ~50 мин, last-pass review ~7-10 мин"
      },
      {
        "id": "AC-02",
        "text": "Знаю 6 типовых traps в формулировках и могу привести пример каждого: двойные отрицания · all-of-the-above · near-miss · K-level confusion · абсолюты · BEST/MOST"
      },
      {
        "id": "AC-03",
        "text": "Различаю K1/K2/K3 в формулировке вопроса (recall · understand · apply)"
      },
      {
        "id": "AC-04",
        "text": "Помню правило: никогда не оставлять пустые ответы (25% expected value &gt; 0%)"
      },
      {
        "id": "AC-05",
        "text": "Применяю flowchart решения за 10-15 секунд на каждом вопросе (stem → trap-сигналы → 4 опции → уверен? → выбор/флаг)"
      },
      {
        "id": "AC-06",
        "text": "Quick check раскрыт, правильный ответ подтверждён"
      },
      {
        "id": "AC-07",
        "text": "Знаю правило «на экзамене — по силлабусу, на собесе — по контексту, в работе — по команде» и могу назвать 3 места, где канон спорит с практикой"
      }
    ],
    "istqb": [
      "CTFL-Ch1"
    ],
    "skills": [
      "istqb-knowledge"
    ],
    "quickCheck": {
      "id": "QC-CTFL-04",
      "prompt": "Quick check",
      "question": "Junior строит Decision Table для расчёта скидки в e-commerce: 3 условия (VIP / промокод / сумма &gt; 5000 ₽). Получает 8 rules. Не минимизирует, не помечает Reachability, при множественной скидке (VIP + промокод + большая сумма) самостоятельно решает: «применяем максимальную одну». Пишет 8 Test Cases. Что не так?",
      "options": [
        {
          "id": "a",
          "text": "Всё правильно — 8 rules → 8 TC"
        },
        {
          "id": "b",
          "text": "Сразу 3 проблемы: (а) отсутствует минимизация — часть rules может давать одинаковую скидку; (б) приоритезация при множественной скидке не согласована с PM (бизнес-правило: суммируются ли скидки или применяется максимальная?); (в) Reachability не проверена"
        },
        {
          "id": "c",
          "text": "Нужно сделать 16 rules — junior пропустил половину"
        },
        {
          "id": "d",
          "text": "Decision Table не подходит для скидок, нужно использовать EP"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: 3 проблемы — отсутствует минимизация, не согласована приоритезация, не проверена Reachability.</strong> На скидках классическая ловушка — это <em>правила суммирования</em>. PM может решить: «скидки суммируются» (VIP 10% + промокод 5% + большая сумма 5% = 20%), либо «применяется максимальная» (max из VIP / промокод / сумма), либо «применяется фиксированная при сочетании» (VIP + промокод = 15% независимо от ставок). Junior, который сам выбрал «максимальная одна», будет тестировать <em>не то поведение</em>, что в проде. <strong>Опция 1</strong> упускает все 3 проблемы. <strong>Опция 3</strong> — 8 rules для 3 условий правильно (2³ = 8). <strong>Опция 4</strong> — Decision Table идеально для скидок (бизнес-правила с комбинациями условий — её основной use case)."
    }
  },
  {
    "id": "CTFL-05",
    "sprintId": "S06",
    "ord": 5,
    "type": "ai",
    "priority": "P1",
    "title": "AI-помощник для повторения после Mock #1 — 3 промпта-эталона",
    "estimateMin": 15,
    "ac": [
      {
        "id": "AC-01",
        "text": "Первый план повторения сгенерирован по Промпту 1 на основе реального результата Mock #1 (или на «допустим у меня было…», если Mock #1 ещё впереди)"
      },
      {
        "id": "AC-02",
        "text": "Промпт 2 применён минимум к 1 конкретной ошибке Mock #1 (не «вообще Ch.4», а КОНКРЕТНАЯ тема провала)"
      },
      {
        "id": "AC-03",
        "text": "Мини-мок из 4-8 вопросов по Промпту 3 сгенерирован на свои 2-3 слабые темы — прорешан, объяснения сверены"
      },
      {
        "id": "AC-04",
        "text": "Quick check раскрыт, правильный ответ подтверждён + понимаешь 4 ограничения AI из блока «Внимание»"
      },
      {
        "id": "AC-05",
        "text": "При сомнении в AI-ответе на confusing pair (severity vs priority, validation vs verification, smoke vs sanity) — открывай <a href=\"https://glossary.istqb.org/\">glossary.istqb.org</a> для проверки (минимум 1 раз за сессию)"
      },
      {
        "id": "AC-06",
        "text": "Понимаю, что AI study-buddy ≠ examination-cheat: AI помогает планировать, я отвечаю за факты и решения"
      }
    ],
    "istqb": [
      "CTFL-Ch1"
    ],
    "skills": [
      "istqb-knowledge",
      "ai-workflow"
    ],
    "quickCheck": {
      "id": "QC-CTFL-05",
      "prompt": "Quick check",
      "question": "Junior рисует State Transition диаграмму для аккаунта (Active / Suspended / Blocked / Deleted), выписывает 6 валидных переходов и пишет 6 TC. На вопрос про невалидные переходы говорит: «они не нужны, потому что UI не позволяет их сделать». Что не так?",
      "options": [
        {
          "id": "a",
          "text": "Невалидные переходы не существуют в State Transition"
        },
        {
          "id": "b",
          "text": "Нужно нарисовать диаграмму красивее"
        },
        {
          "id": "c",
          "text": "Невалидные переходы обязательно тестируются через прямой API (Postman / curl), потому что UI можно обойти: атакующий модифицирует JS на стороне клиента, или race condition между UI-блокировкой и backend-валидацией. Backend должен валидировать independent от UI — defense in depth"
        },
        {
          "id": "d",
          "text": "Всё правильно — UI блокирует невалидные переходы"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: невалидные переходы тестируются через API напрямую.</strong> Это критическое понимание State Transition: UI-блокировки <em>недостаточно</em> для безопасности. Атакующий может: <em>(а)</em> модифицировать JS на стороне клиента и убрать UI-проверку; <em>(б)</em> вызвать API напрямую через Postman / curl, минуя UI; <em>(в)</em> поймать race condition между UI-блокировкой и backend-валидацией (200ms окна часто хватает). Backend должен валидировать <strong>independent от UI</strong> — это принцип defense in depth. На каждый невалидный переход в нашей диаграмме (Deleted → Active, Blocked → Suspended, Suspended → Active без timeout, и т.д.) пишем отдельный API-test через Postman: попытка сделать невалидный переход → ожидание 4xx или 403. Если получаем 200 OK — это критический security-баг. <strong>Опция 4</strong> упускает principle defense in depth. <strong>Опция 1</strong> неверна — невалидные переходы и есть основа security-тестирования State Transition. <strong>Опция 2</strong> мешает темы. На собесе junior, упомянувший «UI блокирует, но я обязательно проверю через API» — выглядит как middle."
    }
  },
  {
    "id": "CTFL-06",
    "sprintId": "S06",
    "ord": 6,
    "type": "mission",
    "priority": "P0",
    "title": "Mock Exam #2 и регистрация на экзамен — финальный гейт спринта",
    "estimateMin": 90,
    "ac": [
      {
        "id": "AC-01",
        "text": "Mock #2 пройден за ≤60 минут без перерывов"
      },
      {
        "id": "AC-02",
        "text": "Score ≥28/40 (70%) → бейдж «Exam-Ready» открывается, дальше — выбор board и регистрация"
      },
      {
        "id": "AC-03",
        "text": "Score &lt;28/40 → пересдача того же Mock #2 без ограничения попыток (перед пересдачей — разбор ошибок и точечное повторение)"
      },
      {
        "id": "AC-04",
        "text": "Гид по 13 странам прочитан, свой board выбран по правилам из разведки (где живёшь — там и сдаёшь + cross-border случай)"
      },
      {
        "id": "AC-05",
        "text": "Пробная регистрация на сайте своего board пройдена до экрана подтверждения БЕЗ оплаты — в дневнике минимум 3 наблюдения «что узнаёшь заранее»"
      },
      {
        "id": "AC-06",
        "text": "Понимаю формат экзамена своего board (online proctored или тест-центр) и какие документы нужны"
      }
    ],
    "istqb": [
      "CTFL-Ch1"
    ],
    "skills": [
      "istqb-knowledge"
    ],
    "quickCheck": {
      "id": "QC-CTFL-06",
      "prompt": "Quick check",
      "question": "Junior тестирует регистрацию с 5 параметрами (тип счёта × валюта × план подписки × регион × promo code) — каждый по 4 значения. Полный перебор: 4⁵ = 1024 комбинации. В спринте на это 1 день. Что выбрать?",
      "options": [
        {
          "id": "a",
          "text": "Pairwise через PICT / pairwise.yuuniworks.com — получим ~16 тестов вместо 1024 (сокращение в 60+ раз). Покроем все пары значений, но нужно учесть constraints (например, «promo code только для plan Premium»). Дополнительно — выбрать вручную 3-5 «обязательных» комбинаций (наиболее частые у клиентов) поверх Pairwise"
        },
        {
          "id": "b",
          "text": "Полный перебор всех 1024 — иначе не покроем"
        },
        {
          "id": "c",
          "text": "Decision Table — 4⁵ = 1024 rules, но минимизация поможет"
        },
        {
          "id": "d",
          "text": "EP+BVA — этого достаточно"
        }
      ],
      "answer": "a",
      "explanation": "<strong>Правильно: Pairwise через PICT с учётом constraints + 3-5 обязательных комбинаций руками.</strong> Это классический use case Pairwise: 5 параметров × 4 значения = 1024 полный перебор → ~16 pairwise-тестов покрывают все пары. Но junior должен <em>(а)</em> выписать constraints (некоторые комбинации физически невозможны или запрещены — promo code только для Premium, валюта зависит от региона); <em>(б)</em> поверх pairwise-сгенерированного набора добавить 3-5 «обязательных» комбинаций — самые частые сценарии у клиентов (например, «basic + USD + US + no promo» — типичный новый юзер). <strong>Опция 2</strong> — полный перебор невозможен в спринте. <strong>Опция 3</strong> — Decision Table эффективна для бизнес-правил, но 4⁵ = 1024 rules — это та же проблема, минимизация не поможет. <strong>Опция 4</strong> — EP+BVA на уровне отдельного поля (например, «значения promo code»), не на уровне комбинаций параметров. На собесе ответ через Pairwise + constraints + обязательные комбинации = подготовленный junior+."
    }
  },
  {
    "id": "BUG-01",
    "sprintId": "S07",
    "ord": 1,
    "type": "docs",
    "priority": "P0",
    "title": "Severity vs Priority — кто что определяет, и как они вместе работают",
    "estimateMin": 20,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю **Severity** (техническое влияние · ставит QA) и **Priority** (бизнес-срочность · ставит PM/PO) и могу объяснить, почему они независимы."
      },
      {
        "id": "AC-02",
        "text": "Привожу **минимум 2 примера** независимости: Critical+Low (граничный случай) · Trivial+High (опечатка перед PR)."
      },
      {
        "id": "AC-03",
        "text": "Применяю **4-уровневые шкалы** (Critical/Major/Minor/Trivial · P0/P1/P2/P3 · или Urgent/High/Medium/Low в Linear) для конкретного баг-сценария."
      },
      {
        "id": "AC-04",
        "text": "Помню, что **Severity ставит QA, Priority ставит PM/PO** · и калибровка происходит на triage meeting."
      },
      {
        "id": "AC-05",
        "text": "Распознаю **анти-паттерн «матрица как автоматическая связь»** — Critical не означает автоматически P0."
      },
      {
        "id": "AC-06",
        "text": "Прохожу Quick check и подтверждаю правильный ответ."
      },
      {
        "id": "AC-07",
        "text": "Прохожу калибровку «Откалибруй баг»: **4 кейса по двум осям**, включая пары Trivial+P1 и Critical+P3 — и помню, кто отвечает за каждую ось."
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "Test Documentation",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-BUG-01",
      "prompt": "Quick check",
      "question": "QA нашла баг: на странице «Условия использования» (Terms & Conditions · юридический раздел) опечатка: «правала» вместо «правила». До запуска маркетинговой кампании 2 дня. Какие Severity и Priority?",
      "options": [
        {
          "id": "a",
          "text": "Severity Critical · Priority P0 (юридический документ нельзя выпускать с опечаткой)"
        },
        {
          "id": "b",
          "text": "Severity Trivial · Priority P1 (опечатка = Trivial технически, но юр-влияние + кампания делают P1)"
        },
        {
          "id": "c",
          "text": "Severity Trivial · Priority P3 (опечатка незаметная, кампания не блокируется)"
        },
        {
          "id": "d",
          "text": "Severity Major · Priority P2 (юр-документ — Major по определению)"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: Severity Trivial · Priority P1.</strong> Severity = техническая сторона: опечатка не сломала функциональность, ничего не упало → Trivial (косметика). Priority = бизнес-сторона: юридический документ + маркетинговая кампания через 2 дня + имидж бренда — это P1 High (нужно в этом релизе). Это классический пример Trivial+High = «технически мелочь, но бизнес-важно». Вариант 1 — Severity не Critical (ничего не сломано). Вариант 3 — недооценка бизнес-влияния (кампания + юр-аспект). Вариант 4 — Severity не Major (опечатка не вредит функциональности)."
    }
  },
  {
    "id": "BUG-02",
    "sprintId": "S07",
    "ord": 2,
    "type": "docs",
    "priority": "P0",
    "title": "Bug Lifecycle — что происходит с багом от появления до закрытия",
    "estimateMin": 23,
    "ac": [
      {
        "id": "AC-01",
        "text": "Перечисляю **6 основных состояний** (NEW · OPEN · IN_PROGRESS · RESOLVED · VERIFIED · CLOSED) с владельцем (кто двигает) и триггером (что должно произойти) каждого."
      },
      {
        "id": "AC-02",
        "text": "Знаю **5 краевых состояний** (REOPENED · DEFERRED · DUPLICATE · NOT_A_BUG · CANNOT_REPRODUCE) и когда каждое использовать."
      },
      {
        "id": "AC-03",
        "text": "Различаю **RESOLVED vs CLOSED** · RESOLVED = код merged, ждёт верификации · CLOSED = после релиза."
      },
      {
        "id": "AC-04",
        "text": "Применяю lifecycle к **сквозному примеру** (баг «кэшбэк не списался» от NEW до CLOSED)."
      },
      {
        "id": "AC-05",
        "text": "Распознаю **анти-паттерн «баг застрял в RESOLVED»** · привычка ежедневно проверять что ждёт верификации."
      },
      {
        "id": "AC-06",
        "text": "Прохожу Quick check и подтверждаю правильный ответ."
      },
      {
        "id": "AC-07",
        "text": "Собираю **happy-путь из 6 состояний** в цепочке и раскладываю **5 triage-ситуаций** по краевым состояниям (DEFERRED vs NOT_A_BUG — не путаю)."
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-BUG-02",
      "prompt": "Quick check",
      "question": "Dev назначил себе баг, написал в комментарии «починил, merged в master». В каком состоянии теперь баг?",
      "options": [
        {
          "id": "a",
          "text": "CLOSED — Dev починил, всё готово"
        },
        {
          "id": "b",
          "text": "VERIFIED — Dev сказал «починил», значит работает"
        },
        {
          "id": "c",
          "text": "IN_PROGRESS — пока не выкатили в prod, всё ещё «в работе»"
        },
        {
          "id": "d",
          "text": "RESOLVED — код merged, но ждёт QA-верификации до закрытия"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: RESOLVED.</strong> Dev починил код, merged — это значит фикс готов, но <em>ещё не подтверждён QA</em>. Состояние RESOLVED именно для этого: «со стороны кода готово, ждёт верификации». QA проверит на билде с фиксом, и если работает — двинет в VERIFIED. Если не работает — REOPENED. <strong>CLOSED</strong> — это после релиза + мониторинга (закрывается обычно QA Lead). <strong>VERIFIED</strong> — только после действия QA, не «Dev сказал». <strong>IN_PROGRESS</strong> — пока Dev пишет код, не после merge. Запомни: <em>«я починил» от Dev'а = RESOLVED, не CLOSED. QA должна верифицировать.</em>"
    }
  },
  {
    "id": "BUG-03",
    "sprintId": "S07",
    "ord": 3,
    "type": "docs",
    "priority": "P0",
    "title": "Bug Report 2.0 — анатомия из S04 + шесть новых полей",
    "estimateMin": 21,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю **6 новых полей** сверх базы S04: Environment · Frequency · Build · Business Impact · Pre-conditions · Attachments."
      },
      {
        "id": "AC-02",
        "text": "Понимаю, **зачем каждое поле** — каждое идёт из конкретного наблюдения (Где? · Как часто? · Какая версия? · Почему важно? · Какое состояние до? · Какие доказательства?)."
      },
      {
        "id": "AC-03",
        "text": "Различаю **Pre-conditions vs Steps** · Pre-conditions = состояние, Steps = действия."
      },
      {
        "id": "AC-04",
        "text": "Знаю **анти-паттерны** (Environment только «Production» · Frequency «иногда» без чисел · Build «Latest» · Business Impact «Important» без специфики)."
      },
      {
        "id": "AC-05",
        "text": "Помню **математику времени:** 5 минут на 6 полей × 100 багов = 8-12 часов QA-усилий, экономит 50 часов Dev-усилий = чистый выигрыш команды."
      },
      {
        "id": "AC-06",
        "text": "Прохожу Quick check и подтверждаю правильный ответ."
      },
      {
        "id": "AC-07",
        "text": "Прохожу **живой ENG-201** по всем 11 полям шаблона (+ бонусное Linked issues) с подсказками «зачем» и сравниваю со своим первым BR из S04 (запись в Журнал)."
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "Test Documentation"
    ],
    "quickCheck": {
      "id": "QC-BUG-03",
      "prompt": "Quick check",
      "question": "QA пишет баг-репорт. В Steps указала «Логин и проверить cashback». В каком поле должно быть указано, что у пользователя должен быть cashback_balance &gt; 0 для воспроизведения?",
      "options": [
        {
          "id": "a",
          "text": "В Pre-conditions — это условие <em>до</em> Steps, не часть самих шагов"
        },
        {
          "id": "b",
          "text": "В Steps to Reproduce — это шаг 0"
        },
        {
          "id": "c",
          "text": "В Environment — это часть пользовательского окружения"
        },
        {
          "id": "d",
          "text": "В Title — это контекст для всего бага"
        }
      ],
      "answer": "a",
      "explanation": "<strong>Правильно: в Pre-conditions.</strong> Pre-conditions — это всё, что должно быть истинным <em>до</em> запуска Steps to Reproduce. «У пользователя есть cashback_balance &gt; 0» — типичное pre-condition. Это <em>не шаг</em> (не действие, которое QA выполняет при воспроизведении) — это <em>состояние</em>, в котором система должна быть. Вариант 1 (Steps) — анти-паттерн: смешивает состояние и действия. Вариант 3 (Environment) — Environment про ОС/браузер/сеть, не про состояние данных пользователя. Вариант 4 (Title) — слишком широко, Title только «что+где+когда». Запомни: <em>Pre-conditions = состояние · Steps = действия</em>."
    }
  },
  {
    "id": "BUG-04",
    "sprintId": "S07",
    "ord": 4,
    "type": "docs",
    "priority": "P0",
    "title": "Искусство воспроизведения — качество шагов и плавающие баги",
    "estimateMin": 20,
    "ac": [
      {
        "id": "AC-01",
        "text": "Применяю **3 принципа хороших шагов**: атомарность · проверяемость · контекстность."
      },
      {
        "id": "AC-02",
        "text": "Различаю **плохие шаги** (слепленные действия, без проверяемых состояний) и **хорошие шаги** (один глагол на шаг + проверяемые состояния + URL/контекст страницы)."
      },
      {
        "id": "AC-03",
        "text": "Применяю **шкалу частоты** · Always / Sometimes (X из Y) / Rarely / Once · с конкретными числами вместо «иногда»."
      },
      {
        "id": "AC-04",
        "text": "Знаю **5 приёмов для нестабильных багов**: поиск паттерна · запись видео · серверная корреляция · не отбрасывать once-баги · охота на race conditions."
      },
      {
        "id": "AC-05",
        "text": "Помню **правило количества шагов** · &gt;15 шагов = декомпозировать в 2-3 отдельных бага."
      },
      {
        "id": "AC-06",
        "text": "Прохожу Quick check и подтверждаю правильный ответ."
      },
      {
        "id": "AC-07",
        "text": "Чиню **4 сломанных шага** в repair-практике — atomic · verifiable · contextual на репорте, который Dev вернул."
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "Test Documentation"
    ],
    "quickCheck": {
      "id": "QC-BUG-04",
      "prompt": "Quick check",
      "question": "Какой шаг нарушает принцип атомарности?",
      "options": [
        {
          "id": "a",
          "text": "«1. Перейти на /login»"
        },
        {
          "id": "b",
          "text": "«1. Ввести email «test@example.com» в поле Email · 2. Ввести пароль «TestPass» в поле Password · 3. Кликнуть Submit»"
        },
        {
          "id": "c",
          "text": "«1. Залогиниться как premium-пользователь, добавить товар в корзину, перейти на checkout и применить промокод»"
        },
        {
          "id": "d",
          "text": "«1. Кликнуть кнопку «В корзину» на странице товара»"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: вариант 3.</strong> «Залогиниться + добавить в корзину + перейти на checkout + применить промокод» — это <em>четыре действия</em>, слепленных в один шаг. Принцип атомарности нарушен. Это нужно разбить минимум на 4 шага (а лучше на 6-8 с проверяемыми промежуточными состояниями). Вариант 1 — атомарно (1 действие). Вариант 2 — атомарно (3 шага, каждый — одно действие). Вариант 4 — атомарно (1 действие). Запомни: <em>один шаг = один глагол (открыть / ввести / кликнуть / проверить)</em>."
    }
  },
  {
    "id": "BUG-05",
    "sprintId": "S07",
    "ord": 5,
    "type": "docs",
    "priority": "P0",
    "title": "Evidence — доказательства бага: скриншоты, видео, DevTools, логи",
    "estimateMin": 22,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю **5 типов доказательств** (скриншоты · видео · DevTools Console · Network HAR · логи сервера) и когда применять каждый."
      },
      {
        "id": "AC-02",
        "text": "Применяю **принцип пропорциональности** · простая опечатка = 1 скриншот · функциональный баг = скриншот + HAR · SQL-баг = + query · НЕ overkill, НЕ underkill."
      },
      {
        "id": "AC-03",
        "text": "Знаю **вкладки DevTools** · Network / Console / Application / Performance / Sources — что в каждой и когда смотреть."
      },
      {
        "id": "AC-04",
        "text": "Помню **маскировку PII** · перед прикреплением лога — заменить пароли / токены / персональные данные на `***`."
      },
      {
        "id": "AC-05",
        "text": "Применяю **cross-link к S08 T08** · после SQL-investigation query + результаты = готовое доказательство для баг-репорта."
      },
      {
        "id": "AC-06",
        "text": "Прохожу Quick check и подтверждаю правильный ответ."
      },
      {
        "id": "AC-07",
        "text": "Подбираю **главный evidence** для 5 багов в карусели — по сигналу из описания (скриншот / видео / HAR / logs / console)."
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "Test Documentation",
      "Workspace Tools"
    ],
    "quickCheck": {
      "id": "QC-BUG-05",
      "prompt": "Quick check",
      "question": "QA расследует нестабильный баг (1 из 20 попыток). Баг проявляется через ~30 секунд после специфичной последовательности действий. Какое доказательство наиболее полезно?",
      "options": [
        {
          "id": "a",
          "text": "Один скриншот после бага"
        },
        {
          "id": "b",
          "text": "Network HAR за весь день"
        },
        {
          "id": "c",
          "text": "Видео / запись экрана всей сессии (видно действия + момент бага)"
        },
        {
          "id": "d",
          "text": "Только текстовое описание"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: видео / запись экрана.</strong> Нестабильный баг (1 из 20) + специфичный тайминг + зависимость от последовательности = видео необходимо. Dev может пересматривать запись несколько раз, видеть точную последовательность, искать паттерн. Скриншот (вариант 1) показывает только финальное состояние, не путь. Текстовое описание (вариант 3) теряет нюансы тайминга. Network HAR за весь день (вариант 4) — overkill, нужно отрезать 1-2 минуты вокруг события. <em>Привычка:</em> для rarely/нестабильных — видео по умолчанию."
    }
  },
  {
    "id": "BUG-06",
    "sprintId": "S07",
    "ord": 6,
    "type": "docs",
    "priority": "P0",
    "title": "Triage — кто решает, что чинить первым",
    "estimateMin": 20,
    "ac": [
      {
        "id": "AC-01",
        "text": "Перечисляю **4 роли** в bug flow (QA · PM/PO · Dev · Lead) с обязанностями каждой."
      },
      {
        "id": "AC-02",
        "text": "Различаю **3 типа triage-встреч** (daily standup · weekly triage · hot-issue sync) и когда каждая запускается."
      },
      {
        "id": "AC-03",
        "text": "Применяю **матрицу SLA per Priority** (P0: 24h · P1: 2 недели · P2: 6-8 недель · P3: бессрочно)."
      },
      {
        "id": "AC-04",
        "text": "Знаю **дерево решений** на triage: NEW → 4 исхода (OPEN+назначен · DUPLICATE · NOT_A_BUG · DEFERRED)."
      },
      {
        "id": "AC-05",
        "text": "Распознаю **анти-паттерн «приостановить triage»** · бэклог накапливается · невидимый технический долг · нужен triage marathon для восстановления."
      },
      {
        "id": "AC-06",
        "text": "Прохожу Quick check и подтверждаю правильный ответ."
      },
      {
        "id": "AC-07",
        "text": "Принимаю **5 triage-решений** по SLA-матрице в карусели — включая ловушку «P1 за день до code freeze»."
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-BUG-06",
      "prompt": "Quick check",
      "question": "QA создала баг в состоянии NEW. PM на weekly triage решил «это duplicate of BUG-145 · close». Кто двигает состояние и какое финальное состояние?",
      "options": [
        {
          "id": "a",
          "text": "PM, состояние → DUPLICATE (со ссылкой на BUG-145)"
        },
        {
          "id": "b",
          "text": "QA, состояние → CLOSED"
        },
        {
          "id": "c",
          "text": "Dev, состояние → CANNOT_REPRODUCE"
        },
        {
          "id": "d",
          "text": "Lead, состояние → DEFERRED"
        }
      ],
      "answer": "a",
      "explanation": "<strong>Правильно: PM, состояние → DUPLICATE.</strong> На triage meeting у PM есть полномочия закрывать баги как DUPLICATE (со ссылкой на оригинал). Состояние → DUPLICATE (краевое состояние из T02 lifecycle), не CLOSED. Ссылка на BUG-145 обязательна для traceability. Вариант 1 — QA не двигает в DUPLICATE в одиночку, это решение PM на triage. Вариант 3 — CANNOT_REPRODUCE это состояние от Dev (когда Dev пробовал воспроизвести и не смог). Вариант 4 — DEFERRED для реальных багов, которые откладываются, не для дубликатов."
    }
  },
  {
    "id": "BUG-07",
    "sprintId": "S07",
    "ord": 7,
    "type": "docs",
    "priority": "P0",
    "title": "Жизнь бага в трекере — Linear как пример",
    "estimateMin": 21,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю **9 ключевых полей Linear issue** (Title · Description · Status · Priority · Assignee · Labels · Linked · Comments · Cycle)."
      },
      {
        "id": "AC-02",
        "text": "Различаю **дефолтный workflow Linear** (Backlog → Todo → In Progress → In Review → Done · плюс Cancelled · Duplicate) и сопоставление с универсальным lifecycle 6+5 из T02."
      },
      {
        "id": "AC-03",
        "text": "Применяю **этикет комментариев** · содержание важнее шума · «wip» в поле статуса, не в комментарии."
      },
      {
        "id": "AC-04",
        "text": "Использую **4 типа связанных issues** (Blocks · Blocked-by · Related · Duplicate-of · Parent/Sub-issue)."
      },
      {
        "id": "AC-05",
        "text": "Понимаю, что **трекер — универсальный концепт**, конкретный UI учится за дни (Linear / Jira / Asana / GitHub Issues — у всех те же примитивы)."
      },
      {
        "id": "AC-06",
        "text": "Прохожу Quick check и подтверждаю правильный ответ."
      },
      {
        "id": "AC-07",
        "text": "Перевожу **6 состояний Linear на канон** в сортере и читаю живую карточку ENG-201."
      }
    ],
    "istqb": [
      "CTFL-Ch6"
    ],
    "skills": [
      "Workspace Tools"
    ],
    "quickCheck": {
      "id": "QC-BUG-07",
      "prompt": "Quick check",
      "question": "QA создала баг в Linear. На triage PM выяснил, что это дубликат ENG-145. Что делать в Linear?",
      "options": [
        {
          "id": "a",
          "text": "Удалить новую issue"
        },
        {
          "id": "b",
          "text": "Вручную изменить состояние на Cancelled и написать в комментарии «duplicate»"
        },
        {
          "id": "c",
          "text": "Переместить в Backlog и забыть"
        },
        {
          "id": "d",
          "text": "Right-click → Mark as duplicate of ENG-145 · Linear автоматически закроет со ссылкой на оригинал"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: Mark as duplicate of ENG-145.</strong> У Linear есть встроенное действие «Mark as duplicate of...» которое (1) создаёт связь Duplicate-of к оригиналу, (2) автоматически закрывает состояние в Duplicate (краевое состояние), (3) сохраняет issue для истории (нет потери данных). Вариант 1 (удалить) — теряем доказательную историю. Вариант 3 (ручной Cancelled + комментарий) — работает, но не использует встроенную фичу Linear, теряет структурированную связь. Вариант 4 (Backlog + забыть) — анти-паттерн, увеличивает невидимый бэклог. <em>Привычка:</em> используй встроенные фичи трекера вместо ручных workaround'ов."
    }
  },
  {
    "id": "BUG-08",
    "sprintId": "S07",
    "ord": 8,
    "type": "docs",
    "priority": "P1",
    "title": "Senior-паттерны охоты за багами + знакомство с SFDIPOT",
    "estimateMin": 23,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю **3 senior bug patterns**: cross-feature impact · regression risk · root cause hypothesis."
      },
      {
        "id": "AC-02",
        "text": "Знаю **SFDIPOT 7 lens** (Structure / Function / Data / Interface / Platform / Operations / Time) и могу для конкретного бага пройти по 7 углам."
      },
      {
        "id": "AC-03",
        "text": "Понимаю, что **SFDIPOT — это инструмент мышления, не шаг процесса** · применяю на сложных багах · пропускаю на простых."
      },
      {
        "id": "AC-04",
        "text": "Применяю **SFDIPOT к worked example** (cashback багу · 7 lens · final additional bug report sections)."
      },
      {
        "id": "AC-05",
        "text": "Распознаю **анти-паттерн «эвристика как checkbox»** · 5-секундная оценка «сложный или простой?» перед применением."
      },
      {
        "id": "AC-06",
        "text": "Прохожу Quick check и подтверждаю правильный ответ."
      },
      {
        "id": "AC-07",
        "text": "Определяю **линзу SFDIPOT по находке** в карусели ×4 — и помню, когда эвристика overkill."
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "Test Documentation",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-BUG-08",
      "prompt": "Quick check",
      "question": "QA нашла баг «опечатка в подвале · «Cnotact» вместо «Contact»». Применять SFDIPOT-линзу к этому багу?",
      "options": [
        {
          "id": "a",
          "text": "Да, всегда применять SFDIPOT для тщательности"
        },
        {
          "id": "b",
          "text": "Нет — это простой изолированный UI-баг, SFDIPOT — overkill. Применяй для сложных / кросс-функциональных / затрагивающих production багов"
        },
        {
          "id": "c",
          "text": "Да, но только буквы Structure + Function"
        },
        {
          "id": "d",
          "text": "Спросить у Tech Lead перед применением"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: вариант 2 — пропустить SFDIPOT для простых багов.</strong> SFDIPOT — это <em>вспомогательный инструмент мышления</em> для сложных / кросс-функциональных / затрагивающих production багов. Опечатка в подвале — изолированный UI-баг · scope ясен · нет кросс-функциональных импликаций · нет риска регрессии. Применять SFDIPOT здесь = overkill, потеря времени. Вариант 1 — анти-паттерн «эвристика как checkbox» (T08 SITREP). Вариант 3 — частичное применение тоже не нужно. Вариант 4 — не нужно эскалировать на каждое решение · учись отличать «нужен ли SFDIPOT» сама. <em>Привычка: 5 секунд оценки «сложный или простой?» перед применением.</em>"
    }
  },
  {
    "id": "BUG-09",
    "sprintId": "S07",
    "ord": 9,
    "type": "ai",
    "priority": "P1",
    "title": "AI-эпизод — три промпта для работы с баг-репортами",
    "estimateMin": 14,
    "ac": [
      {
        "id": "AC-01",
        "text": "Применяю **3 паттерна промптов** для баг-репортов: helper · reviewer · repro-finder."
      },
      {
        "id": "AC-02",
        "text": "Знаю, что **AI галлюцинирует** на бизнес-контексте · числах · версиях билда · кросс-функциональных импликациях · командных конвенциях."
      },
      {
        "id": "AC-03",
        "text": "Применяю **привычку верификации** · минимум 3 минуты ревью перед submit'ом AI-сгенерированного BR."
      },
      {
        "id": "AC-04",
        "text": "Различаю **где AI помогает** (структурированный output из заметок · ревью готового BR) и **не помогает** (калибровка Severity/Priority · архитектурно-специфичный анализ · командные конвенции)."
      },
      {
        "id": "AC-05",
        "text": "Использую **указание ограничений в промпте** · «не угадывай Severity» · «не выдумывай числа»."
      },
      {
        "id": "AC-06",
        "text": "Прохожу Quick check и подтверждаю правильный ответ."
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "AI Workflow"
    ],
    "quickCheck": {
      "id": "QC-BUG-09",
      "prompt": "Quick check",
      "question": "AI помог написать баг-репорт. AI указал «Business Impact: затронуто 30% пользователей». Что джуниор должен сделать перед submit?",
      "options": [
        {
          "id": "a",
          "text": "Submit как есть — AI обычно прав"
        },
        {
          "id": "b",
          "text": "Удалить поле Business Impact"
        },
        {
          "id": "c",
          "text": "Проверить число через product-аналитику или тикеты customer support · если проверить нельзя — заменить на «требует подтверждения аналитикой» или реальное измеренное число"
        },
        {
          "id": "d",
          "text": "Изменить на «100% пользователей» для максимальной видимости"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: проверить через product-аналитику или заменить на placeholder.</strong> AI не знает реальную аналитику твоего продукта — любое число влияния от него — догадка. Джуниор должен либо проверить через реальные данные (дашборд аналитики, тикеты поддержки), либо заменить на «требует подтверждения аналитикой» (placeholder в ожидании реальных данных). Submit с непроверенным числом — потенциальная ложь, может миска́либровать Priority. Вариант 1 — слепое доверие AI = анти-паттерн из SITREP. Вариант 3 — Business Impact важное поле, удаление = недостаточно информации для PM. Вариант 4 — преувеличение = ложь, плохая практика. <em>Привычка:</em> любое число от AI = сначала проверить."
    }
  },
  {
    "id": "BUG-10",
    "sprintId": "S07",
    "ord": 10,
    "type": "mission",
    "priority": "P0",
    "title": "Миссия — найди баг и оформи Bug Report от и до",
    "estimateMin": 45,
    "ac": [
      {
        "id": "AC-01",
        "text": "Открываю Atelier bug-hunt сценарий · загружаю сломанный UI W2.1 · осматриваю фичу."
      },
      {
        "id": "AC-02",
        "text": "Провожу **exploratory testing ~10 мин** · нахожу ≥1 аномалию · пауза 30 секунд для анализа «баг или ожидаемое поведение?»."
      },
      {
        "id": "AC-03",
        "text": "Выбираю **один баг в полную глубину** (не гонясь за широтой) · исследую через DevTools / SQL если применимо."
      },
      {
        "id": "AC-04",
        "text": "Собираю **пропорциональные доказательства** (скриншоты + Network HAR + console output если применимо + видео если нестабильный)."
      },
      {
        "id": "AC-05",
        "text": "Пишу **полный 11-полевой баг-репорт** (S04 5 базовых + T03 6 новых) · атомарные шаги · pre-conditions отделены · доказательства приоритизированы · severity/priority предварительные с пометкой «to confirm at triage»."
      },
      {
        "id": "AC-06",
        "text": "(Опционально) Применяю **SFDIPOT-линзу** если баг сложный · добавляю секции кросс-функциональное влияние + риск регрессии + гипотеза о корневой причине."
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "Test Documentation",
      "QA Concepts",
      "Workspace Tools"
    ],
    "mission": {
      "cta": "Открыть Mission в Atelier",
      "atelierScenarioId": "block-2-bug-report-end-to-end"
    }
  },
  {
    "id": "SQL-01",
    "sprintId": "S08",
    "ord": 1,
    "type": "docs",
    "priority": "P0",
    "title": "Зачем тестировщику SQL — три истории про правду",
    "estimateMin": 14,
    "ac": [
      {
        "id": "AC-01",
        "text": "Могу описать словами **3 типичных сценария**, когда QA нужно SQL: верификация бага в данных, подготовка тестовых данных в граничном состоянии, расследование странности UI vs БД."
      },
      {
        "id": "AC-02",
        "text": "Различаю **3 уровня системы** (UI · API · БД) и понимаю, что «правда» живёт на самом нижнем — в БД."
      },
      {
        "id": "AC-03",
        "text": "Знаю, что **джуниорский уровень SQL** — это чтение + базовое CRUD (Create/Read/Update/Delete), без DBA-задач (оптимизация, миграции)."
      },
      {
        "id": "AC-04",
        "text": "Помню **золотое правило**: «если речь о деньгах / заказах / доступах — не доверяй UI без подтверждения в БД»."
      },
      {
        "id": "AC-05",
        "text": "Различаю, что **в S08 базовый уровень**, а подзапросы / оконные функции / NoSQL ждут в **S11 (углублённо)**."
      },
      {
        "id": "AC-06",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "SQL",
      "Workspace Tools"
    ],
    "quickCheck": {
      "id": "QC-SQL-01",
      "prompt": "Quick check",
      "question": "QA-инженер видит, что клиент пишет в саппорт «оплатил, но заказ не появился в моей истории». В UI у клиента — пустая история заказов. Какое первое действие выполнит QA, который умеет SQL?",
      "options": [
        {
          "id": "a",
          "text": "Эскалирует разработчику с пометкой «UI не показывает заказ»"
        },
        {
          "id": "b",
          "text": "Попросит клиента очистить кэш браузера и перелогиниться"
        },
        {
          "id": "c",
          "text": "Сделает <code>SELECT</code> по orders с фильтром по user_id — увидеть, есть ли заказ в БД и в каком он статусе"
        },
        {
          "id": "d",
          "text": "Закроет тикет как дубликат"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Источник правды — БД, не UI.</strong> Рефлекс QA с SQL: не доверять UI на слово, а спросить базу напрямую — <code>SELECT</code>-ом увидеть, есть ли заказ и в каком он статусе. Эскалация Dev'у без проверки в БД — потеря часа на «у меня всё работает». Кэш и перелогин — бесплатная попытка, но не первый шаг: ещё не знаем, есть ли заказ в данных. Закрыть как duplicate без верификации — анти-паттерн."
    }
  },
  {
    "id": "SQL-04",
    "sprintId": "S08",
    "ord": 4,
    "type": "docs",
    "priority": "P0",
    "title": "SELECT базовый — читаем таблицы",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю **6 частей анатомии SELECT** (SELECT / FROM / WHERE / ORDER BY / LIMIT / `;`) и какие из них обязательны."
      },
      {
        "id": "AC-02",
        "text": "Различаю **`SELECT *`** (все колонки) и **`SELECT col1, col2`** (явный список) — и понимаю, почему второе предпочтительнее."
      },
      {
        "id": "AC-03",
        "text": "Применяю **DISTINCT** для получения уникальных значений колонки."
      },
      {
        "id": "AC-04",
        "text": "Применяю **ORDER BY ... DESC/ASC** для сортировки результата по одной или нескольким колонкам."
      },
      {
        "id": "AC-05",
        "text": "Помню правило **LIMIT на незнакомой таблице** — первый запрос всегда с `LIMIT 10`."
      },
      {
        "id": "AC-06",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "SQL"
    ],
    "quickCheck": {
      "id": "QC-SQL-04",
      "prompt": "Quick check",
      "question": "Какая клауза в SELECT убирает дубликаты из результата запроса?",
      "options": [
        {
          "id": "a",
          "text": "UNIQUE"
        },
        {
          "id": "b",
          "text": "GROUP BY"
        },
        {
          "id": "c",
          "text": "NO_DUPLICATES"
        },
        {
          "id": "d",
          "text": "DISTINCT"
        }
      ],
      "answer": "d",
      "explanation": "<strong>DISTINCT убирает дубликаты.</strong> <code>SELECT DISTINCT status FROM orders</code> вернёт уникальные значения колонки. <code>UNIQUE</code> — это constraint при создании таблицы (DDL), не клауза SELECT. <code>GROUP BY</code> группирует строки для агрегаций (SUM/COUNT/AVG) — это не то же самое, что убрать дубликаты, разберём в T07. <code>NO_DUPLICATES</code> — такой команды в SQL нет. Запомни: DISTINCT — единственный способ убрать дубликаты в SELECT."
    }
  },
  {
    "id": "SQL-03",
    "sprintId": "S08",
    "ord": 3,
    "type": "docs",
    "priority": "P0",
    "title": "5 категорий SQL — кто каждой пользуется",
    "estimateMin": 14,
    "ac": [
      {
        "id": "AC-01",
        "text": "Перечисляю **все 5 категорий SQL** (DDL · DML · DQL · DCL · TCL) с расшифровкой каждой."
      },
      {
        "id": "AC-02",
        "text": "Привожу **минимум 1-2 команды** в каждой категории (DDL: CREATE/ALTER/DROP · DML: INSERT/UPDATE/DELETE · DQL: SELECT · DCL: GRANT/REVOKE · TCL: BEGIN/COMMIT/ROLLBACK)."
      },
      {
        "id": "AC-03",
        "text": "Понимаю, что **джуниор QA в основном пишет DQL и DML**, а DDL/DCL — почти никогда."
      },
      {
        "id": "AC-04",
        "text": "Различаю **DDL и DML** через мнемонику «структура vs содержимое»."
      },
      {
        "id": "AC-05",
        "text": "Могу проследить **жизненный цикл одной фичи** через все 5 категорий (Dev DDL → DBA DCL → QA DML → QA DQL → QA TCL)."
      },
      {
        "id": "AC-06",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "SQL"
    ],
    "quickCheck": {
      "id": "QC-SQL-03",
      "prompt": "Quick check",
      "question": "К какой категории SQL относится команда <code>ALTER TABLE users ADD COLUMN phone TEXT;</code>?",
      "options": [
        {
          "id": "a",
          "text": "DDL (Data Definition Language)"
        },
        {
          "id": "b",
          "text": "DML (Data Manipulation Language)"
        },
        {
          "id": "c",
          "text": "DQL (Data Query Language)"
        },
        {
          "id": "d",
          "text": "TCL (Transaction Control Language)"
        }
      ],
      "answer": "a",
      "explanation": "<strong>ALTER TABLE — это DDL.</strong> Команда меняет <em>структуру</em> таблицы (добавляет колонку), а не данные внутри. Структура — это DDL (Data Definition Language). DML — это INSERT/UPDATE/DELETE, меняет содержимое строк. DQL — это SELECT, читает данные. TCL — это BEGIN/COMMIT/ROLLBACK, управляет транзакциями. Мнемоника: DDL = таблица как объект, DML = строки внутри таблицы."
    }
  },
  {
    "id": "SQL-05",
    "sprintId": "S08",
    "ord": 5,
    "type": "docs",
    "priority": "P0",
    "title": "WHERE deep — операторы, логика, и ловушка NULL",
    "estimateMin": 20,
    "ac": [
      {
        "id": "AC-01",
        "text": "Применяю **6 операторов сравнения** (<code>=</code>, <code>!=</code>/<code>&lt;&gt;</code>, <code>&lt;</code>, <code>&gt;</code>, <code>&lt;=</code>, <code>&gt;=</code>) в WHERE."
      },
      {
        "id": "AC-02",
        "text": "Использую **логические операторы** <code>AND</code>, <code>OR</code>, <code>NOT</code> и понимаю их приоритет (NOT &gt; AND &gt; OR) · ставлю **скобки явно** при смеси."
      },
      {
        "id": "AC-03",
        "text": "Применяю **специализированные операторы** <code>IN (...)</code>, <code>BETWEEN x AND y</code>, <code>LIKE 'pattern'</code> с пониманием их эквивалентов."
      },
      {
        "id": "AC-04",
        "text": "Различаю **подстановочные символы в LIKE**: <code>%</code> (любая последовательность) vs <code>_</code> (один символ)."
      },
      {
        "id": "AC-05",
        "text": "Помню **ловушку NULL** · трёхзначная логика TRUE/FALSE/UNKNOWN · использую <code>IS NULL</code> / <code>IS NOT NULL</code> вместо <code>= NULL</code>."
      },
      {
        "id": "AC-06",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "SQL"
    ],
    "quickCheck": {
      "id": "QC-SQL-05",
      "prompt": "Quick check",
      "question": "QA хочет найти все заказы, у которых не указан <code>promo_code</code> (NULL). Какой query правильный?",
      "options": [
        {
          "id": "a",
          "text": "<code>SELECT * FROM orders WHERE promo_code = NULL;</code>"
        },
        {
          "id": "b",
          "text": "<code>SELECT * FROM orders WHERE promo_code IS NULL;</code>"
        },
        {
          "id": "c",
          "text": "<code>SELECT * FROM orders WHERE promo_code = '';</code>"
        },
        {
          "id": "d",
          "text": "<code>SELECT * FROM orders WHERE promo_code = 'NULL';</code>"
        }
      ],
      "answer": "b",
      "explanation": "<strong>NULL — это отсутствие значения, не значение.</strong> Его нельзя сравнивать через <code>=</code> (всегда даёт UNKNOWN, не TRUE) — работает только <code>IS NULL</code> / <code>IS NOT NULL</code>. Вариант с <code>= NULL</code> — классическая ошибка новичка, вернёт 0 строк. <code>= ''</code> ищет пустую строку — это не то же самое, что NULL (пустая строка — значение, NULL — его отсутствие). <code>= 'NULL'</code> ищет буквальный текст «NULL». Запомни: с NULL работаем через IS NULL."
    }
  },
  {
    "id": "SQL-06",
    "sprintId": "S08",
    "ord": 6,
    "type": "docs",
    "priority": "P0",
    "title": "JOINs — соединяем таблицы (INNER + LEFT основные)",
    "estimateMin": 20,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю **INNER JOIN** (только совпадения в обеих таблицах) и **LEFT JOIN** (все слева + совпадения справа, где нет — NULL)."
      },
      {
        "id": "AC-02",
        "text": "Применяю **синтаксис JOIN**: <code>FROM A a INNER/LEFT JOIN B b ON a.id = b.a_id</code>; использую алиас для таблиц."
      },
      {
        "id": "AC-03",
        "text": "Понимаю разницу между **primary key** (id таблицы) и **foreign key** (ссылка на id другой таблицы)."
      },
      {
        "id": "AC-04",
        "text": "Применяю паттерн **LEFT JOIN + IS NULL** для поиска «X без Y» (users без orders, orders без payments и т.п.)."
      },
      {
        "id": "AC-05",
        "text": "Различаю **ON-clause** vs **WHERE-clause** в JOIN — особенно для LEFT JOIN, где WHERE на правой таблице превращает LEFT обратно в INNER."
      },
      {
        "id": "AC-06",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "SQL"
    ],
    "quickCheck": {
      "id": "QC-SQL-06",
      "prompt": "Quick check",
      "question": "QA хочет найти всех users, у которых <strong>нет ни одного заказа</strong>. Какой query правильный?",
      "options": [
        {
          "id": "a",
          "text": "<code>SELECT u.* FROM users u INNER JOIN orders o ON u.id = o.user_id WHERE o.id IS NULL;</code>"
        },
        {
          "id": "b",
          "text": "<code>SELECT u.* FROM users u WHERE NOT EXISTS orders;</code>"
        },
        {
          "id": "c",
          "text": "<code>SELECT u.* FROM users u LEFT JOIN orders o ON u.id = o.user_id WHERE o.status = 'cancelled';</code>"
        },
        {
          "id": "d",
          "text": "<code>SELECT u.* FROM users u LEFT JOIN orders o ON u.id = o.user_id WHERE o.id IS NULL;</code>"
        }
      ],
      "answer": "d",
      "explanation": "<strong>LEFT JOIN + IS NULL = поиск «X без Y».</strong> LEFT JOIN включает всех users (даже без orders), а <code>WHERE o.id IS NULL</code> оставляет только тех, у кого справа всё NULL — ни одного совпадения в orders. Вариант с INNER JOIN отбрасывает строки без совпадения <em>до</em> WHERE, поэтому <code>o.id IS NULL</code> не найдёт ничего. <code>NOT EXISTS orders</code> синтаксически невалиден (NOT EXISTS требует подзапрос — это S11). Вариант с <code>cancelled</code> найдёт users с отменёнными заказами, а не «без заказов». Запомни паттерн: LEFT JOIN + IS NULL = поиск orphans."
    }
  },
  {
    "id": "SQL-07",
    "sprintId": "S08",
    "ord": 7,
    "type": "docs",
    "priority": "P0",
    "title": "Aggregations + GROUP BY — считаем, суммируем, группируем",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Применяю **5 агрегатных функций** (COUNT · SUM · AVG · MIN · MAX) для подсчёта данных по всей выборке или по группам."
      },
      {
        "id": "AC-02",
        "text": "Различаю **<code>COUNT(*)</code>** (все строки) и **<code>COUNT(column)</code>** (только не-NULL значения column)."
      },
      {
        "id": "AC-03",
        "text": "Применяю **GROUP BY** для разбивки строк на группы и независимой агрегации каждой."
      },
      {
        "id": "AC-04",
        "text": "Соблюдаю правило **«в SELECT только колонки из GROUP BY или обёрнутые в агрегат»**."
      },
      {
        "id": "AC-05",
        "text": "Различаю **WHERE vs HAVING** · WHERE до агрегации (строки), HAVING после (группы) · НЕ пишу агрегат в WHERE."
      },
      {
        "id": "AC-06",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "SQL"
    ],
    "quickCheck": {
      "id": "QC-SQL-07",
      "prompt": "Quick check",
      "question": "QA хочет найти все страны, в которых количество paid orders больше 5. Какой query правильный?",
      "options": [
        {
          "id": "a",
          "text": "<code>SELECT country, COUNT(*) FROM orders WHERE status = 'paid' GROUP BY country HAVING COUNT(*) &gt; 5;</code>"
        },
        {
          "id": "b",
          "text": "<code>SELECT country FROM orders WHERE status = 'paid' AND COUNT(*) &gt; 5 GROUP BY country;</code>"
        },
        {
          "id": "c",
          "text": "<code>SELECT country FROM orders GROUP BY country WHERE status = 'paid' HAVING &gt; 5;</code>"
        },
        {
          "id": "d",
          "text": "<code>SELECT country, COUNT(*) FROM orders WHERE COUNT(*) &gt; 5 AND status = 'paid';</code>"
        }
      ],
      "answer": "a",
      "explanation": "<strong>WHERE до GROUP BY, HAVING после.</strong> WHERE фильтрует строки <em>до</em> агрегации (только paid), GROUP BY группирует по country, HAVING фильтрует уже готовые группы (только те, где count &gt; 5). Варианты с <code>COUNT(*)</code> в WHERE невалидны — агрегат нельзя использовать в фильтре строк до агрегации. Вариант с <code>WHERE</code> после <code>GROUP BY</code> — неверный порядок клауз. Запомни: в HAVING можно агрегаты, в WHERE — нельзя."
    }
  },
  {
    "id": "SQL-08",
    "sprintId": "S08",
    "ord": 8,
    "type": "docs",
    "priority": "P0",
    "title": "DML — INSERT/UPDATE/DELETE для тестовых данных, и почему WHERE спасает карьеру",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Применяю **3 формы INSERT** (одна строка · много строк · INSERT FROM SELECT) для подготовки тестовых данных."
      },
      {
        "id": "AC-02",
        "text": "Применяю **UPDATE** для перевода существующих записей в нужное граничное состояние — **всегда с WHERE**."
      },
      {
        "id": "AC-03",
        "text": "Применяю **DELETE** для очистки тестовых записей — **всегда с WHERE**."
      },
      {
        "id": "AC-04",
        "text": "Знаю и применяю **3-шаговый протокол безопасности** для опасных операций: SELECT-проверка → BEGIN → опасная команда → SELECT-сверка → COMMIT/ROLLBACK."
      },
      {
        "id": "AC-05",
        "text": "Помню **золотое правило**: **никогда не запускаю UPDATE или DELETE без WHERE** · никогда без BEGIN'а на больше чем 1-2 строках."
      },
      {
        "id": "AC-06",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "SQL"
    ],
    "quickCheck": {
      "id": "QC-SQL-08",
      "prompt": "Quick check",
      "question": "QA случайно запустил <code>UPDATE users SET tier = 'premium';</code> на staging БД (без WHERE!). Какой первый ход?",
      "options": [
        {
          "id": "a",
          "text": "Нажать Ctrl+C / Cancel в SQL-клиенте"
        },
        {
          "id": "b",
          "text": "Запустить <code>UPDATE users SET tier = 'regular';</code> чтобы откатить"
        },
        {
          "id": "c",
          "text": "Если запустил вне транзакции — изменения уже применены, нужно восстановление из бэкапа. Сразу написать DBA, не пытаться «починить» запросами."
        },
        {
          "id": "d",
          "text": "Перезагрузить базу данных"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Без транзакции изменение уже применено — нужен restore из backup, который делает DBA.</strong> Ctrl+C не помогает: query уже выполнилась. <code>UPDATE SET tier='regular'</code> уничтожит правильные premium-tier'ы существующих юзеров (мы не знаем, кто был premium до). Перезагрузка БД не откатит данные — база поднимется в текущем состоянии. Вся боль начинается с забытого WHERE: привычка «BEGIN перед опасным + WHERE всегда» — это страховка, выработанная поколениями QA и Dev'ов."
    }
  },
  {
    "id": "SQL-09",
    "sprintId": "S08",
    "ord": 9,
    "type": "docs",
    "priority": "P0",
    "title": "SQL для расследования багов — сквозной процесс",
    "estimateMin": 22,
    "ac": [
      {
        "id": "AC-01",
        "text": "Применяю **5-шаговый процесс расследования** (гипотеза → запрос → анализ → вывод → оформление) к конкретной странности."
      },
      {
        "id": "AC-02",
        "text": "Сохраняю **гипотезу первой**, запрос — потом · НЕ блуждаю по таблицам без направления."
      },
      {
        "id": "AC-03",
        "text": "Знаю, какие **таблицы** чаще всего используются для расследования (users · orders · payments · events)."
      },
      {
        "id": "AC-04",
        "text": "Применяю **порядок инструментов**: DevTools Network → Console → логи приложения → SQL (~80% решаются до SQL)."
      },
      {
        "id": "AC-05",
        "text": "Прикладываю **запрос + результат как доказательства** в баг-репорт · применяю формулу заголовка «что+где+когда» из S04."
      },
      {
        "id": "AC-06",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "SQL",
      "Workspace Tools"
    ],
    "quickCheck": {
      "id": "QC-SQL-09",
      "prompt": "Quick check",
      "question": "Клиент пишет в саппорт «не пришёл email подтверждения регистрации». Какая последовательность инструментов в QA-расследовании?",
      "options": [
        {
          "id": "a",
          "text": "SQL → логи приложения → DevTools Network → Console"
        },
        {
          "id": "b",
          "text": "DevTools Network → Console → логи приложения → SQL (если нужно)"
        },
        {
          "id": "c",
          "text": "Сразу написать разработчику"
        },
        {
          "id": "d",
          "text": "Перерегистрироваться от другого клиента и проверить"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Сверху вниз по уровням: Network → Console → App logs → SQL.</strong> Сначала верхний уровень (UI/network), потом средний (server logs), потом нижний (БД). 50% случаев решаются на network (видно 500/404 от email-API), 30% — в logs (email-job не запустился из-за queue overflow), 20% доходят до SQL («есть ли запись в email_queue для этого пользователя?»). Обратный порядок (SQL первым) неэффективен. «Сразу написать Dev'у» — преждевременная эскалация без расследования. «Перерегистрироваться» — повторение действия, а не расследование: может сработать, но непонятно почему."
    }
  },
  {
    "id": "SQL-10",
    "sprintId": "S08",
    "ord": 10,
    "type": "ai",
    "priority": "P1",
    "title": "AI-эпизод — SQL с помощником (3 промпта)",
    "estimateMin": 14,
    "ac": [
      {
        "id": "AC-01",
        "text": "Применяю **3 промпт-паттерна** для SQL: **helper** (помоги написать) · **explainer** (объясни существующую) · **debugger** (запрос возвращает не то)."
      },
      {
        "id": "AC-02",
        "text": "Знаю, что **AI галлюцинирует** на именах таблиц, забывает LIMIT/IS NULL, может писать «работающие но логически неправильные» запросы."
      },
      {
        "id": "AC-03",
        "text": "Применяю **протокол безопасности** к AI-сгенерированному запросу: SELECT-проверка → BEGIN → опасное → SELECT-сверка → COMMIT/ROLLBACK."
      },
      {
        "id": "AC-04",
        "text": "Различаю «AI как черновик» и «боевой запрос» · никогда не копирую DELETE/UPDATE без BEGIN."
      },
      {
        "id": "AC-05",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "SQL",
      "AI Workflow"
    ],
    "quickCheck": {
      "id": "QC-SQL-10",
      "prompt": "Quick check",
      "question": "AI помог написать <code>DELETE FROM users WHERE last_login &lt; '2024-01-01';</code>. Что джуниор должен сделать перед запуском?",
      "options": [
        {
          "id": "a",
          "text": "Скопировать и запустить — AI обычно прав"
        },
        {
          "id": "b",
          "text": "Запустить, и если что-то пойдёт не так — попросить AI откатить"
        },
        {
          "id": "c",
          "text": "Сначала <code>SELECT * FROM users WHERE last_login &lt; '2024-01-01' LIMIT 10;</code> · посмотреть, какие пользователи попадут под DELETE · потом <code>BEGIN;</code> + DELETE + SELECT verify + COMMIT/ROLLBACK"
        },
        {
          "id": "d",
          "text": "Просто заменить DELETE на SELECT и проверить, ОК ли результат"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Сначала preview через SELECT, потом BEGIN → DELETE → verify → COMMIT/ROLLBACK.</strong> Это применение 3-step safety protocol из T08 к AI-сгенерированной query. AI может галлюцинировать: «последний логин старше января 2024» может включать «спящих» legitimate-юзеров, которых удалять нельзя. Слепо скопировать и запустить — карьерный кошмар. AI не имеет доступа к твоей БД и не может «откатить». Замена DELETE на SELECT — на правильном пути (это и есть preview), но без BEGIN/ROLLBACK защиты не хватает. Запомни: AI — черновик, твои safety-правила — final guard."
    }
  },
  {
    "id": "SQL-11",
    "sprintId": "S08",
    "ord": 11,
    "type": "mission",
    "priority": "P0",
    "title": "Миссия · SQL-расследование в Atelier sql-playground",
    "estimateMin": 40,
    "ac": [
      {
        "id": "AC-01",
        "text": "Atelier sql-playground открыт · e-commerce-фикстура загружена · схема 4 таблиц просмотрена."
      },
      {
        "id": "AC-02",
        "text": "Сформулированы **минимум 3 гипотезы** перед написанием запросов."
      },
      {
        "id": "AC-03",
        "text": "Написаны **минимум 3 запроса** с применением SELECT / WHERE / JOIN / GROUP BY (знания из T04-T07)."
      },
      {
        "id": "AC-04",
        "text": "Сделан **обоснованный вывод**: баг ИЛИ закрытие „не баг“, с обоснованием через данные."
      },
      {
        "id": "AC-05",
        "text": "Если баг — баг-репорт оформлен по формуле S04 «что+где+когда» с доказательствами (запросы и результаты приклеены)."
      },
      {
        "id": "AC-06",
        "text": "UPDATE/DELETE в playground не запускались (привычка — только SELECT на этапе расследования)."
      }
    ],
    "istqb": [
      "CTFL-Ch4"
    ],
    "skills": [
      "SQL",
      "Workspace Tools"
    ],
    "mission": {
      "cta": "Открыть миссию в Atelier",
      "atelierScenarioId": "block-2-sql-playground"
    }
  },
  {
    "id": "SQL-02",
    "sprintId": "S08",
    "ord": 2,
    "type": "docs",
    "priority": "P0",
    "title": "Что такое БД · как работает · какие виды",
    "estimateMin": 24,
    "ac": [
      {
        "id": "AC-01",
        "text": "Может объяснить 3-слойную ментальную модель БД (Client → Engine → Storage)."
      },
      {
        "id": "AC-02",
        "text": "Знает **4 главных семейства БД** (relational · document · key-value · graph) с минимум 1 примером системы каждого."
      },
      {
        "id": "AC-03",
        "text": "Понимает позиционирование S08 курса: реляционная основа · NoSQL только знакомство."
      },
      {
        "id": "AC-04",
        "text": "Может назвать **5 строительных блоков** реляционной БД (таблица · строка · колонка · схема · тип)."
      },
      {
        "id": "AC-05",
        "text": "Может объяснить **5 типов ограничений** (PK · FK · UNIQUE · NOT NULL · CHECK) с примером для каждого."
      },
      {
        "id": "AC-06",
        "text": "Разобран мини-ER (users + products + orders + order_items) · понятны FK-связи."
      },
      {
        "id": "AC-07",
        "text": "Знает **4 клиента БД** (DBeaver · pgAdmin · DataGrip · CLI) · может выбрать первый для установки."
      },
      {
        "id": "AC-08",
        "text": "Различает SQL (язык) vs MySQL/PostgreSQL (конкретные движки)."
      },
      {
        "id": "AC-09",
        "text": "Знакомство с моделями консистентности ACID vs BASE (через senior-блок)."
      },
      {
        "id": "AC-10",
        "text": "Знакомство: индексы ускоряют SELECT · PRIMARY KEY автоматически создаёт индекс (через senior-блок)."
      }
    ],
    "istqb": [
      "CTFL-Ch4",
      "CTFL-Ch6",
      "CTFL-Ch2"
    ],
    "skills": [
      "SQL",
      "QA Concepts",
      "HTTP & API"
    ],
    "quickCheck": {
      "id": "QC-SQL-02",
      "prompt": "Quick check",
      "question": "Команда выбирает основную БД для платёжной системы, где недопустимо потерять или задвоить перевод между счетами. Какое семейство выбирают по умолчанию и почему?",
      "options": [
        {
          "id": "a",
          "text": "Документная — гибкая схема ускоряет разработку фич"
        },
        {
          "id": "b",
          "text": "Графовая — удобно описывать связи между счетами"
        },
        {
          "id": "c",
          "text": "Ключ-значение — даёт максимальную скорость записи"
        },
        {
          "id": "d",
          "text": "Реляционная — строгая схема и транзакции защищают целостность переводов"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Реляционная БД (PostgreSQL, MySQL) — выбор по умолчанию для денег и заказов.</strong> Строгая схема и транзакции гарантируют, что перевод применится целиком или не применится вовсе — нельзя списать со счёта и «потерять» зачисление. Именно поэтому около 80% бизнес-систем реляционные, и SQL — базовый навык QA. Документная база ускоряет разработку при меняющейся схеме, но слабее в целостности между записями. Ключ-значение очень быстрая, но без структуры для сложных проверок. Графовая хороша, когда связи важнее самих данных. Для платежей решает целостность, а не скорость или гибкость."
    }
  },
  {
    "id": "API-01",
    "sprintId": "S09",
    "ord": 1,
    "type": "docs",
    "priority": "P0",
    "title": "Зачем QA нужен API testing — курьер между витриной и складом",
    "estimateMin": 16,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю **3 уровня системы** (UI · API · БД) и могу для конкретного бага сказать, на каком уровне он живёт."
      },
      {
        "id": "AC-02",
        "text": "Привожу **3 типичных сценария** API-тестирования: разделение ответственности UI / API / БД · обнаружение изменения контракта · ловля гонок состояний, невидимых в UI."
      },
      {
        "id": "AC-03",
        "text": "Знаю, что **джуниорский уровень API-тестирования** — это ручное через Postman + DevTools Network + SQL-сверка, без автоматизации (S16) и глубокой безопасности (S12)."
      },
      {
        "id": "AC-04",
        "text": "Помню **порядок инструментов** · DevTools Network → Console → логи приложения → SQL · 80% багов разделяются на API на первом шаге."
      },
      {
        "id": "AC-05",
        "text": "Различаю, что **в S09 базовое ручное API-тестирование**, а глубокая автоматизация API / OWASP API Top 10 / GraphQL / нагрузка ждут в **S12 / S16 / S17**."
      },
      {
        "id": "AC-06",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [],
    "skills": [
      "HTTP & API",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-API-01",
      "prompt": "Quick check",
      "question": "Customer пишет в саппорт: «не приходит письмо подтверждения после регистрации». Какой первый инструмент проверки у QA с навыком API testing?",
      "options": [
        {
          "id": "a",
          "text": "Сразу SQL — <code>SELECT * FROM email_queue WHERE user_id=...</code>"
        },
        {
          "id": "b",
          "text": "Сразу позвонить разработчику с описанием"
        },
        {
          "id": "c",
          "text": "DevTools, вкладка Network — посмотреть, был ли вообще запрос к email-API после регистрации и какой ответ он вернул"
        },
        {
          "id": "d",
          "text": "Перерегистрироваться от другого тестового пользователя"
        }
      ],
      "answer": "c",
      "explanation": "<strong>По UI-странности первый ход — Network.</strong> Порядок инструментов из S08 T08 + S09: DevTools Network → Console → App logs → SQL. 50% случаев решаются на Network (видно 500/404 от email-API — баг на бэкенде), 30% — в логах (queue overflow, job failed), до SQL доходит ~20%. «Сразу SQL» — преждевременное погружение в БД. «Позвонить разработчику» — преждевременная эскалация без расследования. «Перерегистрироваться» — повторение действия, а не расследование. Запомни: любая UI-странность → F12 → Network → reproduce → найти подозрительный request."
    }
  },
  {
    "id": "API-02",
    "sprintId": "S09",
    "ord": 2,
    "type": "docs",
    "priority": "P0",
    "title": "HTTP request anatomy — 4 части request, 3 части response",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю **4 части HTTP-запроса** (метод · URL · заголовки · тело) и **3 части ответа** (статус-код · заголовки · тело)."
      },
      {
        "id": "AC-02",
        "text": "Различаю **path-параметры** (идентифицируют ресурс · в пути URL) и **query-параметры** (модифицируют запрос · после `?`)."
      },
      {
        "id": "AC-03",
        "text": "Понимаю **stateless-природу HTTP** · каждый запрос независим · непрерывность через cookies / tokens (заглядываем в T05)."
      },
      {
        "id": "AC-04",
        "text": "Распознаю **один и тот же запрос** в трёх представлениях: Postman UI · команда curl · сырой HTTP в Network."
      },
      {
        "id": "AC-05",
        "text": "Помню **антипаттерн «GET с телом»** · GET-запросы без тела, фильтры через query-параметры."
      },
      {
        "id": "AC-06",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [],
    "skills": [
      "HTTP & API"
    ],
    "quickCheck": {
      "id": "QC-API-02",
      "prompt": "Quick check",
      "question": "QA смотрит в DevTools Network подозрительный запрос: <code>POST /api/orders/101/cancel</code>. Что в этом URL — path param, что — endpoint?",
      "options": [
        {
          "id": "a",
          "text": "Endpoint: <code>/api/orders/{id}/cancel</code> · path param: <code>id=101</code>"
        },
        {
          "id": "b",
          "text": "<code>/api/orders/101/cancel</code> — весь URL это endpoint, path params нет"
        },
        {
          "id": "c",
          "text": "Endpoint: <code>/api/orders</code> · query param: <code>id=101</code> · action: <code>cancel</code>"
        },
        {
          "id": "d",
          "text": "Path param: <code>cancel</code> · endpoint: <code>/api/orders/101</code>"
        }
      ],
      "answer": "a",
      "explanation": "<strong>Endpoint — шаблон URL, path param — конкретное значение в нём.</strong> В документации endpoint пишется как <code>/api/orders/{id}/cancel</code> (плейсхолдер <code>{id}</code>), <code>101</code> — конкретный id заказа (path param), <code>cancel</code> — часть пути, action на ресурсе. «Весь URL = endpoint» — нечётко (path params не выделены). Query param был бы после <code>?</code>, а не в пути. <code>cancel</code> — часть endpoint, не path param. Запомни: path params идентифицируют ресурс, query params модифицируют запрос."
    }
  },
  {
    "id": "API-03",
    "sprintId": "S09",
    "ord": 3,
    "type": "docs",
    "priority": "P0",
    "title": "HTTP методы — GET/POST/PUT/PATCH/DELETE + idempotency",
    "estimateMin": 16,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю **5 главных HTTP методов** (GET / POST / PUT / PATCH / DELETE) и их семантику."
      },
      {
        "id": "AC-02",
        "text": "Различаю **идемпотентные** (GET · PUT · DELETE) и **не идемпотентные** (POST · PATCH) методы."
      },
      {
        "id": "AC-03",
        "text": "Применяю **сопоставление CRUD ↔ HTTP** (Create=POST · Read=GET · Update=PUT/PATCH · Delete=DELETE) со связкой к S08 SQL DML."
      },
      {
        "id": "AC-04",
        "text": "Понимаю, что **POST + повтор = возможный дубль** · идемпотентность критична для безопасного к повторам дизайна API."
      },
      {
        "id": "AC-05",
        "text": "Распознаю **нарушение контракта** (GET, который меняет состояние · DELETE, который не удаляет · POST, который не создаёт) как отдельную категорию багов."
      },
      {
        "id": "AC-06",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [],
    "skills": [
      "HTTP & API"
    ],
    "quickCheck": {
      "id": "QC-API-03",
      "prompt": "Quick check",
      "question": "User кликнул «Submit» дважды быстро (network glitch · кажется, не отреагировало). Backend получил 2 запроса. Что произойдёт, если endpoint <code>POST /api/orders</code>?",
      "options": [
        {
          "id": "a",
          "text": "1 заказ создастся (POST автоматически дедуплицирует)"
        },
        {
          "id": "b",
          "text": "Бэкенд вернёт ошибку «duplicate request»"
        },
        {
          "id": "c",
          "text": "Ничего не произойдёт · сервер сам распознаёт дубль"
        },
        {
          "id": "d",
          "text": "Создадутся 2 заказа · POST не идемпотентен · повтор опасен · нужен Idempotency-Key или дедупликация на бэкенде"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Создадутся 2 заказа — POST не идемпотентен.</strong> Каждый вызов создаёт новый ресурс, server не различает «retry» от нового запроса. Решение на бэкенде: либо клиент передаёт <code>Idempotency-Key</code> (паттерн Stripe), либо у server есть дедупликация (unique constraint на user_id+cart_hash → возвращает существующий заказ). Без этого — двойной заказ и двойное списание, реальный баг. POST автоматически НЕ дедуплицирует; без специальной логики бэкенд не знает, что это дубликат. Запомни: POST + retry = возможный дубль, QA обязана тестировать это на критичных flow."
    }
  },
  {
    "id": "API-04",
    "sprintId": "S09",
    "ord": 4,
    "type": "docs",
    "priority": "P0",
    "title": "Статус-коды углублённо — 5 категорий + ~30 кодов из реальной практики",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю **5 категорий статус-кодов** (1xx · 2xx · 3xx · 4xx · 5xx) и кто виноват в каждой."
      },
      {
        "id": "AC-02",
        "text": "Перечисляю **минимум 15 конкретных кодов** из ~30 покрытых · с правильной категорией и контекстом применения."
      },
      {
        "id": "AC-03",
        "text": "Различаю **401 vs 403 vs 404** · нет аутентификации vs нет прав vs ресурс не существует."
      },
      {
        "id": "AC-04",
        "text": "Применяю **дерево решений** при расследовании API-багов: 4xx → проверь свой запрос · 5xx → эскалация разработчику с trace ID."
      },
      {
        "id": "AC-05",
        "text": "Распознаю **антипаттерны** (200 OK с ошибкой в теле · 500 без контекста · 404 вместо отказа в правах)."
      },
      {
        "id": "AC-06",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [],
    "skills": [
      "HTTP & API"
    ],
    "quickCheck": {
      "id": "QC-API-04",
      "prompt": "Quick check",
      "question": "QA тестирует <code>GET /api/admin/users</code>, залогинен как обычный customer (не admin). Какой status code ожидается?",
      "options": [
        {
          "id": "a",
          "text": "401 Unauthorized — нужен вход админом"
        },
        {
          "id": "b",
          "text": "403 Forbidden — аутентификация ОК (клиент залогинен), но прав нет (не админ)"
        },
        {
          "id": "c",
          "text": "404 Not Found — endpoint не существует для клиента"
        },
        {
          "id": "d",
          "text": "500 Internal Server Error"
        }
      ],
      "answer": "b",
      "explanation": "<strong>403 Forbidden.</strong> Customer залогинен (auth есть), но не имеет admin-прав. 401 vs 403 здесь критично: 401 — auth отсутствует (не залогинен / token невалиден); 403 — auth OK, но прав нет. 404 иногда используют как security-приём (скрыть существование), но без явного дизайн-решения admin-endpoint должен отвечать 403, чтобы QA понимал «endpoint есть, нужен admin». 500 — всегда сигнал, что бэкенд сломан. Запомни: 401 — нужен login, 403 — нужны другие права, 404 — нет такого ресурса."
    }
  },
  {
    "id": "API-05",
    "sprintId": "S09",
    "ord": 5,
    "type": "docs",
    "priority": "P0",
    "title": "Headers + Authentication + OAuth Authorization Code with PKCE teach-block",
    "estimateMin": 22,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю **самые частые заголовки** (Content-Type · Accept · Authorization · User-Agent · Cookie · Set-Cookie · Cache-Control · Location · CORS-relevant · X-Trace-Id) и где они применяются."
      },
      {
        "id": "AC-02",
        "text": "Различаю **3 типа аутентификации** (Bearer token · Basic auth · API key) и где каждый используется."
      },
      {
        "id": "AC-03",
        "text": "Понимаю **OAuth Authorization Code with PKCE** в 5 шагов · могу описать словами без подсказки."
      },
      {
        "id": "AC-04",
        "text": "Знаю **5 нюансов тестирования OAuth** (expiry · refresh · revoke · scopes · multi-account)."
      },
      {
        "id": "AC-05",
        "text": "Понимаю **CORS** как политику безопасности браузера · отличие от Postman/curl · pre-flight-запросы."
      },
      {
        "id": "AC-06",
        "text": "Распознаю **антипаттерн «токены в URL»** как инцидент безопасности."
      },
      {
        "id": "AC-07",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [],
    "skills": [
      "HTTP & API"
    ],
    "quickCheck": {
      "id": "QC-API-05",
      "prompt": "Quick check",
      "question": "QA настроила Postman collection с OAuth · token получен · работает 1 час. После часа все запросы возвращают 401. Что делать?",
      "options": [
        {
          "id": "a",
          "text": "Это баг, эскалировать бэкенду"
        },
        {
          "id": "b",
          "text": "Изменить схему Authorization на Basic"
        },
        {
          "id": "c",
          "text": "Использовать refresh_token чтобы получить новый access_token, или перелогиниться через «Get New Access Token»"
        },
        {
          "id": "d",
          "text": "Повторить запрос — может быть случайный 401"
        }
      ],
      "answer": "c",
      "explanation": "<strong>refresh_token или re-login — и это ожидаемо.</strong> 401 после часа не баг, а token expiry: OAuth access_token обычно short-lived (15 мин – 1 час) ради безопасности. Решения: (a) refresh_token (long-lived ~30 дней) → POST /oauth/token → новый access_token; (b) в Postman «Get New Access Token» в Authorization — перезапускает OAuth flow. «Эскалировать как баг» — это ожидаемое поведение. Basic в OAuth-окружении не используется. Повтор не поможет — token истёк. Запомни: OAuth-токены истекают by design, refresh обязателен для долгих тестов, Postman умеет auto-refresh."
    }
  },
  {
    "id": "API-06",
    "sprintId": "S09",
    "ord": 6,
    "type": "docs",
    "priority": "P0",
    "title": "Инструменты API — Postman + SoapUI основные · Insomnia + Bruno вспомогательные",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю **4 инструмента для API-тестирования** (Postman + SoapUI основные · Insomnia + Bruno вспомогательные) и когда какой использовать."
      },
      {
        "id": "AC-02",
        "text": "Различаю **универсальные понятия** · collections (группы сохранённых запросов) · environments (переменные на среду) · variables (переиспользуемые значения)."
      },
      {
        "id": "AC-03",
        "text": "Использую **Postman** как основной инструмент · знаю UI · могу создать collection с environments + variables."
      },
      {
        "id": "AC-04",
        "text": "Знаю, что **SoapUI единственный с нативной поддержкой SOAP** · корпорации / банкинг / регулируемые отрасли."
      },
      {
        "id": "AC-05",
        "text": "Применяю **Copy as cURL** для воспроизведения в баг-репорте · никогда не хардкожу токены / URL · всегда использую переменные."
      },
      {
        "id": "AC-06",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [],
    "skills": [
      "Workspace Tools",
      "HTTP & API"
    ],
    "quickCheck": {
      "id": "QC-API-06",
      "prompt": "Quick check",
      "question": "Команда работает с banking API, у которого есть и REST, и SOAP endpoints. Какой инструмент лучший для основного тестирования?",
      "options": [
        {
          "id": "a",
          "text": "SoapUI — единственный с нативной поддержкой SOAP · фокус корпорации/банкинг"
        },
        {
          "id": "b",
          "text": "Postman — самый популярный"
        },
        {
          "id": "c",
          "text": "Insomnia — современный UX"
        },
        {
          "id": "d",
          "text": "curl — универсальный"
        }
      ],
      "answer": "a",
      "explanation": "<strong>SoapUI.</strong> Единственный из 4 с родной поддержкой SOAP. Банкинг/финтех/регуляторика часто на SOAP (старый стандарт, но в корпорациях живёт). SoapUI умеет разбор WSDL, сборку SOAP envelope, продвинутые проверки для SOAP-ответов. Postman работает с SOAP через сырой XML в теле (обходной путь), но не оптимально. Insomnia — только REST + GraphQL. curl универсален, но не инструмент для долгого процесса. Запомни: SoapUI = SOAP + REST; Postman/Insomnia/Bruno = REST в первую очередь, GraphQL во вторую."
    }
  },
  {
    "id": "API-07",
    "sprintId": "S09",
    "ord": 7,
    "type": "docs",
    "priority": "P0",
    "title": "процесс расследования API-багов + mandatory SQL verification",
    "estimateMin": 20,
    "ac": [
      {
        "id": "AC-01",
        "text": "Применяю **5-шаговый процесс расследования** (гипотеза · DevTools Network · воспроизведение в API-инструменте · SQL-сверка · отчёт) к конкретному багу."
      },
      {
        "id": "AC-02",
        "text": "Знаю **матрицу решений** когда SQL-сверка обязательна (платежи · заказы · кэшбэк · авторизация · админ) vs необязательна (только чтение · изменения контракта) vs никогда (косметика UI)."
      },
      {
        "id": "AC-03",
        "text": "Помню **золотое правило** «успех API ≠ успех в базе» · 200 OK не означает что данные записались."
      },
      {
        "id": "AC-04",
        "text": "Распознаю антипаттерн **ложного закрытия бага** · пропуск SQL-сверки для критичных сценариев."
      },
      {
        "id": "AC-05",
        "text": "Применяю **trace ID + сопоставление логов** для распределённых систем · копирую trace ID в баг-репорт."
      },
      {
        "id": "AC-06",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [],
    "skills": [
      "HTTP & API",
      "Workspace Tools",
      "SQL"
    ],
    "quickCheck": {
      "id": "QC-API-07",
      "prompt": "Quick check",
      "question": "QA тестирует <code>POST /api/payments/complete</code> в Postman. API возвращает 200 OK. Что делать дальше для critical flow?",
      "options": [
        {
          "id": "a",
          "text": "Закрыть тест-кейс как пройденный · успех API"
        },
        {
          "id": "b",
          "text": "Повторить тест 10 раз — вдруг гонка состояний"
        },
        {
          "id": "c",
          "text": "Только сравнить тело ответа с ожидаемым — этого достаточно"
        },
        {
          "id": "d",
          "text": "SQL verification: <code>SELECT * FROM payments WHERE order_id=...</code> + <code>SELECT cashback_balance FROM users WHERE id=...</code> — подтвердить, что данные записаны / обновлены"
        }
      ],
      "answer": "d",
      "explanation": "<strong>SQL verification обязательна для critical flow.</strong> Payments — критичный flow: «API 200 OK ≠ database success». Backend может silent fail (race condition, transaction rollback, listener failure), а API всё равно вернёт 200. SQL verification — единственный способ подтвердить реальное состояние в БД. «Закрыть passed» — риск false positive, классический анти-паттерн. «Повторить 10 раз» — полезно как дополнение (race condition), но не заменяет SQL. «Только response body» — нужно, но недостаточно. Запомни: для payments/orders/кэшбэка/auth/admin SQL verification обязательна (S08 + S09)."
    }
  },
  {
    "id": "API-08",
    "sprintId": "S09",
    "ord": 8,
    "type": "docs",
    "priority": "P1",
    "title": "API bug report specifics — curl reproduction + response body + trace ID",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Применяю **формулу заголовка API-бага** «METHOD endpoint returns actual_status instead of expected_status when condition» к конкретному багу."
      },
      {
        "id": "AC-02",
        "text": "Использую **воспроизведение через curl** в Postman «Copy as cURL» (4 шага) с маскировкой PII."
      },
      {
        "id": "AC-03",
        "text": "Включаю в доказательства: **тело ответа** · **статус-код** · **trace ID** (корреляция для распределённых систем) · **Network HAR** · **SQL-запросы для сверки** (связка с T07)."
      },
      {
        "id": "AC-04",
        "text": "Различаю **функциональный API-баг** (что-то не работает) и **баг контракта API** (ломающее изменение · проблема обратной совместимости)."
      },
      {
        "id": "AC-05",
        "text": "Помню, что **trace ID = невидимый герой** распределённых систем · копирую X-Trace-Id из ответа в баг-репорт."
      },
      {
        "id": "AC-06",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [],
    "skills": [
      "Test Documentation",
      "HTTP & API"
    ],
    "quickCheck": {
      "id": "QC-API-08",
      "prompt": "Quick check",
      "question": "Найден баг: <code>POST /api/orders</code> возвращает 500. Какой Title — лучший?",
      "options": [
        {
          "id": "a",
          "text": "«API не работает»"
        },
        {
          "id": "b",
          "text": "«POST /api/orders returns 500 Internal Server Error instead of 201 Created when product_id is valid»"
        },
        {
          "id": "c",
          "text": "«Заказ не создаётся»"
        },
        {
          "id": "d",
          "text": "«Баг в endpoint заказа»"
        }
      ],
      "answer": "b",
      "explanation": "<strong>«POST /api/orders returns 500 … instead of 201 … when product_id is valid».</strong> В Title есть: метод (POST), endpoint (/api/orders), фактический статус (500), ожидаемый (201), условие (product_id валиден). Backend-Dev сразу видит scope из Title, не открывая description. «API не работает» — слишком vague (ноль actionable info). «Order не создаётся» — описывает симптом (UI-уровень), не root cause (API). «Bug в order endpoint» — мало конкретики. Запомни: {МЕТОД} {endpoint} returns {actual} instead of {expected} when {condition} — универсальная формула Title для API-бага."
    }
  },
  {
    "id": "API-09",
    "sprintId": "S09",
    "ord": 9,
    "type": "ai",
    "priority": "P1",
    "title": "AI-эпизод — 3 промпта для API testing (helper / explainer / debugger)",
    "estimateMin": 14,
    "ac": [
      {
        "id": "AC-01",
        "text": "Применяю **3 промпт-паттерна** для API-тестирования: helper (форма запроса) · explainer (объяснение ответа / статус-кода) · debugger (разбор неожиданного ответа)."
      },
      {
        "id": "AC-02",
        "text": "Знаю, что **AI галлюцинирует** на endpoint URL · потоках авторизации · форме ответа · кастомных статус-кодах."
      },
      {
        "id": "AC-03",
        "text": "Применяю **привычку проверять** · сверять предложения AI с командной API-документацией / OpenAPI spec перед использованием."
      },
      {
        "id": "AC-04",
        "text": "НИКОГДА **не вставляю реальные токены** в AI-промпты · используется заглушка."
      },
      {
        "id": "AC-05",
        "text": "Использую **указание ограничений + подачу контекста** в многошаговых сессиях для точности."
      },
      {
        "id": "AC-06",
        "text": "Quick check пройден, верный ответ подтверждён."
      }
    ],
    "istqb": [],
    "skills": [
      "AI Процесс",
      "HTTP & API"
    ],
    "quickCheck": {
      "id": "QC-API-09",
      "prompt": "Quick check",
      "question": "AI предложил использовать endpoint <code>POST /api/v2/cashback/apply</code> для теста. Что джуниор должен сделать перед запуском?",
      "options": [
        {
          "id": "a",
          "text": "Отправить запрос — AI обычно прав про endpoints"
        },
        {
          "id": "b",
          "text": "Изменить версию на v1 для безопасности"
        },
        {
          "id": "c",
          "text": "Проверить, что endpoint есть в командной API-документации (или OpenAPI spec) — если нет, это галлюцинация AI"
        },
        {
          "id": "d",
          "text": "Спросить AI ещё раз — возможно он подтвердит"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Verify через командную API-документацию.</strong> AI часто галлюцинирует endpoint URL — выдумывает правдоподобные пути («/api/v2/cashback/apply»), когда реальный может быть «/api/v3/cashback/apply» или вообще другой формы. Verify-шаг обязателен. «Submit, AI прав» — слепое доверие, ~50% шанс получить 404. «Изменить на v1» — смена версии без основания. «Спросить AI ещё раз» — не помогает (та же галлюцинация). Запомни: endpoints от AI — это догадка, всегда сверяй с командной документацией."
    }
  },
  {
    "id": "API-10",
    "sprintId": "S09",
    "ord": 10,
    "type": "mission",
    "priority": "P0",
    "title": "Миссия · найти и оформить API-баг в Atelier API · полный процесс end-to-end",
    "estimateMin": 50,
    "ac": [
      {
        "id": "AC-01",
        "text": "Сценарий Atelier API открыт · сломанный API загружен · endpoints фичи просмотрены."
      },
      {
        "id": "AC-02",
        "text": "Проведена **разведка + DevTools Network ~10 мин** · найден ≥1 подозрительный ответ API · HAR сохранён."
      },
      {
        "id": "AC-03",
        "text": "Баг воспроизведён **изолированно в Postman + curl** · «Copy as cURL» · частота и условия подтверждены."
      },
      {
        "id": "AC-04",
        "text": "Применена **обязательная SQL-сверка** (по T07 для критичных сценариев) · запрошены нужные таблицы · фактическое состояние сверено с ответом API."
      },
      {
        "id": "AC-05",
        "text": "Написан **полный баг-репорт по API** (формат T08, 11 полей) · формула Title · curl для воспроизведения · тело ответа / статус / trace ID · SQL-запросы как доказательство · Severity / Priority / Business Impact."
      },
      {
        "id": "AC-06",
        "text": "Отправлен в sandbox-tracker · curl проверен на воспроизводимость · финальная проверка за ~5 минут."
      }
    ],
    "istqb": [],
    "skills": [
      "HTTP & API",
      "Workspace Tools",
      "Test Documentation",
      "SQL"
    ],
    "mission": {
      "cta": "Открыть Mission в Atelier",
      "atelierScenarioId": "block-2-api-cashback"
    }
  },
  {
    "id": "POST-01",
    "sprintId": "S10",
    "ord": 1,
    "type": "docs",
    "priority": "P0",
    "title": "Карта инструментов API-тестирования — когда что выбирать",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Понимает позиционирование 4 главных инструментов (Postman / SoapUI / Insomnia / Bruno) и их сильные/слабые стороны"
      },
      {
        "id": "AC-02",
        "text": "Может назвать рекомендованный инструмент для 5 типичных сценариев (REST e-commerce / SOAP banking / GraphQL startup / git-first team / quick one-off)"
      },
      {
        "id": "AC-03",
        "text": "Различает SoapUI Open Source vs ReadyAPI Pro по возможностям"
      },
      {
        "id": "AC-04",
        "text": "Знает, что ВХОДИТ в S10 (Postman-мастер + выделенный SoapUI + мост Newman) и что НЕ ВХОДИТ (глубокая автоматизация / безопасность / нагрузка)"
      },
      {
        "id": "AC-05",
        "text": "Заученная формулировка для собеса: «Postman основной, SoapUI для SOAP/корпоративных систем, Insomnia/Bruno как альтернативы — выбор зависит от стиля API и процесса команды»"
      }
    ],
    "istqb": [],
    "skills": [
      "Postman",
      "HTTP & API",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-POST-01",
      "prompt": "Quick check",
      "question": "SaaS-стартап набирает QA-команду из 2-3 человек. Стек — REST API, у команды есть CI/CD, у джунов нет глубокого опыта в Java/JS. Какой инструмент взять первым?",
      "options": [
        {
          "id": "a",
          "text": "SoapUI — самый мощный корпоративный инструмент"
        },
        {
          "id": "b",
          "text": "Postman — GUI с низким порогом входа, REST-нативный, Newman даёт CLI для CI/CD одной командой"
        },
        {
          "id": "c",
          "text": "REST Assured — индустриальный стандарт для серьёзного тестирования"
        },
        {
          "id": "d",
          "text": "Karate — современный BDD-стиль, читаемые сценарии"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: Postman.</strong> 4 критерия из рамки сравнения инструментов работают за него: REST-нативный (SoapUI избыточен для чистого REST) · низкий порог входа в GUI (джуны начнут работать в первый день) · Newman CLI снимает разрыв с CI/CD · бесплатная версия покрывает 90% потребностей. Вариант (a) — SoapUI силён в SOAP/enterprise (банки, страхование), на REST-стартап это перебор. Вариант (c) — REST Assured = Java-библиотека, требует знания Java от каждого QA (для джуна без Java — блокер). Вариант (d) — Karate — code-first BDD, требует базы Java/JS. Запомни: <em>инструмент выбирают по контексту команды (REST/SOAP · GUI/код · CI/CD), а не по «самый мощный»</em>."
    }
  },
  {
    "id": "POST-02",
    "sprintId": "S10",
    "ord": 2,
    "type": "docs",
    "priority": "P0",
    "title": "Postman: основы — рабочие пространства, коллекции, окружения, переменные",
    "estimateMin": 22,
    "ac": [
      {
        "id": "AC-01",
        "text": "Установлен Postman desktop · вход выполнен"
      },
      {
        "id": "AC-02",
        "text": "Создана первая коллекция с папкой и запросом"
      },
      {
        "id": "AC-03",
        "text": "Создан Environment «Dev» с переменной `base_url` · переключение выпадашкой работает"
      },
      {
        "id": "AC-04",
        "text": "Понимает 6 уровней иерархии переменных и цепочку приоритета (Global < Collection < Environment < Data < Local < hardcoded)"
      },
      {
        "id": "AC-05",
        "text": "Знает разницу Initial Value vs Current Value · понимает почему секреты всегда в Current"
      },
      {
        "id": "AC-06",
        "text": "Открыл Postman Console (View → Show Console) и понимает её роль в отладке"
      },
      {
        "id": "AC-07",
        "text": "Знает правило: «секреты в Environment, не в Collection · Environment не коммитится в общий репозиторий»"
      }
    ],
    "istqb": [],
    "skills": [
      "Postman",
      "HTTP & API"
    ],
    "quickCheck": {
      "id": "QC-POST-02",
      "prompt": "Quick check",
      "question": "В Environment задано <code>userId=42</code>. В Collection задано <code>userId=99</code>. Pre-request script не трогает переменные. Какое значение увидит request <code>/users/{{userId}}</code>?",
      "options": [
        {
          "id": "a",
          "text": "99 (Collection ближе к запросу, она побеждает)"
        },
        {
          "id": "b",
          "text": "Postman выдаст ошибку «duplicate variable» и не отправит запрос"
        },
        {
          "id": "c",
          "text": "42 (Environment выше Collection в иерархии переменных)"
        },
        {
          "id": "d",
          "text": "Зависит от того, какую переменную задали первой"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: 42 (Environment).</strong> Variable hierarchy Postman сверху вниз: Local (Pre-request script) → Data file → Environment → Collection → Global. Чем выше уровень — тем сильнее. Environment стоит выше Collection, поэтому 42 побеждает 99. Вариант (a) — обратный порядок (типичная junior-ошибка). Вариант (b) — Postman не валидирует duplicates через уровни, тихо применяет правило приоритета. Вариант (d) — порядок задания не влияет, только уровень scope. Запомни: <em>L-D-E-C-G сверху вниз — Local побеждает всех, Global проигрывает всем</em>."
    }
  },
  {
    "id": "POST-03",
    "sprintId": "S10",
    "ord": 3,
    "type": "docs",
    "priority": "P0",
    "title": "Скрипты pm.test · Pre-request Scripts · цепочки переменных",
    "estimateMin": 28,
    "ac": [
      {
        "id": "AC-01",
        "text": "Понимает разницу Pre-request Scripts vs Tests tab (когда что выполняется в жизненном цикле запроса)"
      },
      {
        "id": "AC-02",
        "text": "Может написать 6 базовых паттернов pm.test без подсматривания (status / oneOf / json field / header / response time / body include)"
      },
      {
        "id": "AC-03",
        "text": "Знает 3 сценария Pre-request Scripts (timestamp · подпись · динамические данные)"
      },
      {
        "id": "AC-04",
        "text": "Реализовал разбор: login → сохранить токен → использовать в следующем запросе через `pm.environment.set(\"auth_token\", ...)` + Bearer auth `{{auth_token}}`"
      },
      {
        "id": "AC-05",
        "text": "Знает правило: pm.test не throw · `pm.environment.set` лучше делать вне pm.test или с if-проверкой"
      },
      {
        "id": "AC-06",
        "text": "Использует Postman Console + console.log для отладки проваленных assertions"
      },
      {
        "id": "AC-07",
        "text": "Знает где находится панель сниппетов (правый край Tests tab) для копи-пейста типичных паттернов"
      }
    ],
    "istqb": [],
    "skills": [
      "Postman",
      "API Contract Testing",
      "HTTP & API"
    ],
    "quickCheck": {
      "id": "QC-POST-03",
      "prompt": "Quick check",
      "question": "В Tests tab написано: <code>pm.test(\"status 200\", function () { pm.response.to.have.status(200); });</code>. Запрос вернул 404. Что произойдёт?",
      "options": [
        {
          "id": "a",
          "text": "Postman остановит выполнение Collection на этом запросе"
        },
        {
          "id": "b",
          "text": "Test Results покажет «status 200» с красным крестом (assertion failed), запрос выполнился, остальные тесты этого запроса тоже отработают"
        },
        {
          "id": "c",
          "text": "Postman отменит запрос и попросит исправить assertion"
        },
        {
          "id": "d",
          "text": "Pre-request script повторно запустится, чтобы починить запрос"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: Test Results покажет failed.</strong> pm.test регистрирует assertion в Test Results — pass или fail отображается отдельной строкой в зависимости от того, прошёл pm.expect или нет. Один failed test НЕ останавливает других tests того же request — все pm.test выполняются. В Collection Runner один failed test тоже не остановит выполнение Collection (если не настроено explicitly). Варианты (a), (c), (d) — Postman не «защищает» от неудачных тестов: твоя задача как QA — увидеть failed и расследовать. Запомни: <em>pm.test — это assertion checkpoint, не gate: failed test = красный крест в отчёте, не остановка процесса</em>."
    }
  },
  {
    "id": "POST-04",
    "sprintId": "S10",
    "ord": 4,
    "type": "docs",
    "priority": "P0",
    "title": "Тестирование на данных · Collection Runner · CSV / JSON / iterationData",
    "estimateMin": 24,
    "ac": [
      {
        "id": "AC-01",
        "text": "Открыл Collection Runner (правый клик на коллекцию → Run, или кнопка Runner справа вверху)"
      },
      {
        "id": "AC-02",
        "text": "Создал CSV минимум на 3 строки + header · загрузил через «Select File» в Runner"
      },
      {
        "id": "AC-03",
        "text": "Использует `pm.iterationData.get(\"field_name\")` в Tests tab для проверки ожидаемого на каждую итерацию"
      },
      {
        "id": "AC-04",
        "text": "Понимает разницу CSV vs JSON и когда что выбирать (табличные vs вложенные)"
      },
      {
        "id": "AC-05",
        "text": "Понимает место iterationData в иерархии переменных (4-й уровень · выше Environment, ниже Local)"
      },
      {
        "id": "AC-06",
        "text": "Может назвать 3 применения data-driven (BVA · regression sweep · localization)"
      },
      {
        "id": "AC-07",
        "text": "Знает что iterationData доступен только в Collection Runner / Newman-прогонах (не в обычном Send)"
      },
      {
        "id": "AC-08",
        "text": "Знает правило: вложенные структуры → JSON · табличные тесты → CSV"
      }
    ],
    "istqb": [],
    "skills": [
      "Postman",
      "Test Design",
      "HTTP & API"
    ],
    "quickCheck": {
      "id": "QC-POST-04",
      "prompt": "Quick check",
      "question": "У тебя request <code>POST /login</code> с body <code>{ \"email\": \"{{email}}\", \"password\": \"{{password}}\" }</code>. Подключила CSV из 30 строк через Collection Runner. Что произойдёт при Run?",
      "options": [
        {
          "id": "a",
          "text": "Postman распараллелит и отправит 30 requests одновременно"
        },
        {
          "id": "b",
          "text": "Postman пошлёт один request с массивом из 30 пар email/password"
        },
        {
          "id": "c",
          "text": "Postman заставит выбрать одну строку перед запуском"
        },
        {
          "id": "d",
          "text": "Postman выполнит request 30 раз последовательно, подставляя email/password из каждой строки CSV на каждой итерации, pm.test прогонит для всех 30"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: 30 итераций последовательно.</strong> Collection Runner с data file = data-driven loop: каждая строка CSV становится одной iteration, переменные {{email}} и {{password}} подставляются из соответствующих колонок, pm.test выполняется на каждой итерации отдельно. На выходе — отчёт со всеми 30 результатами. Вариант (a) — Postman по умолчанию sequential, не parallel. Вариант (b) — не отправляет batch, шлёт 30 отдельных requests. Вариант (c) — выбирать не надо, проходит все автоматически. Запомни: <em>1 request + CSV из N строк через Collection Runner = N requests с подставленными значениями + N прогонов тестов</em>."
    }
  },
  {
    "id": "POST-05",
    "sprintId": "S10",
    "ord": 5,
    "type": "docs",
    "priority": "P0",
    "title": "SoapUI: основы · Project · TestSuite · TestCase · TestStep",
    "estimateMin": 26,
    "ac": [
      {
        "id": "AC-01",
        "text": "Установлен SoapUI Open Source · GUI запущен"
      },
      {
        "id": "AC-02",
        "text": "Создан REST Project с одним endpoint (тот же, что был в Postman T02 — для ощущения моста)"
      },
      {
        "id": "AC-03",
        "text": "Создана иерархия Project → TestSuite → TestCase → TestStep с минимум 2 REST-запросами"
      },
      {
        "id": "AC-04",
        "text": "Применил минимум 3 типа Assertions через UI (Status / JSONPath Match / Response SLA)"
      },
      {
        "id": "AC-05",
        "text": "Использовал Property Transfer step для цепочки токена между REST-запросами"
      },
      {
        "id": "AC-06",
        "text": "Открыл Groovy TestStep · видел синтаксис · знает где искать сниппеты"
      },
      {
        "id": "AC-07",
        "text": "Может объяснить когда SoapUI выигрывает у Postman (SOAP/WSDL · DataSource Excel · смесь REST+SOAP · экосистема Groovy)"
      },
      {
        "id": "AC-08",
        "text": "Понимает что SoapUI Open Source ≠ ReadyAPI Pro · знает что платные функции (Performance / Security / ServiceV) на S10 не используем"
      }
    ],
    "istqb": [],
    "skills": [
      "SoapUI",
      "HTTP & API",
      "Test Documentation"
    ],
    "quickCheck": {
      "id": "QC-POST-05",
      "prompt": "Quick check",
      "question": "Джуниор получил задачу проверить SOAP API банковской системы. Команда дала WSDL-файл. Первый шаг в SoapUI?",
      "options": [
        {
          "id": "a",
          "text": "Открыть Postman и конвертировать SOAP в REST через плагин"
        },
        {
          "id": "b",
          "text": "New SOAP Project → импортировать WSDL → SoapUI автоматически сгенерирует Project → TestSuite → TestCase → TestStep по описанным operations"
        },
        {
          "id": "c",
          "text": "Создать пустой REST Service и копировать XML руками"
        },
        {
          "id": "d",
          "text": "Сначала записать одну транзакцию через proxy, потом replay"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: New SOAP Project + импорт WSDL.</strong> SoapUI это «WSDL-first» tool: WSDL описывает все доступные operations, SoapUI читает XML-описание и автоматически генерирует skeleton Project с TestSuite/TestCase/TestStep для каждой operation. Джуниор получает готовый каркас за 30 секунд, начинает работу с Assertions, а не с ручного составления XML. Вариант (a) — Postman не умеет нативно SOAP (REST-focused). Вариант (c) — ручная работа = потеря дней на то, что tool делает за секунду. Вариант (d) — proxy recording это другой workflow (для legacy без WSDL). Запомни: <em>SOAP + WSDL → SoapUI New SOAP Project + Import WSDL = автогенерация TestSuite за секунды</em>."
    }
  },
  {
    "id": "POST-06",
    "sprintId": "S10",
    "ord": 6,
    "type": "docs",
    "priority": "P0",
    "title": "SoapUI продвинутый · DataSource · DataLoop · логика Groovy · Mock-сервисы",
    "estimateMin": 24,
    "ac": [
      {
        "id": "AC-01",
        "text": "Создал DataSource step (CSV или Grid · уровень джуниор) с минимум 3 строками"
      },
      {
        "id": "AC-02",
        "text": "Понимает разницу 5 типов DataSource (Excel · CSV · JDBC · Grid · Directory) · знает когда что выбирать"
      },
      {
        "id": "AC-03",
        "text": "Создал DataLoop step с правильной ссылкой «Loop back to»"
      },
      {
        "id": "AC-04",
        "text": "Прочитал Groovy-сниппеты (5 паттернов) · может вызвать context.expand для доступа к property DataSource"
      },
      {
        "id": "AC-05",
        "text": "Понимает что Mock Service — это локальный fake-сервер · знает 3 сценария (backend in progress · симуляция крайних случаев · contract testing teaser)"
      },
      {
        "id": "AC-06",
        "text": "Знает правило: JDBC из тестов — только read-only user, никогда prod с правами записи"
      },
      {
        "id": "AC-07",
        "text": "Знает: Groovy ≠ JS · API другой (testRunner / context / log) · шпаргалка рядом первые 2 недели"
      }
    ],
    "istqb": [],
    "skills": [
      "SoapUI",
      "Test Design",
      "API Contract Testing"
    ],
    "quickCheck": {
      "id": "QC-POST-06",
      "prompt": "Quick check",
      "question": "Нужно прогнать 50 logins из Excel через SoapUI, забирая token из response Step 1 и подставляя в header Step 2. Какая комбинация TestSteps решает это?",
      "options": [
        {
          "id": "a",
          "text": "DataSource + REST Request + Assertions (token потеряется между итерациями)"
        },
        {
          "id": "b",
          "text": "Только REST Request, скопировать 50 пар login/password в body 50 раз вручную"
        },
        {
          "id": "c",
          "text": "DataSource (Excel) → DataLoop → REST Request (login) → Property Transfer (token из response в header) → REST Request (protected endpoint)"
        },
        {
          "id": "d",
          "text": "Groovy Script с hardcoded циклом по 50 строкам без DataSource"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: DataSource → DataLoop → REST Request → Property Transfer → REST Request.</strong> Это canonical pattern data-driven SoapUI с переносом значения между шагами. DataSource читает Excel → DataLoop повторяет цепочку для каждой строки → Property Transfer перекладывает поле из одного TestStep в другой (token из response Step 1 в header Step 2). Вариант (a) — без DataLoop и Property Transfer ничего не зациклится и не перенесётся. Вариант (b) — ручная работа на 50 строк = час потерянного времени + ноль reuse. Вариант (d) — Groovy это fallback когда UI tool недостаточно, а здесь UI tool достаточно. Запомни: <em>DataSource = откуда · DataLoop = повторитель · Property Transfer = мост между Steps</em>."
    }
  },
  {
    "id": "POST-07",
    "sprintId": "S10",
    "ord": 7,
    "type": "docs",
    "priority": "P1",
    "title": "Матрица выбора инструмента · Postman vs SoapUI vs Insomnia vs Bruno",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знает 8 осей сравнения (REST · SOAP · Scripting · CI · Pricing · Git-friendly · GraphQL/gRPC · Ecosystem)"
      },
      {
        "id": "AC-02",
        "text": "Может пройти дерево решений (5-сек схема) и обосновать выбор для 5 типичных командных сценариев"
      },
      {
        "id": "AC-03",
        "text": "Понимает что «правильного» инструмента нет · контекст решает · мульти-инструментальные стеки нормальны"
      },
      {
        "id": "AC-04",
        "text": "Знает 5 путей миграции (Postman→REST Assured · Postman→Bruno · SoapUI OS→ReadyAPI · Insomnia→Postman/Bruno · GUI→automation framework)"
      },
      {
        "id": "AC-05",
        "text": "Знаком с процессом выбора инструмента ISTQB Ch.6.2 (6 шагов)"
      },
      {
        "id": "AC-06",
        "text": "Может на собесе ответить «зависит от осей — REST vs SOAP · скриптинг · CI · git-friendly · экосистема» вместо догматичного «Postman лучший»"
      },
      {
        "id": "AC-07",
        "text": "Знает правило: «выбор инструмента — инженерное решение, не личное предпочтение»"
      }
    ],
    "istqb": [],
    "skills": [
      "Postman",
      "SoapUI",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-POST-07",
      "prompt": "Quick check",
      "question": "На собес: «какой инструмент ты бы выбрала для тестирования API нашей системы». Какой ответ зрелее?",
      "options": [
        {
          "id": "a",
          "text": "«Postman, я с ним работала»"
        },
        {
          "id": "b",
          "text": "«SoapUI — он самый мощный»"
        },
        {
          "id": "c",
          "text": "«Зависит от контекста: REST или SOAP, размер команды, есть ли CI/CD, какой стек языков, опыт команды — для вашего случая я бы взяла {инструмент} потому что {1-2 критерия}, и могу обосновать переход через PoC»"
        },
        {
          "id": "d",
          "text": "«Самое популярное — Postman, всегда берут его»"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: ответ через рамку выбора.</strong> Рекрутер и Tech Lead слышат инженерный регистр в этом ответе: ты не «знаешь Postman», ты понимаешь, что выбор инструмента — это решение со своими критериями (REST/SOAP, масштаб, стек, CI/CD, кривая обучения команды). Вариант (a) — личный опыт без контекста = «один инструмент, который я знаю». Вариант (b) — «самый мощный» без условий = не видишь компромиссов. Вариант (d) — «как все» = не показывает твоего вклада. Запомни: <em>«знаю Postman» → юниор · «выбираю инструмент по 5-8 критериям контекста» → регистр готового к middle</em>."
    }
  },
  {
    "id": "POST-08",
    "sprintId": "S10",
    "ord": 8,
    "type": "docs",
    "priority": "P0",
    "title": "Newman CLI + мост CI/CD · GitHub Actions · «бесконечный цикл»",
    "estimateMin": 30,
    "ac": [
      {
        "id": "AC-01",
        "text": "Установлен Newman через `npm install -g newman` · `newman --version` работает"
      },
      {
        "id": "AC-02",
        "text": "Коллекция запущена через CLI: `newman run collection.json -e env.json -d data.csv`"
      },
      {
        "id": "AC-03",
        "text": "Понимает 4 reporter-формата (cli · json · junit · html) и когда какой выбирать"
      },
      {
        "id": "AC-04",
        "text": "Знает значение exit code (0 = pass · 1 = fail) и почему критичен для CI"
      },
      {
        "id": "AC-05",
        "text": "Может прочитать GitHub Actions YAML и понять что происходит на каждом шаге"
      },
      {
        "id": "AC-06",
        "text": "Понимает «бесконечный цикл» CI/CD · 8 фаз · знает что Newman живёт в фазе Test"
      },
      {
        "id": "AC-07",
        "text": "Различает CI vs CD-Delivery vs CD-Deployment vs CT (4 концепции)"
      },
      {
        "id": "AC-08",
        "text": "Может назвать 6 стадий pipeline (Source · Build · Test · Release · Deploy · Monitor) с примером инструментов для каждой"
      },
      {
        "id": "AC-09",
        "text": "Знает аналог в SoapUI — testrunner.bat/.sh с теми же концепциями (run · filter · report · exit code)"
      },
      {
        "id": "AC-10",
        "text": "Понимание: T08 = введение · полная настройка CI/CD = S16"
      }
    ],
    "istqb": [],
    "skills": [
      "Postman",
      "HTTP & API",
      "API Contract Testing"
    ],
    "quickCheck": {
      "id": "QC-POST-08",
      "prompt": "Quick check",
      "question": "Postman collection нужно прогонять автоматически в CI/CD pipeline после каждого merge. Как это организуется?",
      "options": [
        {
          "id": "a",
          "text": "Установить Postman desktop на CI/CD сервер, scheduler нажимает Run по cron"
        },
        {
          "id": "b",
          "text": "Postman cloud сам отслеживает merge и запускает, ты только подключаешь интеграцию"
        },
        {
          "id": "c",
          "text": "Экспортировать HTML отчёт раз в день и слать в Slack"
        },
        {
          "id": "d",
          "text": "Newman: <code>newman run collection.json --reporters cli,junit</code> в CI step → exit code 0 = pass, не-ноль = fail → CI решает блокировать merge или нет"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: Newman + exit code.</strong> Newman это CLI-runner для Postman collections, специально создан для CI/CD: запускается без UI, возвращает exit code (0=pass, не-ноль=fail), CI читает exit code и решает блокировать merge или нет. JUnit-reporter генерит XML, который понимают все CI-системы. Вариант (a) — desktop tool в CI бессмысленно (нужен display, тормозит, не возвращает exit code чисто). Вариант (b) — Postman cloud не имеет «native CI hook», нужен Newman или Postman Monitor. Вариант (c) — отчёт раз в день = слишком поздно ловить регрессию (нужно блокировать merge сразу). Запомни: <em>Newman = мост Postman → CI/CD · exit code = язык, который CI понимает</em>."
    }
  },
  {
    "id": "POST-09",
    "sprintId": "S10",
    "ord": 9,
    "type": "docs",
    "priority": "P0",
    "title": "AI-эпизод · AI для генерации тестов · ревью · границы",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знает 5 сценариев AI в процессе Postman/SoapUI (скелет коллекции · генерация pm.test · ревью · curl→Postman · генерация тестовых данных)"
      },
      {
        "id": "AC-02",
        "text": "Может составить prompt по 3 паттернам с правильной структурой (контекст · вход · ожидаемый вывод)"
      },
      {
        "id": "AC-03",
        "text": "Понимает границы AI (хорош на boilerplate / публичных API · галлюцинирует на внутренних · не знает бизнес-правил команды)"
      },
      {
        "id": "AC-04",
        "text": "Применяет чек-лист ревью к AI-выводу (endpoints / fields / assertion logic / expected values / крайние случаи)"
      },
      {
        "id": "AC-05",
        "text": "Знает правило: конфиденциальные данные НЕ в публичные AI-инструменты · санитизация или корпоративный тариф"
      },
      {
        "id": "AC-06",
        "text": "Может на собесе сказать «AI ускоряет первый драфт, я ревьюю каждый вывод» (правильный регистр)"
      },
      {
        "id": "AC-07",
        "text": "Знаком с Postman Postbot (встроенный AI-помощник)"
      },
      {
        "id": "AC-08",
        "text": "Знаком с ISTQB CT-AI Extension (вперёд к S17)"
      }
    ],
    "istqb": [],
    "skills": [
      "AI Процесс",
      "Postman",
      "SoapUI"
    ],
    "quickCheck": {
      "id": "QC-POST-09",
      "prompt": "Quick check",
      "question": "Джуниор попросил ChatGPT написать pm.test для нового endpoint. AI выдал 15 строк JS. Следующий шаг junior'а?",
      "options": [
        {
          "id": "a",
          "text": "Скопировать в Tests tab и нажать Send — если pass, значит AI правильный"
        },
        {
          "id": "b",
          "text": "Спросить AI «работает ли это?» и доверять ответу"
        },
        {
          "id": "c",
          "text": "Прочитать каждый pm.expect, сверить field paths с реальным response (часто AI выдумывает поля), запустить, посмотреть Test Results, поправить под фактический shape"
        },
        {
          "id": "d",
          "text": "Сразу commit в Collection, попросить senior review позже"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: review-loop перед запуском.</strong> AI = force multiplier, не autopilot. AI часто галлюцинирует field paths (выдумывает несуществующие поля в response), путает status codes, использует устаревший синтаксис pm.test. Джуниор с review-loop ловит это за минуту и адаптирует. Джуниор без review-loop пушит broken tests в Collection, которые «как бы pass» на тестовых данных и ломаются в CI. Вариант (a) — pass на одном Send ≠ corectness. Вариант (b) — AI не валидирует сам себя. Вариант (d) — senior review позже = баг попадает в master. Запомни: <em>AI-output без review = технический долг с первого дня · 5 минут review экономят 5 часов отладки</em>."
    }
  },
  {
    "id": "POST-10",
    "sprintId": "S10",
    "ord": 10,
    "type": "mission",
    "priority": "P0",
    "title": "Миссия Atelier · API-расследование · сборка + диагностика + мост SoapUI",
    "estimateMin": 60,
    "ac": [
      {
        "id": "AC-01",
        "text": "Postman-коллекция построена: минимум 6 запросов с проверками pm.test для расследования"
      },
      {
        "id": "AC-02",
        "text": "`pm.environment.set` использован для цепочки auth_token и наблюдаемых значений"
      },
      {
        "id": "AC-03",
        "text": "Диагностированы 3 сломанных pm.test (to.exist false-pass · to.be.true anti-pattern · forEach+empty array · case-sensitivity) и починены через strict assertions + понятные ошибки"
      },
      {
        "id": "AC-04",
        "text": "Проведена SQL-сверка минимум 4 запросов (balances · transactions · orders · audit) для анализа первопричины"
      },
      {
        "id": "AC-05",
        "text": "Проведён шаг-связка SoapUI: минимум 1 критичный запрос с идентичными проверками для перекрёстной сверки инструментами"
      },
      {
        "id": "AC-06",
        "text": "Оформлен баг-репорт с воспроизведением через curl · severity+priority с обоснованием · доказательства расследования · гипотеза первопричины · пометка обходного пути (если применим) · запрос охвата затронутых пользователей"
      },
      {
        "id": "AC-07",
        "text": "Отчёт по миссии написан в джуниор-регистре (что сделано · что усвоено · что улучшить)"
      },
      {
        "id": "AC-08",
        "text": "Понимает: Mission = симуляция работы · элемент портфолио для собеса"
      }
    ],
    "istqb": [],
    "skills": [
      "Postman",
      "SoapUI",
      "HTTP & API",
      "API Contract Testing",
      "SQL",
      "AI Процесс"
    ],
    "mission": {
      "cta": "Открыть Mission в Atelier",
      "atelierScenarioId": "block-2-postman-cashback"
    },
    "quickCheck": {
      "id": "QC-POST-10",
      "prompt": "Quick check",
      "question": "В Mission сценарий воспроизведён через Postman: <code>POST /api/orders</code> вернул 200 OK. Клиент жалуется: «оплатил, заказа нет в моей истории». Block 2 рефлекс — какой следующий ход?",
      "options": [
        {
          "id": "a",
          "text": "Закрыть тикет как not-reproducible (раз Postman 200, всё ок)"
        },
        {
          "id": "b",
          "text": "Эскалировать Dev'у «не работает, разбирайся»"
        },
        {
          "id": "c",
          "text": "Очистить cache Postman и повторить request"
        },
        {
          "id": "d",
          "text": "Mandatory SQL verification (cross-link S08): <code>SELECT * FROM orders WHERE user_id = ? ORDER BY created_at DESC LIMIT 5</code> — проверить, физически записался ли заказ в БД и в каком статусе"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: SQL verification в orders.</strong> 200 OK от API ≠ «данные сохранились правильно». Может быть: транзакция rolled back после response отправлен, INSERT прошёл но в неправильную партицию, async job не отработал, статус заказа = pending вместо paid. Mandatory SQL verification из S08 закрывает эту слепую зону за 30 секунд. Вариант (a) — закрытие без БД-проверки = баг едет в prod. Вариант (b) — эскалация без расследования = джуниор теряет в credibility (Dev спросит «а что было проверено?»). Вариант (c) — Postman cache не влияет на server state. Запомни: <em>200 OK = ответ дошёл; SQL verify = данные легли правильно — это два разных факта</em>."
    }
  },
  {
    "id": "SQL-D1",
    "sprintId": "S11",
    "ord": 1,
    "type": "docs",
    "priority": "P0",
    "title": "Зачем SQL глубже + второй стек данных — мотивация Block 2 финал",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Может назвать 3 типа сложных queries, где basic SQL не справляется (subquery / recursive CTE / window functions) и привести по одному real-world use case"
      },
      {
        "id": "AC-02",
        "text": "Может назвать 3 типа real-world use cases для NoSQL (Mongo для гибкой schema · Redis для кэша/сессий · Faker для test data разнообразия)"
      },
      {
        "id": "AC-03",
        "text": "Различает что входит в S11 (SQL deep core + NoSQL toolkit + Faker) vs что НЕ входит (NoSQL deep · DB performance deep · migrations)"
      },
      {
        "id": "AC-04",
        "text": "Понимает позиционирование: после S11 — закрытие skill #11 SQL · awareness MongoDB/Redis · gap-fill test data prep"
      },
      {
        "id": "AC-05",
        "text": "Awareness polyglot persistence pattern (senior-ext)"
      },
      {
        "id": "AC-06",
        "text": "Awareness CAP theorem · знает что eventual consistency может быть feature, не bug (senior-ext)"
      },
      {
        "id": "AC-07",
        "text": "Заученная формулировка для собеса: «PostgreSQL primary, MongoDB + Redis awareness, понимаю когда что выбирают» — comparison-driven thinking"
      }
    ],
    "istqb": [],
    "skills": [
      "SQL",
      "QA Concepts",
      "AI Workflow"
    ],
    "quickCheck": {
      "id": "QC-SQL-D1",
      "prompt": "Quick check",
      "question": "Junior умеет SELECT/WHERE/JOIN/GROUP BY (S08 base). На работе задача: «найди ПЕРВЫЙ заказ КАЖДОГО клиента и его total». Что нужно дополнительно к basic SQL?",
      "options": [
        {
          "id": "a",
          "text": "Subquery с MIN(created_at) per user или window function <code>ROW_NUMBER() OVER (PARTITION BY user_id ORDER BY created_at)</code> + WHERE rn=1"
        },
        {
          "id": "b",
          "text": "Excel: выгрузить все заказы и руками отсортировать по user_id + created_at"
        },
        {
          "id": "c",
          "text": "Сразу эскалировать в data team — это сложная аналитика"
        },
        {
          "id": "d",
          "text": "Только базовый SQL — задача решается одним GROUP BY user_id"
        }
      ],
      "answer": "a",
      "explanation": "<strong>Правильно: subquery или window function.</strong> GROUP BY user_id даёт по одной строке на клиента, но «первый заказ» это не агрегат — это конкретная строка с конкретным total. Basic SQL умеет MIN(created_at), но не умеет «дай total ИЗ ТОЙ ЖЕ строки где MIN(created_at)» в один шаг. Subquery (<code>WHERE created_at = (SELECT MIN(created_at) FROM orders WHERE user_id = o.user_id)</code>) или window function решают это за один query. Вариант (d) — GROUP BY теряет связь между min(created_at) и total. Вариант (b) — Excel не масштабируется на 1M заказов. Вариант (c) — задача junior-уровня после S11. Запомни: <em>«первый/последний/n-й per group» = subquery или window function, не GROUP BY</em>."
    }
  },
  {
    "id": "SQL-D2",
    "sprintId": "S11",
    "ord": 2,
    "type": "docs",
    "priority": "P0",
    "title": "Subqueries · подзапросы · WHERE EXISTS · WHERE IN · scalar",
    "estimateMin": 26,
    "ac": [
      {
        "id": "AC-01",
        "text": "Может объяснить 3 места, где может стоять subquery (WHERE · FROM · SELECT) с примером для каждого"
      },
      {
        "id": "AC-02",
        "text": "Различает correlated (ссылается на внешний запрос · выполняется для каждой строки) vs non-correlated (один раз отдельно)"
      },
      {
        "id": "AC-03",
        "text": "Знает 4 главных pattern'а: WHERE IN · WHERE EXISTS · WHERE = scalar · FROM derived table — может написать без подсматривания"
      },
      {
        "id": "AC-04",
        "text": "Применяет decision framework subquery vs JOIN (matching → JOIN/IN · existence → EXISTS · anti-join → NOT EXISTS · aggregate compare → scalar · multi-step → CTE)"
      },
      {
        "id": "AC-05",
        "text": "Знает rule: для anti-join всегда NOT EXISTS, не NOT IN (NULL trap)"
      },
      {
        "id": "AC-06",
        "text": "Понимает performance trade-off: correlated subquery в SELECT может быть медленным на больших таблицах · переписать в JOIN+GROUP BY для production scale"
      },
      {
        "id": "AC-07",
        "text": "Прошёл worked example: «orders > avg» · «users без orders» · «count orders per user» — может вспомнить query без подсказки"
      },
      {
        "id": "AC-08",
        "text": "Awareness ANY / ALL operators (senior-ext)"
      },
      {
        "id": "AC-09",
        "text": "Awareness comparison subquery / CTE / window / JOIN+GROUP BY · знает когда что (senior-ext)"
      }
    ],
    "istqb": [],
    "skills": [
      "SQL",
      "Test Design"
    ],
    "quickCheck": {
      "id": "QC-SQL-D2",
      "prompt": "Quick check",
      "question": "Задача: «найди заказы, total которых выше среднего по всем заказам». Какая структура query корректна?",
      "options": [
        {
          "id": "a",
          "text": "<code>SELECT * FROM orders WHERE total &gt; AVG(total)</code> — WHERE с aggregate сразу работает"
        },
        {
          "id": "b",
          "text": "<code>SELECT * FROM orders HAVING total &gt; AVG(total)</code> — HAVING решает проблему"
        },
        {
          "id": "c",
          "text": "<code>SELECT * FROM orders WHERE total &gt; (SELECT AVG(total) FROM orders)</code> — subquery вычисляет среднее, внешний WHERE сравнивает с ним"
        },
        {
          "id": "d",
          "text": "Нужно сначала выгрузить в Excel и посчитать среднее там"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: subquery в WHERE.</strong> WHERE не работает с aggregate-функциями напрямую (AVG/SUM/COUNT) — нужно либо HAVING (для GROUP BY), либо subquery, которая вернёт скалярное значение. Subquery <code>(SELECT AVG(total) FROM orders)</code> выполняется один раз, возвращает одно число, внешний WHERE сравнивает каждую строку с этим числом. Вариант (a) — синтаксическая ошибка, DB вернёт «aggregate functions are not allowed in WHERE». Вариант (b) — HAVING работает только после GROUP BY, без него тоже ошибка. Вариант (d) — задача SQL уровня. Запомни: <em>WHERE с aggregate = subquery; HAVING нужен только когда есть GROUP BY</em>."
    }
  },
  {
    "id": "SQL-D3",
    "sprintId": "S11",
    "ord": 3,
    "type": "docs",
    "priority": "P0",
    "title": "CTE · Common Table Expressions · WITH clause + recursive",
    "estimateMin": 28,
    "ac": [
      {
        "id": "AC-01",
        "text": "Может объяснить базовый синтаксис CTE: <code>WITH name AS (SELECT ...) SELECT * FROM name;</code>"
      },
      {
        "id": "AC-02",
        "text": "Различает 3 формы CTE: simple · multiple chained · recursive"
      },
      {
        "id": "AC-03",
        "text": "Может написать multiple chained CTE с 3 шагами без подсматривания (для top-N per group или похожего pattern)"
      },
      {
        "id": "AC-04",
        "text": "Может написать basic recursive CTE для tree traversal: anchor + UNION ALL + recursive part (для дерева категорий или org chart)"
      },
      {
        "id": "AC-05",
        "text": "Применяет 4-criteria checklist «когда CTE»: 3+ уровня вложенности · 2+ usage of derived table · tree/hierarchy · code review request"
      },
      {
        "id": "AC-06",
        "text": "Знает rule: для anti-cycle safety guard в recursive CTE — <code>WHERE depth &lt; 100</code>"
      },
      {
        "id": "AC-07",
        "text": "Awareness: PostgreSQL 12+ hint MATERIALIZED / NOT MATERIALIZED для CTE optimization (senior-ext)"
      },
      {
        "id": "AC-08",
        "text": "Awareness: recursive CTE patterns beyond tree categories — org chart · sequence generation · graph path finding (senior-ext)"
      }
    ],
    "istqb": [],
    "skills": [
      "SQL",
      "Test Design"
    ],
    "quickCheck": {
      "id": "QC-SQL-D3",
      "prompt": "Quick check",
      "question": "У тебя query с 4 уровнями вложенных subquery в FROM — читать невозможно, ошибку искать долго. Что даёт переписывание через CTE (WITH-клауза)?",
      "options": [
        {
          "id": "a",
          "text": "Ускорит выполнение — CTE автоматически кешируется в памяти"
        },
        {
          "id": "b",
          "text": "Даст каждому уровню имя (<code>WITH step1 AS (...), step2 AS (...) SELECT ... FROM step2</code>) — query читается сверху вниз как pipeline, debug проще"
        },
        {
          "id": "c",
          "text": "Уберёт необходимость в WHERE"
        },
        {
          "id": "d",
          "text": "Заменит JOIN'ы на UNION и упростит логику"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: имена + читаемость + debug.</strong> CTE — это про organization, не про performance (в большинстве DB CTE не кешируется, исполняется как обычный subquery). Главная польза: каждый WITH-блок имеет имя, можно читать сверху вниз как «сначала вычислили X, потом Y использовал X, потом final SELECT использовал Y» — это pipeline-mental-model. Debug упрощается: можно прокомментировать <code>SELECT * FROM step1</code> чтобы проверить промежуточный результат. Вариант (a) — performance не меняется (а в некоторых DB CTE даже медленнее из-за optimization fence). Вариант (d) — CTE не заменяет JOIN, это разные tools. Вариант (c) — WHERE остаётся. Запомни: <em>CTE = читаемость и debug, не speed</em>."
    }
  },
  {
    "id": "SQL-D4",
    "sprintId": "S11",
    "ord": 4,
    "type": "docs",
    "priority": "P0",
    "title": "Window functions · ROW_NUMBER · RANK · LAG · LEAD · OVER",
    "estimateMin": 30,
    "ac": [
      {
        "id": "AC-01",
        "text": "Может объяснить анатомию window function: <code>function() OVER (PARTITION BY ... ORDER BY ...)</code> с пояснением каждой части"
      },
      {
        "id": "AC-02",
        "text": "Знает 5 главных функций junior уровня: ROW_NUMBER · RANK / DENSE_RANK · LAG / LEAD · SUM/AVG OVER · NTILE"
      },
      {
        "id": "AC-03",
        "text": "Различает ROW_NUMBER (без ties) vs RANK (ties + skips) vs DENSE_RANK (ties без skips)"
      },
      {
        "id": "AC-04",
        "text": "Может написать «top-N per group» pattern без подсматривания (CTE + ROW_NUMBER + WHERE rn &lt;= N)"
      },
      {
        "id": "AC-05",
        "text": "Может написать LAG для compare-with-previous (e.g., gap detection · balance change)"
      },
      {
        "id": "AC-06",
        "text": "Может написать SUM OVER для running total"
      },
      {
        "id": "AC-07",
        "text": "Различает window function vs GROUP BY (window сохраняет строки · GROUP BY схлопывает)"
      },
      {
        "id": "AC-08",
        "text": "Знает rule: window function НЕЛЬЗЯ в WHERE — заворачивай в CTE"
      },
      {
        "id": "AC-09",
        "text": "Знает rule: LAG/LEAD первой/последней строки = NULL — оборачивай в COALESCE"
      },
      {
        "id": "AC-10",
        "text": "Awareness frame clauses (ROWS BETWEEN N PRECEDING AND CURRENT ROW) для rolling averages (senior-ext)"
      }
    ],
    "istqb": [],
    "skills": [
      "SQL",
      "Test Design"
    ],
    "quickCheck": {
      "id": "QC-SQL-D4",
      "prompt": "Quick check",
      "question": "Чем <code>ROW_NUMBER() OVER (PARTITION BY user_id ORDER BY created_at)</code> отличается от <code>GROUP BY user_id</code>?",
      "options": [
        {
          "id": "a",
          "text": "Ничем — это два способа сделать одно и то же, выбирай любой"
        },
        {
          "id": "b",
          "text": "Window медленнее, но точнее"
        },
        {
          "id": "c",
          "text": "Window работает только в PostgreSQL, в MySQL нет"
        },
        {
          "id": "d",
          "text": "GROUP BY схлопывает 1000 заказов в N групп (по одной строке на user_id); window function сохраняет все 1000 строк И добавляет колонку с номером заказа внутри клиента"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: GROUP BY схлопывает, window нет.</strong> Это главное концептуальное различие. GROUP BY — агрегация: 1000 заказов → N групп (один заказ остаётся для каждого user_id, остальные «сворачиваются» в SUM/COUNT/AVG). Window function — обогащение: 1000 заказов остаются 1000 строк, но к каждой добавляется computed column (номер, ранг, накопительная сумма, разница с предыдущим). Junior выбирает по задаче: «свернуть для отчёта» → GROUP BY; «сохранить детали + добавить контекст» → window. Вариант (a) — это разные tools для разных задач. Вариант (b) — window сопоставима по speed, не «медленнее». Вариант (c) — window есть в MySQL 8+, PostgreSQL, SQL Server, Oracle, SQLite 3.25+ — везде. Запомни: <em>GROUP BY = свернуть; window = обогатить</em>."
    }
  },
  {
    "id": "SQL-D5",
    "sprintId": "S11",
    "ord": 5,
    "type": "docs",
    "priority": "P0",
    "title": "ER diagrams + indexes preview · читаем схему незнакомой системы",
    "estimateMin": 24,
    "ac": [
      {
        "id": "AC-01",
        "text": "Может назвать 3 элемента ER-диаграммы (entity · attribute · relationship)"
      },
      {
        "id": "AC-02",
        "text": "Различает 3 типа cardinality: 1:1 · 1:N · N:N — с примером для каждого"
      },
      {
        "id": "AC-03",
        "text": "Понимает crow\\'s foot notation: ровная линия = 1, «лапка вороны» = N"
      },
      {
        "id": "AC-04",
        "text": "Может за 5 минут прочитать e-commerce ER-диаграмму и identify central entities + tree structures + junction tables"
      },
      {
        "id": "AC-05",
        "text": "Знает 3 факта про indexes (PK auto-index · FK index отдельно · indexes замедляют writes)"
      },
      {
        "id": "AC-06",
        "text": "Может прочитать basic EXPLAIN output: «Index Scan» vs «Seq Scan» · cost оценка"
      },
      {
        "id": "AC-07",
        "text": "Знает 5-minute ER onboarding drill для первого дня на новом проекте"
      },
      {
        "id": "AC-08",
        "text": "Awareness anti-patterns: function в WHERE blocks index · LIKE с wildcard в начале blocks index"
      },
      {
        "id": "AC-09",
        "text": "Awareness ER notations: Chen · UML · IDEF1X (senior-ext)"
      },
      {
        "id": "AC-10",
        "text": "Awareness composite / partial / functional indexes (senior-ext · forward к S17)"
      }
    ],
    "istqb": [],
    "skills": [
      "SQL",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-SQL-D5",
      "prompt": "Quick check",
      "question": "Junior пришёл на новый проект, открыл ER-диаграмму. Видит две таблицы — <code>users</code> и <code>orders</code> — между ними линия с пометкой <strong>1 .. *</strong> (один-ко-многим, со стороны users). Что это значит?",
      "options": [
        {
          "id": "a",
          "text": "Один user может иметь много orders; orders содержит FK <code>user_id</code>, который ссылается на <code>users.id</code> — каждый order привязан ровно к одному user"
        },
        {
          "id": "b",
          "text": "Это many-to-many, нужна junction-таблица"
        },
        {
          "id": "c",
          "text": "Это inheritance — orders наследует поля от users"
        },
        {
          "id": "d",
          "text": "Один order может принадлежать многим users одновременно"
        }
      ],
      "answer": "a",
      "explanation": "<strong>Правильно: 1 user → много orders через FK.</strong> Нотация «1..*» (one-to-many) — самая частая связь в production БД: один user имеет несколько заказов, каждый заказ принадлежит одному user. Технически — FK <code>user_id</code> в таблице orders ссылается на <code>users.id</code>. Junior читает ER-диаграмму, чтобы за 5 минут понять scope системы и спланировать JOIN'ы. Вариант (d) — обратное направление, путаница «многие к одному». Вариант (b) — many-to-many (* .. *) рисуется с junction-таблицей посередине, например <code>user_roles</code> между users и roles. Вариант (c) — inheritance в реляционных БД редкость, обычно отдельная конструкция (Table-Per-Type). Запомни: <em>1..* = FK в «многих» ссылается на PK в «одном»</em>."
    }
  },
  {
    "id": "SQL-D6",
    "sprintId": "S11",
    "ord": 6,
    "type": "docs",
    "priority": "P0",
    "title": "MongoDB foundations + cross-tool decision matrix",
    "estimateMin": 26,
    "ac": [
      {
        "id": "AC-01",
        "text": "Может объяснить разницу document model (MongoDB) vs relational tables (SQL) — гибкая schema vs strict · embedded vs JOIN"
      },
      {
        "id": "AC-02",
        "text": "Установил MongoDB Atlas free tier ИЛИ local Mongo через Docker · подключился через mongosh"
      },
      {
        "id": "AC-03",
        "text": "Может написать 6 базовых operations: find · find с projection · find с $gt/$lt · updateOne · deleteOne · countDocuments"
      },
      {
        "id": "AC-04",
        "text": "Awareness aggregation pipeline · знает базовые stages ($match · $group · $sort · $limit) и их SQL-эквиваленты (WHERE / GROUP BY / ORDER BY / LIMIT) · понимает, что $lookup — это JOIN-like операция уровня senior, которой в Mongo обычно избегают"
      },
      {
        "id": "AC-05",
        "text": "Применяет NoSQL vs SQL decision matrix (transactional → SQL · гибкая schema → Mongo · cache → Redis)"
      },
      {
        "id": "AC-06",
        "text": "Знает rule: orders/payments → SQL · catalogs/CMS → Mongo · sessions/cache → Redis (typical polyglot pattern)"
      },
      {
        "id": "AC-07",
        "text": "Знает quirk: _id NOT id · ObjectId wrapper для standard IDs"
      },
      {
        "id": "AC-08",
        "text": "Знает rule: connection strings НИКОГДА в code · ENV variables + .env + .gitignore + CI secrets"
      },
      {
        "id": "AC-09",
        "text": "Awareness Mongoose schemas в Node.js context (senior-ext)"
      },
      {
        "id": "AC-10",
        "text": "Awareness Mongo indexes (senior-ext)"
      }
    ],
    "istqb": [],
    "skills": [
      "SQL",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-SQL-D6",
      "prompt": "Quick check",
      "question": "На собес junior спрашивают «как ты бы посмотрела все заказы клиента id=42 в MongoDB». Какой ответ корректен?",
      "options": [
        {
          "id": "a",
          "text": "<code>SELECT * FROM orders WHERE user_id = 42</code> — Mongo поддерживает SQL"
        },
        {
          "id": "b",
          "text": "В Mongo нельзя искать по полю, только по <code>_id</code>"
        },
        {
          "id": "c",
          "text": "<code>db.orders.find({ user_id: 42 })</code> — Mongo использует JSON-подобные query-объекты вместо SQL"
        },
        {
          "id": "d",
          "text": "Нужно сначала экспортировать в SQL, потом запросить"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: <code>db.orders.find({ user_id: 42 })</code>.</strong> Mongo это document database: данные хранятся как JSON-документы, query тоже выражается JSON-объектом «найди все документы где user_id равен 42». Junior с awareness Mongo читает такую команду без шока. Вариант (a) — Mongo не SQL-native (хотя есть SQL-плагины типа MongoSQL, в production junior встретит native syntax). Вариант (b) — Mongo индексирует любые поля, не только _id. Вариант (d) — экспорт ради простого find = потеря времени и source of truth. Запомни: <em>Mongo find = JSON-фильтр; SQL WHERE = условия словами — два разных синтаксиса для одной идеи «найди где»</em>."
    }
  },
  {
    "id": "SQL-D7",
    "sprintId": "S11",
    "ord": 7,
    "type": "docs",
    "priority": "P0",
    "title": "Faker · test data preparation deep",
    "estimateMin": 22,
    "ac": [
      {
        "id": "AC-01",
        "text": "Установлен Python Faker (`pip install faker`) ИЛИ faker.js (`npm install @faker-js/faker`) — оба желательно"
      },
      {
        "id": "AC-02",
        "text": "Может назвать 6 главных типов данных (identity · location · datetime · business · text · structured) с примерами для каждого"
      },
      {
        "id": "AC-03",
        "text": "Различает 3 подхода к test data (seed script · fixture · runtime generation) и когда что выбирают"
      },
      {
        "id": "AC-04",
        "text": "Применил DML safety pattern из S08 T08 в seed script (BEGIN → loop → verify → COMMIT/ROLLBACK)"
      },
      {
        "id": "AC-05",
        "text": "Знает rule: ВСЕГДА fail-fast assert на ENVIRONMENT before seed script (защита от accidentally hitting production)"
      },
      {
        "id": "AC-06",
        "text": "Знает rule: для unique constraints — Faker + timestamp prefix (collisions на 1000+ records без timestamp)"
      },
      {
        "id": "AC-07",
        "text": "Применяет multi-locale Faker для unicode coverage (минимум ru_RU + en_US + zh_CN + ja_JP)"
      },
      {
        "id": "AC-08",
        "text": "Awareness Custom providers для domain-specific data (senior-ext)"
      },
      {
        "id": "AC-09",
        "text": "Awareness Mockaroo как web GUI alternative (senior-ext)"
      },
      {
        "id": "AC-10",
        "text": "Различает synthetic generation (Faker) vs data masking (отдельная category tools)"
      }
    ],
    "istqb": [],
    "skills": [
      "SQL",
      "Test Design",
      "AI Workflow"
    ],
    "quickCheck": {
      "id": "QC-SQL-D7",
      "prompt": "Quick check",
      "question": "Нужно создать 500 тестовых пользователей для нагрузочного теста. Какой подход правильный?",
      "options": [
        {
          "id": "a",
          "text": "Вручную набрать User1, User2, ... User500 — управляемо"
        },
        {
          "id": "b",
          "text": "Faker: <code>fake = Faker('ru_RU'); for _ in range(500): print(fake.name(), fake.email())</code> — реалистичные имена/email/адреса со всеми крайними случаями (unicode, длинные имена, спецсимволы, null-эквиваленты)"
        },
        {
          "id": "c",
          "text": "Не создавать вообще — использовать одного тестового пользователя для всех 500 запросов"
        },
        {
          "id": "d",
          "text": "Скопировать prod-данные в test БД — самые реалистичные значения"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: Faker.</strong> Faker закрывает главный gap test data: реалистичность + объём + покрытие крайних случаев. «User1..User500» — все короткие, все ASCII, ноль unicode-багов, ноль апострофов, ноль длинных имён, не покрывают граничные. Faker делает «Анна Иванова», «O'Brien», «王明», «Heinrich Müller-Schmidt-Hofstetter» — те самые edge cases, которые в prod возникают в первую неделю. Вариант (a) — теряет coverage. Вариант (d) — копировать prod в test = нарушение GDPR/privacy, никогда. Вариант (c) — один пользователь не симулирует concurrent traffic и не ловит race-conditions. Запомни: <em>1 строка Faker = 30 минут ручной работы + покрытие unicode/длины/спецсимволов из коробки</em>."
    }
  },
  {
    "id": "SQL-D8",
    "sprintId": "S11",
    "ord": 8,
    "type": "ai",
    "priority": "P0",
    "title": "AI-эпизод · 2 секции · writing + analysis",
    "estimateMin": 24,
    "ac": [
      {
        "id": "AC-01",
        "text": "Понимает разницу Section A (writing mode) vs Section B (analysis mode) — разные prompt structures, разные failure patterns"
      },
      {
        "id": "AC-02",
        "text": "Может составить prompt по 3 patterns Section A: SQL deep generation · Mongo aggregation · test data schema"
      },
      {
        "id": "AC-03",
        "text": "Может составить prompt по 3 patterns Section B: query explanation · EXPLAIN reading · cross-database refactor"
      },
      {
        "id": "AC-04",
        "text": "Знает rule: ВСЕГДА передавать schema в prompt (prevents 90% hallucinations)"
      },
      {
        "id": "AC-05",
        "text": "Применяет review checklist Section A (table/column names · крайние случаи · return shape)"
      },
      {
        "id": "AC-06",
        "text": "Применяет review checklist Section B (suggestions релевантны workload · cross-validate с ANALYZE · numbers verify)"
      },
      {
        "id": "AC-07",
        "text": "Знает границы AI: standard SQL/Mongo good · domain rules / business logic — не знает"
      },
      {
        "id": "AC-08",
        "text": "Знает rule: confidential data НЕ в public AI · enterprise tier OR sanitize"
      },
      {
        "id": "AC-09",
        "text": "Awareness ISTQB CT-AI Extension (senior-ext · forward к S17)"
      },
      {
        "id": "AC-10",
        "text": "Awareness in-tool AI (Postbot · DBeaver AI · DataGrip AI) для daily work без external chat (senior-ext)"
      }
    ],
    "istqb": [],
    "skills": [
      "SQL",
      "AI Workflow"
    ],
    "quickCheck": {
      "id": "QC-SQL-D8",
      "prompt": "Quick check",
      "question": "Junior просит AI: «объясни этот EXPLAIN output». AI выдал 3 параграфа про Seq Scan и suggestion «добавь индекс на колонку user_id». Следующий шаг?",
      "options": [
        {
          "id": "a",
          "text": "Сразу применить <code>CREATE INDEX</code> на prod — AI знает лучше"
        },
        {
          "id": "b",
          "text": "Проигнорировать — AI часто ошибается"
        },
        {
          "id": "c",
          "text": "Скопировать объяснение AI в bug report без проверки"
        },
        {
          "id": "d",
          "text": "Создать индекс на staging, прогнать <code>EXPLAIN ANALYZE</code> до и после, измерить реальный gain (мс), потом обсудить с Dev перед prod"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: staging → EXPLAIN ANALYZE до/после → обсудить.</strong> AI suggestions по performance часто generic: «добавь индекс» работает для одного workload и портит другой (индекс ускоряет SELECT, замедляет INSERT/UPDATE). Validation через <code>EXPLAIN ANALYZE</code> показывает реальное время выполнения с real data — это единственный ground truth. Вариант (a) — изменение prod схемы без замера = potential incident (lock table, place takeover, замедление writes). Вариант (b) — игнорировать AI = терять force multiplier. Вариант (c) — AI текст без validation = передача галлюцинаций в bug report = потеря credibility. Запомни: <em>AI говорит «попробуй X» → ты делаешь A/B замер на staging → решение принимаешь по числам, не по обещанию AI</em>."
    }
  },
  {
    "id": "SQL-D9",
    "sprintId": "S11",
    "ord": 9,
    "type": "docs",
    "priority": "P0",
    "title": "Redis basics · GET/SET/TTL · 4 use case patterns",
    "estimateMin": 24,
    "ac": [
      {
        "id": "AC-01",
        "text": "Может объяснить in-memory architecture Redis (RAM primary · disk persistence optional · &lt;1ms latency)"
      },
      {
        "id": "AC-02",
        "text": "Знает 5 data types (String · List · Hash · Set · Sorted Set) и use cases для каждого"
      },
      {
        "id": "AC-03",
        "text": "Может назвать 4 главных use case patterns (cache · sessions · rate limiting · queues) с пример commands"
      },
      {
        "id": "AC-04",
        "text": "Освоил 15+ базовых команд (SET / GET / DEL / EXISTS / INCR / TTL / HSET / HGETALL / LPUSH / RPUSH / LPOP / SADD / ZADD / etc.)"
      },
      {
        "id": "AC-05",
        "text": "Может пройти 5-step debug pattern «cache invalidation bug» (psql verify · redis HGETALL · TTL check · root cause hypothesis · workaround)"
      },
      {
        "id": "AC-06",
        "text": "Различает Redis vs Memcached (Redis modern default · Memcached legacy simple caching)"
      },
      {
        "id": "AC-07",
        "text": "Знает 4 production rules: (1) FLUSHDB только dev · (2) KEYS only dev (use SCAN в prod) · (3) Critical data НЕ в Redis · (4) TTL не absolute timing guarantee"
      },
      {
        "id": "AC-08",
        "text": "Применяет key naming conventions (entity:id:field с двоеточиями)"
      },
      {
        "id": "AC-09",
        "text": "Awareness: single-threaded · long ops блокируют сервер"
      },
      {
        "id": "AC-10",
        "text": "Awareness Pub/Sub · Streams · Cluster mode (senior-ext)"
      }
    ],
    "istqb": [],
    "skills": [
      "SQL",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-SQL-D9",
      "prompt": "Quick check",
      "question": "Backend dev говорит: «положили session token в Redis на 30 минут, ключ <code>session:42</code>». Junior хочет проверить — что в Redis по этому ключу. Какая команда?",
      "options": [
        {
          "id": "a",
          "text": "<code>GET session:42</code> — Redis это key-value store, команда GET по ключу возвращает значение или <code>(nil)</code> если ключ протух"
        },
        {
          "id": "b",
          "text": "<code>db.sessions.find({ token: 'abc' })</code> — Redis работает как Mongo"
        },
        {
          "id": "c",
          "text": "Никак нельзя посмотреть — Redis закрытый"
        },
        {
          "id": "d",
          "text": "<code>SELECT * FROM redis WHERE key = 'session:42'</code>"
        }
      ],
      "answer": "a",
      "explanation": "<strong>Правильно: <code>GET session:42</code>.</strong> Redis — key-value store, никакого SQL и никаких документов. Команды простые: <code>GET key</code> читает значение, <code>SET key value</code> пишет, <code>EXPIRE key 1800</code> ставит TTL. Если ключ просрочен (TTL вышел), <code>GET</code> вернёт <code>(nil)</code> — это легко перепутать с «такого ключа никогда не было». Junior с этой command-памятью проводит cache investigation за 30 секунд. Вариант (d) — Redis не SQL. Вариант (b) — Redis не documents. Вариант (c) — Redis легко смотрится через CLI <code>redis-cli</code> или GUI типа RedisInsight. Запомни: <em>Redis = GET/SET по ключу; <code>(nil)</code> = ключа нет ИЛИ протух</em>."
    }
  },
  {
    "id": "SQL-D10",
    "sprintId": "S11",
    "ord": 10,
    "type": "mission",
    "priority": "P0",
    "title": "Миссия · cross-database investigation в Atelier",
    "estimateMin": 60,
    "ac": [
      {
        "id": "AC-01",
        "text": "Прошёл 5-step investigation flow (UI/API · SQL · Mongo · Redis · Bug Report)"
      },
      {
        "id": "AC-02",
        "text": "Подготовил минимум 3 SQL queries (current state · transactions history · audit log) с evidence"
      },
      {
        "id": "AC-03",
        "text": "Сделал Mongo find verification (cashed value comparison с SQL)"
      },
      {
        "id": "AC-04",
        "text": "Сделал Redis HGETALL + TTL check (cache state inspection)"
      },
      {
        "id": "AC-05",
        "text": "Идентифицировал root cause hypothesis (где из 4 layers проблема)"
      },
      {
        "id": "AC-06",
        "text": "Оформил bug report с curl reproduction · evidence × 4 layers · workaround flag · code-level fix recommendation · affected users scope query"
      },
      {
        "id": "AC-07",
        "text": "Написал отчёт по миссии в джуниор-уровня формате (что сделал · что узнал · что улучшить · honest о limitations)"
      },
      {
        "id": "AC-08",
        "text": "Применил decision tree «когда workaround vs когда fix» (manual DEL = workaround · code change = fix)"
      },
      {
        "id": "AC-09",
        "text": "Avoidance 5 anti-patterns (SQL ok ≠ close · workaround ≠ fix · skip Redis · evidence missing · scope = 1)"
      },
      {
        "id": "AC-10",
        "text": "Awareness forward links: S16 (regression automation) · S12 (security concern)"
      }
    ],
    "istqb": [],
    "skills": [
      "SQL",
      "QA Concepts",
      "AI Workflow",
      "Test Design"
    ],
    "mission": {
      "cta": "Открыть Mission в Atelier",
      "atelierScenarioId": "block-2-cross-db-investigation"
    },
    "quickCheck": {
      "id": "QC-SQL-D10",
      "prompt": "Quick check",
      "question": "Клиент пишет в саппорт: «оплатил подписку, баланс на UI остался прежним». Junior проверила: в SQL <code>users.balance</code> — новый (правильный); в Mongo cache <code>users_cache.balance</code> — старый; в Redis ключ <code>user:42:balance</code> — тоже старый. Где root cause?",
      "options": [
        {
          "id": "a",
          "text": "SQL баг — там должен быть старый баланс"
        },
        {
          "id": "b",
          "text": "Cache invalidation не сработал: после UPDATE баланса в SQL backend должен был сбросить Mongo cache + удалить Redis key, чтобы при следующем чтении они перезаполнились из SQL — этого не произошло"
        },
        {
          "id": "c",
          "text": "Невозможно определить без эскалации"
        },
        {
          "id": "d",
          "text": "Frontend баг — UI читает не из той таблицы"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Правильно: cache invalidation не сработал.</strong> Это классический cross-database bug на polyglot stack: SQL = source of truth, Mongo + Redis = производные кэши для скорости. После UPDATE баланса backend должен выполнить два дополнительных действия: <code>db.users_cache.updateOne({_id:42}, {$set: {balance: NEW}})</code> и <code>DEL user:42:balance</code> в Redis. Если эти шаги пропущены — UI читает stale cache и показывает старое значение. Вариант (a) — SQL правильный, баг не в нём. Вариант (d) — UI читает «откуда сказали» (обычно через API → cache → SQL); ошибка не во frontend. Вариант (c) — три источника правды с evidence уже дают чёткий root cause. Запомни: <em>polyglot stack → каждый UPDATE source of truth требует cache invalidation в каждом производном хранилище</em>."
    }
  },
  {
    "id": "NF-01",
    "sprintId": "S12",
    "ord": 1,
    "type": "docs",
    "priority": "P0",
    "title": "Зачем junior нужны Performance + Security + Accessibility — 3 истории",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Может назвать 3 области NF (производительность · безопасность · доступность) с базовым описанием каждой"
      },
      {
        "id": "AC-02",
        "text": "Может назвать 3 реальных сценария (IDOR · медленная загрузка на мобильном · недоступный checkout) с их влиянием"
      },
      {
        "id": "AC-03",
        "text": "Различает что входит в S12 (основы + расследование + 4-5 практических приёмов) и что НЕ входит (глубокое нагрузочное · глубокий pentest · мобильная доступность · безопасность в CI · криптография)"
      },
      {
        "id": "AC-04",
        "text": "Понимает позиционирование S12 — finale Block 2 · готовит к Block 2 Capstone «Junior Manual+ QA»"
      },
      {
        "id": "AC-05",
        "text": "Знает industry standards для каждой области (Web Vitals · OWASP Top 10 · WCAG 2.1 AA)"
      },
      {
        "id": "AC-06",
        "text": "Понимает модель зрелости NF · junior → middle → senior → специализация (senior-ext)"
      },
      {
        "id": "AC-07",
        "text": "Понимает правовой ландшафт · EAA 2025 · ADA · GDPR · SOC 2 · PCI DSS (senior-ext)"
      },
      {
        "id": "AC-08",
        "text": "Заученная формулировка для собеса: «производительность/безопасность/доступность · по 1 примеру на каждую · индустриальные стандарты»"
      }
    ],
    "istqb": [
      "CTFL-Ch2",
      "CTFL-Ch4",
      "CTFL-Ch6"
    ],
    "skills": [
      "Performance & Security",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-NF-01",
      "prompt": "Quick check",
      "question": "До S12 ты тестировала «приложение делает X» (functional). Что проверяет non-functional testing — теми же сценариями, но под другим углом?",
      "options": [
        {
          "id": "a",
          "text": "То же, что functional, но дважды для надёжности"
        },
        {
          "id": "b",
          "text": "Только performance — security и a11y это отдельные disciplines, не часть QA"
        },
        {
          "id": "c",
          "text": "КАК приложение это делает: насколько быстро (performance), безопасно ли (security), доступно ли всем пользователям, включая людей с инвалидностью (accessibility)"
        },
        {
          "id": "d",
          "text": "Только визуальный layout страниц"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: КАК — perf + security + a11y.</strong> Functional отвечает «работает ли фича» (бинарно). Non-functional отвечает «какого качества работает» (по шкале): за 0.5 секунды или 10? Защищена от IDOR или нет? Может ли слепой пользователь со screen reader пройти checkout? Эти три домена — основной NF scope в S12. Вариант (a) — повторение functional не покрывает скорость/безопасность/доступность. Вариант (b) — security и a11y входят в QA-зону, не «отдельный отдел». Вариант (d) — layout это часть UX/visual QA, не отдельный NF домен. Запомни: <em>functional = что делает; NF = как делает (perf + security + a11y)</em>."
    }
  },
  {
    "id": "NF-02",
    "sprintId": "S12",
    "ord": 2,
    "type": "docs",
    "priority": "P0",
    "title": "Основы производительности · Lighthouse + Web Vitals + вкладка DevTools Performance",
    "estimateMin": 26,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знает 4 Core Web Vitals (LCP / INP / CLS / TTFB) с порогами для каждой"
      },
      {
        "id": "AC-02",
        "text": "Запустил аудит Lighthouse на реальной странице · прочитал оценку + 3 главные возможности улучшения"
      },
      {
        "id": "AC-03",
        "text": "Понимает процесс Lighthouse · 5 шагов (открыть страницу → DevTools → вкладка Lighthouse → настроить (Mobile + Performance) → Generate → прочитать отчёт)"
      },
      {
        "id": "AC-04",
        "text": "Знает 4 главных инструмента набора junior (Lighthouse · DevTools Performance · DevTools Network · DevTools Memory)"
      },
      {
        "id": "AC-05",
        "text": "Может объяснить разницу режимов Lighthouse Mobile и Desktop · почему Mobile по умолчанию ближе к реальности"
      },
      {
        "id": "AC-06",
        "text": "Понимает разницу синтетического мониторинга и RUM (senior-ext)"
      },
      {
        "id": "AC-07",
        "text": "Понимает понятие Performance budget + Lighthouse CI (senior-ext)"
      },
      {
        "id": "AC-08",
        "text": "Знаком с набором данных CrUX (senior-ext)"
      },
      {
        "id": "AC-09",
        "text": "Знает правило: FID устарел · используй INP (2024+)"
      },
      {
        "id": "AC-10",
        "text": "Знает правило: режим Mobile + ограничение Slow 3G по умолчанию для имитации реальных условий"
      }
    ],
    "istqb": [
      "CTFL-Ch2",
      "CTFL-Ch5",
      "CTFL-Ch6"
    ],
    "skills": [
      "Performance & Security",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-NF-02",
      "prompt": "Quick check",
      "question": "Lighthouse audit выдал LCP = 4.2 секунды (норма ≤ 2.5). Что это значит на языке пользователя?",
      "options": [
        {
          "id": "a",
          "text": "Сервер очень медленный — backend проблема"
        },
        {
          "id": "b",
          "text": "Браузер несовместим с твоей вёрсткой"
        },
        {
          "id": "c",
          "text": "Largest Contentful Paint = время до отрисовки самого большого видимого элемента (обычно hero-image или заголовок). 4.2 сек = пользователь видит белый экран или скелетон ~4 секунды до появления главного контента — bounce-rate растёт"
        },
        {
          "id": "d",
          "text": "JavaScript содержит infinite loop, страница висит"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Правильно: время до самого большого видимого элемента.</strong> LCP — одна из 3 Core Web Vitals (LCP / INP / CLS), которые Google использует как SEO-фактор. Норма ≤ 2.5 сек = «хорошо», 2.5-4.0 = «нужна доработка», &gt; 4.0 = «плохо». Причины: тяжёлая hero-image без оптимизации, render-blocking JS/CSS, медленный TTFB, слишком много DOM-узлов. Вариант (a) — может быть, но только одна из ~5 возможных причин. Вариант (b) — несовместимость это другая метрика (Crash Rate). Вариант (d) — infinite loop ловит INP (interaction lag), не LCP. Запомни: <em>LCP = «когда пользователь видит главное» — целевое значение 2.5 сек или меньше</em>."
    }
  },
  {
    "id": "NF-03",
    "sprintId": "S12",
    "ord": 3,
    "type": "docs",
    "priority": "P0",
    "title": "Расследование производительности · waterfall + память + сеть · приём отладки",
    "estimateMin": 26,
    "ac": [
      {
        "id": "AC-01",
        "text": "Прошёл процесс расследования производительности из 5 шагов (наблюдение · Network · Performance · Memory · баг-репорт)"
      },
      {
        "id": "AC-02",
        "text": "Может ловить 4 паттерна в Network waterfall (тяжёлый ответ · медленный запрос · блокировка отрисовки · последовательно vs параллельно)"
      },
      {
        "id": "AC-03",
        "text": "Знает 3 вещи, которые читать в записи Performance (долгие задачи · элемент LCP · сдвиги вёрстки)"
      },
      {
        "id": "AC-04",
        "text": "Знает признак утечки памяти «удержанная память растёт» · передача разработчику"
      },
      {
        "id": "AC-05",
        "text": "Прошёл разобранный пример «мобильное тормозит» · от наблюдения до баг-репорта"
      },
      {
        "id": "AC-06",
        "text": "Может прочитать разбивку Timing одного запроса (Queueing · Stalled · DNS · Initial Connection · TLS · Waiting · Content Download)"
      },
      {
        "id": "AC-07",
        "text": "Может оформить баг-репорт по производительности с возможностями из Lighthouse · доказательством из waterfall · гипотезой о первопричине · охватом затронутых пользователей"
      },
      {
        "id": "AC-08",
        "text": "Знает правило: сначала исследуй метрики фронтенда · бэкенд (TTFB) во вторую очередь · 90% багов производительности — на фронтенде"
      },
      {
        "id": "AC-09",
        "text": "Знает правило: запись Performance — короткие сфокусированные сессии · не «записывать всё подряд»"
      },
      {
        "id": "AC-10",
        "text": "Знаком со вкладкой Coverage · WebPageTest · Lighthouse CI (senior-ext)"
      }
    ],
    "istqb": [
      "CTFL-Ch2",
      "CTFL-Ch5",
      "CTFL-Ch6"
    ],
    "skills": [
      "Performance & Security",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-NF-03",
      "prompt": "Quick check",
      "question": "Support тикет: «страница профиля грузится 8 секунд». Где junior с perf-расследование рефлексом начнёт?",
      "options": [
        {
          "id": "a",
          "text": "Сразу проверить database queries — наверняка медленный SQL"
        },
        {
          "id": "b",
          "text": "Спросить у Dev'а, что он там написал"
        },
        {
          "id": "c",
          "text": "Очистить cache браузера и закрыть тикет «not-reproducible»"
        },
        {
          "id": "d",
          "text": "DevTools → Network tab → отсортировать по Duration → посмотреть waterfall → найти самые медленные requests и render-blocking resources → дальше копать по самому жирному кандидату"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: DevTools Network → waterfall.</strong> Универсальный perf-investigation flow: начни с того, что видит пользователь (browser-side), потом спускайся глубже. Network waterfall показывает за 30 секунд: какой request медленнее всех, есть ли render-blocking JS/CSS, есть ли последовательные requests, которые могли бы быть параллельными. После того, как найден кандидат — копаем дальше (Performance tab если render, Source если backend). Вариант (a) — преждевременное погружение в БД (если фронт грузит 5 МБ изображений, SQL ни при чём). Вариант (b) — преждевременная эскалация без evidence. Вариант (c) — закрытие без расследования = баг в prod. Запомни: <em>perf-расследование = всегда сверху вниз: Network → Performance → DevTools deeper → backend logs</em>."
    }
  },
  {
    "id": "NF-04",
    "sprintId": "S12",
    "ord": 4,
    "type": "docs",
    "priority": "P0",
    "title": "Основы безопасности · OWASP Top 10 + знакомство с 4-5 практическими приёмами",
    "estimateMin": 26,
    "ac": [
      {
        "id": "AC-01",
        "text": "Может назвать 10 категорий OWASP Top 10 (2021) с базовым описанием каждой"
      },
      {
        "id": "AC-02",
        "text": "Различает AuthN (authentication · «кто ты») vs AuthZ (authorization · «что можешь»)"
      },
      {
        "id": "AC-03",
        "text": "Применил минимум 3 практических приёма тестирования (XSS · знакомство с IDOR · CSRF · поток авторизации · контракт API)"
      },
      {
        "id": "AC-04",
        "text": "Знает XSS payload basics (<code>&lt;script&gt;alert(1)&lt;/script&gt;</code> · <code>&lt;img src=x onerror=alert(1)&gt;</code>)"
      },
      {
        "id": "AC-05",
        "text": "Различает уязвимость · эксплойт · раскрытие"
      },
      {
        "id": "AC-06",
        "text": "Знает правило: НИКОГДА не тестируй безопасность на проде без разрешения · правовой риск"
      },
      {
        "id": "AC-07",
        "text": "Знает правило: OWASP Top 10 обновляется каждые 3-4 года · проверяй текущую версию"
      },
      {
        "id": "AC-08",
        "text": "Знаком с OWASP API Security Top 10 (2023) · OWASP ASVS (senior-ext)"
      },
      {
        "id": "AC-09",
        "text": "Знаком с экосистемой Burp Suite · junior не применяет (senior-ext)"
      },
      {
        "id": "AC-10",
        "text": "Может оформить баг-репорт по безопасности с категорией OWASP + приёмом теста + рекомендованным исправлением"
      }
    ],
    "istqb": [
      "CTFL-Ch2",
      "CTFL-Ch5",
      "CTFL-Ch6"
    ],
    "skills": [
      "Performance & Security",
      "QA Concepts",
      "HTTP & API"
    ],
    "quickCheck": {
      "id": "QC-NF-04",
      "prompt": "Quick check",
      "question": "На собес middle спрашивают «какие security категории знаешь и какие чаще всего встречаются у junior». Какой ответ зрелее?",
      "options": [
        {
          "id": "a",
          "text": "«Все, что есть» — без перечня"
        },
        {
          "id": "b",
          "text": "«Только пароли и SQL injection — этого хватает»"
        },
        {
          "id": "c",
          "text": "«Security это не моя работа, этим занимается DevSecOps»"
        },
        {
          "id": "d",
          "text": "«OWASP Top 10 — индустриальный baseline, 10 категорий, обновляется каждые 3-4 года, последнее обновление 2021. На junior уровне чаще всего ловлю A01 Broken Access Control (IDOR), A03 Injection, A07 Identification & Authentication Failures»"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: OWASP Top 10 + 2-3 конкретных категории.</strong> Recruiter и Tech Lead слышат engineer-регистр: ты знаешь индустриальный стандарт, знаешь его актуальную версию, и можешь назвать конкретные категории, которые встречала. Это сигнал, что security в твоей рабочей картине, а не «модное слово». Вариант (a) — расплывчатый ответ = unknown depth. Вариант (b) — «только пароли и SQLi» = устаревшая картина 2010 года (в 2021 Broken Access Control — категория #1, не Injection). Вариант (c) — junior, который дистанцируется от security, теряет балл; security базовые проверки входят в манипул QA. Запомни: <em>OWASP Top 10 — обязательный mental map для собеса · 2-3 категории «из практики» = доказательство, что не теория</em>."
    }
  },
  {
    "id": "NF-05",
    "sprintId": "S12",
    "ord": 5,
    "type": "docs",
    "priority": "P0",
    "title": "Security Deep · IDOR · сломанный контроль доступа · нарушения контракта API",
    "estimateMin": 28,
    "ac": [
      {
        "id": "AC-01",
        "text": "Может объяснить приём IDOR · 4 варианта (параметр URL · тело POST · API · GraphQL/вложенные)"
      },
      {
        "id": "AC-02",
        "text": "Применил минимум 2 варианта IDOR на тестовом приложении (параметр URL + тело POST)"
      },
      {
        "id": "AC-03",
        "text": "Построил матрицу прав для простого приложения (3+ роли × 5+ эндпоинтов) · протестировал каждую ячейку"
      },
      {
        "id": "AC-04",
        "text": "Различает горизонтальное и вертикальное повышение привилегий"
      },
      {
        "id": "AC-05",
        "text": "Понимает паттерн Mass Assignment · может тестировать через подстановку произвольных полей"
      },
      {
        "id": "AC-06",
        "text": "Знаком с манипуляцией JWT · атакой `algorithm: \"none\"` · слабым секретом HS256"
      },
      {
        "id": "AC-07",
        "text": "Прошёл разобранный пример «доступ к админ-панели» · от наблюдения до баг-репорта"
      },
      {
        "id": "AC-08",
        "text": "Знает правило: backend ОБЯЗАН проверять весь доступ (access control) · frontend hiding = UX, не security"
      },
      {
        "id": "AC-09",
        "text": "Знает правило: НИКОГДА не развивай эксплуатацию дальше · только зафиксируй и доложи"
      },
      {
        "id": "AC-10",
        "text": "Знаком с состоянием гонки TOCTOU · связь с инвалидацией кэша из S11 как с вопросом безопасности"
      },
      {
        "id": "AC-11",
        "text": "Знаком с OWASP Cheat Sheets · справочник для баг-репортов (senior-ext)"
      },
      {
        "id": "AC-12",
        "text": "Может оформить полный баг-репорт по безопасности (категория OWASP + 5 шагов воспроизведения + первопричина + рекомендации по исправлению + запрос охвата затронутых + временное решение)"
      }
    ],
    "istqb": [
      "CTFL-Ch2",
      "CTFL-Ch4",
      "CTFL-Ch5"
    ],
    "skills": [
      "Performance & Security",
      "HTTP & API",
      "API Contract Testing"
    ],
    "quickCheck": {
      "id": "QC-NF-05",
      "prompt": "Quick check",
      "question": "User A авторизован, заходит в свой заказ <code>/orders/123</code> — всё ок. Меняет URL на <code>/orders/124</code> — видит чужой заказ User B (адрес доставки, total, items). Backend вернул 200. Что это за уязвимость?",
      "options": [
        {
          "id": "a",
          "text": "Это нормально, все заказы публичные"
        },
        {
          "id": "b",
          "text": "XSS (Cross-Site Scripting)"
        },
        {
          "id": "c",
          "text": "SQL Injection"
        },
        {
          "id": "d",
          "text": "IDOR (Insecure Direct Object Reference) / Broken Access Control: backend проверил, что пользователь авторизован, но НЕ проверил, что order 124 принадлежит именно ему — типовой OWASP A01 баг"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: IDOR / Broken Access Control.</strong> IDOR — самая частая security-уязвимость в web (OWASP A01 с 2021). Корень: backend проверяет authentication (\"кто ты\"), но забывает authorization (\"имеешь ли ты право на ЭТОТ ресурс\"). Junior ловит за минуту: открой URL с ID не своего ресурса (заказ, документ, профиль) — должен быть 403 Forbidden или 404, не 200 с данными. Вариант (a) — заказы приватные, личные данные. Вариант (b) — XSS это injection JavaScript через input, не доступ к чужому ресурсу. Вариант (c) — SQL Injection это инъекция SQL через input. Запомни: <em>видишь данные другого user через подмену ID в URL → IDOR</em>."
    }
  },
  {
    "id": "NF-06",
    "sprintId": "S12",
    "ord": 6,
    "type": "docs",
    "priority": "P0",
    "title": "Основы доступности (a11y) · WCAG 2.1 AA + 4 практических инструмента",
    "estimateMin": 26,
    "ac": [
      {
        "id": "AC-01",
        "text": "Может объяснить структуру WCAG 2.1 · принципы POUR (Perceivable · Operable · Understandable · Robust) · 3 уровня (A / AA / AAA)"
      },
      {
        "id": "AC-02",
        "text": "Знает, что AA — целевой уровень для коммерции · AAA — госсектор / здравоохранение"
      },
      {
        "id": "AC-03",
        "text": "Установил axe DevTools (расширение Chrome) · просканировал одну страницу"
      },
      {
        "id": "AC-04",
        "text": "Применил тест навигации с клавиатуры · Tab/Shift+Tab/Enter/Esc · нашёл минимум 1 проблему"
      },
      {
        "id": "AC-05",
        "text": "Установил screen reader (NVDA на Windows ИЛИ VoiceOver на Mac) · прошёл 1 страницу · слышит alt-текст + имена кнопок + label полей формы"
      },
      {
        "id": "AC-06",
        "text": "Может использовать секцию Accessibility в Chrome DevTools для проверки контраста цвета"
      },
      {
        "id": "AC-07",
        "text": "Знает 10 самых частых нарушений WCAG (alt у картинок · контраст · label · фокус · заголовки · имена кнопок · контекст ссылки · ловушка клавиатуры · live region · смысл только цветом)"
      },
      {
        "id": "AC-08",
        "text": "Прошёл разобранный пример · 15-минутный аудит доступности · 10-15 находок · баг-репорт"
      },
      {
        "id": "AC-09",
        "text": "Знаком с EAA 2025 · ADA · Section 508 · региональным соответствием (senior-ext)"
      },
      {
        "id": "AC-10",
        "text": "Знаком с 5 правилами ARIA · первое правило «не используй ARIA, если есть нативный HTML» (senior-ext)"
      },
      {
        "id": "AC-11",
        "text": "Знает правило: axe ловит только ~30-40% · ручная проверка обязательна"
      },
      {
        "id": "AC-12",
        "text": "Знает правило: аудит доступности рано в жизненном цикле · не под конец · разница в стоимости 20x"
      }
    ],
    "istqb": [
      "CTFL-Ch2",
      "CTFL-Ch4",
      "CTFL-Ch6"
    ],
    "skills": [
      "Performance & Security",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-NF-06",
      "prompt": "Quick check",
      "question": "Junior запустил axe-core на странице — выдало 7 violations. Какая категория чаще всего на первом месте у нетехнических сайтов?",
      "options": [
        {
          "id": "a",
          "text": "Сайт не работает в Internet Explorer 6"
        },
        {
          "id": "b",
          "text": "Шрифт не Times New Roman"
        },
        {
          "id": "c",
          "text": "Картинки слишком большие (загружаются долго)"
        },
        {
          "id": "d",
          "text": "Color contrast — серый текст #999 на белом фоне даёт ratio &lt; 4.5:1 и не проходит WCAG AA для normal text. Слабовидящие пользователи не могут прочитать"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: color contrast.</strong> Color contrast — самый частый WCAG violation на «обычных» (не специально доступных) сайтах. WCAG AA требует contrast ratio ≥ 4.5:1 для normal text и ≥ 3:1 для large text (18pt+). Дизайнеры часто берут «модный светло-серый» #999 или #aaa без проверки — выглядит мягко, но 30% пользователей физически не могут прочитать. axe-core ловит это автоматически. Вариант (a) — IE6 EOL в 2014, никто не тестит. Вариант (b) — шрифт не входит в WCAG (это design preference, не accessibility). Вариант (c) — это performance проблема (NF-02), не a11y. Запомни: <em>color contrast = top-1 a11y violation; проверяй каждый дизайн на contrast ratio через axe-core или DevTools Lighthouse</em>."
    }
  },
  {
    "id": "NF-07",
    "sprintId": "S12",
    "ord": 7,
    "type": "docs",
    "priority": "P1",
    "title": "Master Test Strategy · приоритизация по рискам · сквозное планирование NF",
    "estimateMin": 22,
    "ac": [
      {
        "id": "AC-01",
        "text": "Понимает, что Master Test Strategy = уровень программы/продукта · долгосрочная · пишет Test Manager / Tech Lead · junior вносит вклад"
      },
      {
        "id": "AC-02",
        "text": "Может объяснить матрицу RBT 2x2 (вероятность × влияние · 4 квадранта · ориентир для вложений)"
      },
      {
        "id": "AC-03",
        "text": "Знает 5 профилей приоритетов NF по типу продукта (e-commerce · fintech · госсектор · внутренний инструмент · контент/медиа)"
      },
      {
        "id": "AC-04",
        "text": "Знает 8 разделов типичного документа Master Test Strategy"
      },
      {
        "id": "AC-05",
        "text": "Может вносить структурированный вклад · 5 приёмов уровня junior"
      },
      {
        "id": "AC-06",
        "text": "Применяет привычку «приноси данные, а не мнения»"
      },
      {
        "id": "AC-07",
        "text": "Различает Test Strategy и Test Plan (уровень программы vs уровень фичи)"
      },
      {
        "id": "AC-08",
        "text": "Знаком с шаблоном Master Test Plan по IEEE 829 (senior-ext)"
      },
      {
        "id": "AC-09",
        "text": "Знаком с инструментами управления тестами TestRail / Xray / qTest (senior-ext)"
      },
      {
        "id": "AC-10",
        "text": "Может на собесе уровня middle предложить «структурный подход к Master Test Strategy для продукта X»"
      }
    ],
    "istqb": [
      "CTFL-Ch5"
    ],
    "skills": [
      "Performance & Security",
      "QA Concepts",
      "Test Plan"
    ],
    "quickCheck": {
      "id": "QC-NF-07",
      "prompt": "Quick check",
      "question": "На собес middle спрашивают «как ты бы решила, на что у нас сильнее фокусировать NF testing — security или performance — на fintech продукте»? Какой ответ зрелее?",
      "options": [
        {
          "id": "a",
          "text": "«Не моя работа — Test Manager решает»"
        },
        {
          "id": "b",
          "text": "«Тестим всё по очереди, time не лимит»"
        },
        {
          "id": "c",
          "text": "«Performance — пользователь сразу заметит, security всё равно никто не ломает»"
        },
        {
          "id": "d",
          "text": "«Зависит от business risk: fintech = деньги + регуляторы → security priority выше performance, потому что breach стоит дороже чем медленная страница. Конкретно — я бы предложила X часов на security audits, Y на perf, обновлять приоритеты по incident-логу каждый квартал. Полный Master Test Strategy пишет Test Manager — я contributing structured input»"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: risk-based + честное признание границ роли.</strong> Recruiter слышит middle-credibility: ты понимаешь, что NF приоритеты определяются business risk (тип продукта, регуляторы, audit history), можешь предложить конкретное распределение, и при этом честно признаёшь — full Master Test Strategy junior не authors, contributing structured input. Это правильная позиция «знаю framework, понимаю свою зону вклада». Вариант (a) — отстранение = junior без зрелости. Вариант (b) — игнорирование trade-off = unawareness. Вариант (c) — недооценка security в fintech = факапит на первом security audit. Запомни: <em>NF priorities = функция от business risk; junior contributing, не authoring full strategy</em>."
    }
  },
  {
    "id": "NF-08",
    "sprintId": "S12",
    "ord": 8,
    "type": "ai",
    "priority": "P0",
    "title": "AI-эпизод · 2 секции · Section A security + Section B performance",
    "estimateMin": 24,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различает Section A (написание · генерация для безопасности) и Section B (анализ · чтение производительности) · разные промпты · разные паттерны сбоев"
      },
      {
        "id": "AC-02",
        "text": "Может составить промпт по 3 приёмам Section A (XSS-нагрузки · каркас матрицы прав · нарушения контракта API)"
      },
      {
        "id": "AC-03",
        "text": "Может составить промпт по 3 приёмам Section B (разбор Lighthouse · анализ waterfall · исправления оптимизации)"
      },
      {
        "id": "AC-04",
        "text": "Знает 8 контекстов границ AI (хорошо vs галлюцинирует · общее OWASP / Web Vitals / WCAG vs кастомные бизнес-правила / технологический стек / интерпретация данных)"
      },
      {
        "id": "AC-05",
        "text": "Применяет чек-лист проверки по обеим секциям"
      },
      {
        "id": "AC-06",
        "text": "Знает правило: НИКОГДА не применяй боевые эксплойт-нагрузки на неавторизованных целях · только разрешённое тестирование"
      },
      {
        "id": "AC-07",
        "text": "Знает правило: НИКОГДА не вставляй боевые учётные данные / персональные данные в промпты AI · обезличивай или используй корпоративный тариф"
      },
      {
        "id": "AC-08",
        "text": "Знаком с расширением ISTQB CT-AI + обзором AI-инструментов для NF (senior-ext)"
      }
    ],
    "istqb": [
      "CTFL-Ch1",
      "CTFL-Ch6"
    ],
    "skills": [
      "AI Процесс",
      "Performance & Security"
    ],
    "quickCheck": {
      "id": "QC-NF-08",
      "prompt": "Quick check",
      "question": "Junior просит AI: «дай OWASP payloads для проверки XSS на input email». AI выдал 12 payloads. Что junior сделает?",
      "options": [
        {
          "id": "a",
          "text": "Сразу прогонит все 12 на prod — раз AI выдал, значит безопасно"
        },
        {
          "id": "b",
          "text": "Спрячет от team — это «hacking»"
        },
        {
          "id": "c",
          "text": "Удалит prompt из истории чата, AI не должен помнить запрос"
        },
        {
          "id": "d",
          "text": "Прогонит все 12 на staging, посмотрит response в DevTools (был ли payload отрендерен как HTML или escaped как text), задокументирует результат каждого, обсудит findings с senior security перед открытием bug report"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: staging → проверь рендер → задокументируй → senior review.</strong> Security testing с AI = writing mode (AI генерит payloads) + analysis mode (ты смотришь как backend отреагировал). Critical правила: <strong>(1)</strong> никогда не прогоняй security payloads на prod без согласия — это nearly indistinguishable от реальной атаки в логах SOC; <strong>(2)</strong> результат каждого payload документируешь (escaped / rendered / blocked / 500); <strong>(3)</strong> senior review перед bug report потому что false positives = embarrassment. Вариант (a) — атака на prod = potential incident + юридический вопрос. Вариант (b) — security testing это часть QA, не hacking. Вариант (c) — AI history не делает работу безопаснее, маскировка не контроль. Запомни: <em>security payloads → staging only → проверь рендер → документ → senior review → bug report</em>."
    }
  },
  {
    "id": "NF-09",
    "sprintId": "S12",
    "ord": 9,
    "type": "docs",
    "priority": "P1",
    "title": "Обзор инструментов QA · 5-6 категорий · каркас принятия решений",
    "estimateMin": 20,
    "ac": [
      {
        "id": "AC-01",
        "text": "Может назвать 6 главных категорий инструментов QA (управление тестами · трекинг багов · тестирование API · инструменты БД · NF-тестирование · автоматизация) · 2-3 примера на категорию"
      },
      {
        "id": "AC-02",
        "text": "Различает управление тестами (TestRail / Xray) и трекинг багов (Linear / Jira)"
      },
      {
        "id": "AC-03",
        "text": "Может перечислить инструменты, уже освоенные в спринтах Block 2 (приём закрепления)"
      },
      {
        "id": "AC-04",
        "text": "Понимает 5 критериев выбора (интеграция со стеком · размер команды/бюджет · совпадение навыков · соответствие · специализированные функции)"
      },
      {
        "id": "AC-05",
        "text": "Знает правило: «лучший инструмент» = «лучший для контекста» · не абсолют"
      },
      {
        "id": "AC-06",
        "text": "На собесе уровня middle отвечает структурно («категория X — инструменты A/B · категория Y — инструменты C/D · выбор зависит от ...»)"
      },
      {
        "id": "AC-07",
        "text": "Знаком с каркасом оценки инструментов · POC + bake-off (senior-ext)"
      },
      {
        "id": "AC-08",
        "text": "Понимает компромиссы Open Source vs коммерческих (senior-ext)"
      }
    ],
    "istqb": [
      "CTFL-Ch6"
    ],
    "skills": [
      "QA Concepts",
      "Performance & Security"
    ],
    "quickCheck": {
      "id": "QC-NF-09",
      "prompt": "Quick check",
      "question": "На собес middle спрашивают «какие QA tools знаешь». Какой ответ зрелее?",
      "options": [
        {
          "id": "a",
          "text": "«Все Postman» — одно имя без структуры"
        },
        {
          "id": "b",
          "text": "«Всё, что есть в BrowserStack» — один источник"
        },
        {
          "id": "c",
          "text": "«Знаю всё, не помню как называются»"
        },
        {
          "id": "d",
          "text": "«По категориям: API — Postman + SoapUI; SQL/DB — DBeaver + pgAdmin; Performance — Lighthouse + DevTools Performance; Security — OWASP ZAP + Burp Suite Community; Accessibility — axe-core + WAVE; AI — ChatGPT + Claude. В каждой минимум на basic уровне, с 1-2 examples»"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: ответ по категориям с 1-2 examples per category.</strong> Recruiter middle уровня хочет услышать обзорное знание рынка — карту QA tooling по категориям, не глубокую экспертизу в каждой. 5-6 категорий × 2 tools = ~10-12 имён + понимание, что каждый tool решает. Это сигнал, что ты не «one-tool-junior», у тебя картина рынка. Вариант (a) — одно имя = одна экспертиза = junior. Вариант (b) — narrow vendor lock-in. Вариант (c) — расплывчато, нечего предложить team. Запомни: <em>обзорное знание = категория + 1-2 tools per категория + 1 предложение что они делают</em>."
    }
  },
  {
    "id": "NF-10",
    "sprintId": "S12",
    "ord": 10,
    "type": "mission",
    "priority": "P0",
    "title": "Миссия · cross-NF расследование в Atelier · полный flow",
    "estimateMin": 60,
    "ac": [
      {
        "id": "AC-01",
        "text": "Прошёл сквозной аудит NF из 5 шагов (безопасность → производительность → доступность → сведение → сквозной баг-репорт по NF)"
      },
      {
        "id": "AC-02",
        "text": "Применил минимум 2 варианта теста IDOR (Шаг 1 — безопасность)"
      },
      {
        "id": "AC-03",
        "text": "Запустил аудит Lighthouse + анализ Network waterfall (Шаг 2 — производительность)"
      },
      {
        "id": "AC-04",
        "text": "Применил цикл из 4 инструментов доступности (axe + клавиатура + screen reader + контраст · Шаг 3 — доступность)"
      },
      {
        "id": "AC-05",
        "text": "Применил приоритизацию RBT (Шаг 4 — сведение) · топ-5 критичных · остальное сгруппировано"
      },
      {
        "id": "AC-06",
        "text": "Оформил сквозной баг-репорт по NF (Шаг 5) · единый сводный · доказательства по 3 доменам NF · рекомендации на уровне кода · запросы охвата"
      },
      {
        "id": "AC-07",
        "text": "Написал отчёт по миссии в формате уровня junior (что сделал · что узнал · что улучшить · честно об ограничениях)"
      },
      {
        "id": "AC-08",
        "text": "Избегает 4 анти-паттернов (3 отдельных отчёта · спешка с параллельным вместо последовательного · пропуск приоритизации · жёсткий лимит времени)"
      },
      {
        "id": "AC-09",
        "text": "Понимает Mission = capstone preparation для Block 2 Release v1.0"
      },
      {
        "id": "AC-10",
        "text": "Знаком с тем, что впереди Block 2 Capstone и мобильное тестирование S13 (senior-ext)"
      }
    ],
    "istqb": [
      "CTFL-Ch1",
      "CTFL-Ch2",
      "CTFL-Ch5",
      "CTFL-Ch6"
    ],
    "skills": [
      "Performance & Security",
      "QA Concepts",
      "AI Процесс",
      "Test Plan"
    ],
    "mission": {
      "cta": "Открыть Mission в Atelier",
      "atelierScenarioId": "block-2-cross-nf-investigation"
    },
    "quickCheck": {
      "id": "QC-NF-10",
      "prompt": "Quick check",
      "question": "Mission требует cross-NF audit одной Atelier feature. Какой порядок аудита оптимален для junior на первом cross-NF задании?",
      "options": [
        {
          "id": "a",
          "text": "Параллельно security + perf + a11y — быстрее"
        },
        {
          "id": "b",
          "text": "Только perf — junior не должна делать security и a11y"
        },
        {
          "id": "c",
          "text": "Случайным порядком, как пойдёт"
        },
        {
          "id": "d",
          "text": "Sequential на первый раз: security (IDOR / access control) → performance (Lighthouse + waterfall) → accessibility (axe-core + manual keyboard nav + screen reader spot-check) → консолидация findings → cross-NF bug report с разделом на каждый домен"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Правильно: sequential на первый раз.</strong> Sequential audit даёт junior полный фокус на каждом домене по очереди — меньше context switching, легче не пропустить категорию, чище документация. Параллельный аудит работает у middle с опытом, у junior — recipe потеряться. Каждый домен закрываешь, документируешь, переходишь к следующему. Финал — bug report с одним разделом на каждый домен (Security findings · Perf findings · a11y findings) + summary на cover page. Вариант (a) — параллельно на первый раз = пропуски + хаос. Вариант (b) — junior должна делать basic уровень всех 3 NF доменов. Вариант (c) — случайный порядок = без системы = пропуски. Запомни: <em>первый cross-NF audit = sequential; после 3-5 раз — пробовать параллельно</em>."
    }
  },
  {
    "id": "MOB-01",
    "sprintId": "S13",
    "ord": 1,
    "type": "docs",
    "priority": "P0",
    "title": "Чем телефон отличается от веба · почему мобильное — отдельная тема",
    "estimateMin": 14,
    "ac": [
      {
        "id": "AC-01",
        "text": "Объясняю, чем тестирование на телефоне отличается от веба (условия, а не размер экрана)"
      },
      {
        "id": "AC-02",
        "text": "Привожу 2 сценария мобайл-специфики (прерывание, смена сети, разные экраны)"
      },
      {
        "id": "AC-03",
        "text": "Понимаю рамку: это taster, мобильное — отдельная большая тема"
      },
      {
        "id": "AC-04",
        "text": "Знаю, что трогать руками будем через device-mode, без реального устройства"
      }
    ],
    "istqb": [],
    "skills": [
      "Mobile Testing",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-MOB-01",
      "prompt": "Quick check",
      "question": "Почему мобильное тестирование выделяют в отдельную тему, а не считают «вебом на маленьком экране»?",
      "options": [
        {
          "id": "a",
          "text": "Просто традиция"
        },
        {
          "id": "b",
          "text": "Потому что мобильное проще"
        },
        {
          "id": "c",
          "text": "У телефона свой набор условий, которых нет в вебе: жесты, прерывания, смена сети, разрешения, фрагментация, ограниченные ресурсы"
        },
        {
          "id": "d",
          "text": "Только потому, что экран меньше"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Верно — вариант C.</strong> Дело не в размере экрана, а в целом пласте ситуаций: касания, звонок посреди сценария, скачущая сеть, разрешения, ориентация, тысячи устройств, ограниченные батарея/память. Этого в вебе нет, и именно поэтому мобильное проверяют отдельно и специально."
    }
  },
  {
    "id": "MOB-02",
    "sprintId": "S13",
    "ord": 2,
    "type": "docs",
    "priority": "P0",
    "title": "Нативное, гибридное, мобайл-веб + Android и iOS · что меняется в тестировании",
    "estimateMin": 16,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю нативное / гибридное / мобайл-веб и понимаю разницу"
      },
      {
        "id": "AC-02",
        "text": "Знаю, что у каждого типа свой фокус тестирования"
      },
      {
        "id": "AC-03",
        "text": "Понимаю, что Android и iOS отличаются деталями (часто тестируют на обеих)"
      },
      {
        "id": "AC-04",
        "text": "Определяю тип приложения как первый шаг тест-планирования"
      }
    ],
    "istqb": [],
    "skills": [
      "Mobile Testing",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-MOB-02",
      "prompt": "Quick check",
      "question": "Приложение — это сайт, открытый в мобильном браузере, не ставится из стора. Какой это тип?",
      "options": [
        {
          "id": "a",
          "text": "Мобайл-веб"
        },
        {
          "id": "b",
          "text": "Нативное"
        },
        {
          "id": "c",
          "text": "Гибридное"
        },
        {
          "id": "d",
          "text": "Эмулятор"
        }
      ],
      "answer": "a",
      "explanation": "<strong>Верно — мобайл-веб.</strong> Не ставится, работает через браузер — это сайт на телефоне. Нативное ставится из стора и написано под платформу; гибридное — веб внутри нативной обёртки (тоже ставится). Тип определяет, что тестировать: у мобайл-веба фокус на мобильных браузерах и адаптиве."
    }
  },
  {
    "id": "MOB-03",
    "sprintId": "S13",
    "ord": 3,
    "type": "docs",
    "priority": "P0",
    "title": "Тысячи устройств · нельзя проверить всё · покрытие по риску",
    "estimateMin": 15,
    "ac": [
      {
        "id": "AC-01",
        "text": "Объясняю, что такое фрагментация и почему «протестировать на всём» невозможно"
      },
      {
        "id": "AC-02",
        "text": "Собираю стратегию покрытия по данным (аналитика + ключевые OS + края)"
      },
      {
        "id": "AC-03",
        "text": "Связываю покрытие устройств с приоритизацией по риску (S03)"
      },
      {
        "id": "AC-04",
        "text": "Отвечаю менеджеру на «протестируй на всех» профессионально"
      }
    ],
    "istqb": [],
    "skills": [
      "Mobile Testing",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-MOB-03",
      "prompt": "Quick check",
      "question": "Менеджер просит «протестировать на всех Android-устройствах». Что ответить как тестировщик?",
      "options": [
        {
          "id": "a",
          "text": "«Хорошо, проверю на всех тысячах»"
        },
        {
          "id": "b",
          "text": "«Проверю на своём телефоне, этого хватит»"
        },
        {
          "id": "c",
          "text": "«На всех невозможно; соберём матрицу покрытия по аналитике пользователей + ключевые версии OS + пара краёв — это разумный риск»"
        },
        {
          "id": "d",
          "text": "«Это не моя задача»"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Верно — вариант C.</strong> «На всех» физически невозможно (фрагментация), «на своём» — слишком мало. Профессиональный ответ — покрытие по данным и риску: реальные устройства пользователей + важные версии OS + крайние случаи. Это тот же принцип, что и с приоритизацией тестов по риску из S03, только применённый к устройствам."
    }
  },
  {
    "id": "MOB-04",
    "sprintId": "S13",
    "ord": 4,
    "type": "docs",
    "priority": "P0",
    "title": "Касания и жесты · ориентация · адаптив · практика в DevTools device-mode",
    "estimateMin": 17,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю основные жесты (тап/свайп/щипок/долгое нажатие) и что с ними проверять"
      },
      {
        "id": "AC-02",
        "text": "Проверяю ориентацию (поворот) и адаптив на разных экранах"
      },
      {
        "id": "AC-03",
        "text": "Прохожу практику в device-mode на demoblaze (устройства, поворот)"
      },
      {
        "id": "AC-04",
        "text": "Понимаю, что device-mode хорош для мобайл-веба, но не заменяет реальное устройство"
      }
    ],
    "istqb": [],
    "skills": [
      "Mobile Testing",
      "DevTools"
    ],
    "quickCheck": {
      "id": "QC-MOB-04",
      "prompt": "Quick check",
      "question": "Какой баг чаще всего ловится именно при повороте экрана?",
      "options": [
        {
          "id": "a",
          "text": "Приложение вообще не открывается"
        },
        {
          "id": "b",
          "text": "Ломается вёрстка или теряются введённые данные при смене ориентации"
        },
        {
          "id": "c",
          "text": "Меняется язык приложения"
        },
        {
          "id": "d",
          "text": "Садится батарея"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Верно — вариант B.</strong> Поворот экрана — классический источник багов: вёрстка не подстроилась (элементы налезли/уехали) или приложение «забыло» введённый в форму текст при пересоздании экрана. Поэтому смену ориентации проверяют отдельно, особенно на формах. В device-mode это видно по кнопке поворота."
    }
  },
  {
    "id": "MOB-05",
    "sprintId": "S13",
    "ord": 5,
    "type": "docs",
    "priority": "P0",
    "title": "Прерывания + смена сети + батарея/память · условия, которых нет в вебе",
    "estimateMin": 18,
    "ac": [
      {
        "id": "AC-01",
        "text": "Знаю чек-лист мобайл-условий: прерывания, фон/возврат, пропажа/смена сети, ресурсы"
      },
      {
        "id": "AC-02",
        "text": "На каждое условие задаю вопрос «сохранилось ли состояние / не задвоилось / не упало»"
      },
      {
        "id": "AC-03",
        "text": "Эмулирую пропажу/медленную сеть в DevTools (Offline / Slow 3G)"
      },
      {
        "id": "AC-04",
        "text": "Понимаю, что большинство мобильных багов — в этих внешних вмешательствах"
      }
    ],
    "istqb": [],
    "skills": [
      "Mobile Testing",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-MOB-05",
      "prompt": "Quick check",
      "question": "Главный вопрос при тесте «звонок во время оплаты»?",
      "options": [
        {
          "id": "a",
          "text": "Какой рингтон у звонка"
        },
        {
          "id": "b",
          "text": "Сколько длился звонок"
        },
        {
          "id": "c",
          "text": "Какая громкость была у телефона"
        },
        {
          "id": "d",
          "text": "Сохранилось ли состояние после возврата и не повторилась ли оплата (не списали дважды)"
        }
      ],
      "answer": "d",
      "explanation": "<strong>Верно — вариант D.</strong> Прерывание уводит приложение в фон в критический момент. Проверяем: вернулись — корзина/форма на месте? оплата не задвоилась? приложение не упало? Это типовой и важный мобильный сценарий, особенно вокруг денег. Рингтон, длительность и громкость к делу не относятся."
    }
  },
  {
    "id": "MOB-06",
    "sprintId": "S13",
    "ord": 6,
    "type": "docs",
    "priority": "P0",
    "title": "Permissions · lifecycle · push · install/update/uninstall",
    "estimateMin": 17,
    "ac": [
      {
        "id": "AC-01",
        "text": "Проверяю разрешения в трёх состояниях (дал / отклонил / отозвал), приоритет — отказ"
      },
      {
        "id": "AC-02",
        "text": "Знаю, что проверять при установке/обновлении/удалении (обновление не теряет данные)"
      },
      {
        "id": "AC-03",
        "text": "Проверяю пуши и deep links (и при закрытом, и при открытом приложении)"
      },
      {
        "id": "AC-04",
        "text": "Проверяю восстановление состояния после выгрузки из фона"
      }
    ],
    "istqb": [],
    "skills": [
      "Mobile Testing",
      "QA Concepts"
    ],
    "quickCheck": {
      "id": "QC-MOB-06",
      "prompt": "Quick check",
      "question": "Самый важный тест для разрешения (например на камеру)?",
      "options": [
        {
          "id": "a",
          "text": "Что будет, если пользователь его отклонил — приложение должно объяснить и не падать, а не зависнуть"
        },
        {
          "id": "b",
          "text": "Что будет, если пользователь его дал"
        },
        {
          "id": "c",
          "text": "Цвет кнопки разрешения"
        },
        {
          "id": "d",
          "text": "Сколько времени висит диалог разрешения"
        }
      ],
      "answer": "a",
      "explanation": "<strong>Верно — вариант A.</strong> «Дал разрешение» проверить тоже надо, но баги чаще в негативе: пользователь <em>отклонил</em>, а приложение падает, зависает или молча ничего не делает. Разумное поведение — объяснить, зачем нужно, и показать путь включить в настройках. Проверяем все три состояния, но отказ — приоритетный."
    }
  },
  {
    "id": "MOB-07",
    "sprintId": "S13",
    "ord": 7,
    "type": "docs",
    "priority": "P1",
    "title": "Эмулятор/симулятор vs реальное устройство · девайс-фермы · логи",
    "estimateMin": 16,
    "ac": [
      {
        "id": "AC-01",
        "text": "Различаю эмулятор/симулятор и реальное устройство и знаю, когда что"
      },
      {
        "id": "AC-02",
        "text": "Понимаю, что финальную проверку делают на реальном устройстве (или ферме)"
      },
      {
        "id": "AC-03",
        "text": "Знаю, зачем нужны облачные девайс-фермы (покрытие фрагментации)"
      },
      {
        "id": "AC-04",
        "text": "Знаю на уровне awareness, что логи устройства (adb logcat) существуют и идут в баг-репорт"
      }
    ],
    "istqb": [],
    "skills": [
      "Mobile Testing",
      "Tools"
    ],
    "quickCheck": {
      "id": "QC-MOB-07",
      "prompt": "Quick check",
      "question": "Финальную проверку перед релизом лучше делать на чём?",
      "options": [
        {
          "id": "a",
          "text": "Только на эмуляторе — он быстрее"
        },
        {
          "id": "b",
          "text": "На реальном устройстве (или облачной ферме) — эмулятор не покажет настоящие сенсоры, производительность и сеть"
        },
        {
          "id": "c",
          "text": "Нигде, и так понятно"
        },
        {
          "id": "d",
          "text": "Только в device-mode браузера"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Верно — вариант B.</strong> Эмулятор отлично подходит для быстрых ранних проверок, но финал — на реальном устройстве: только там настоящие жесты, камера/GPS, реальная производительность и поведение сети/батареи. Если своих устройств мало — облачная девайс-ферма даёт доступ к нужным моделям. Device-mode браузера годится только для мобайл-веба."
    }
  },
  {
    "id": "MOB-08",
    "sprintId": "S13",
    "ord": 8,
    "type": "docs",
    "priority": "P0",
    "title": "Баг-репорт на мобильном · устройство, версия OS, логи, видео",
    "estimateMin": 15,
    "ac": [
      {
        "id": "AC-01",
        "text": "Добавляю к баг-репорту S04 мобильные детали: устройство, версию OS, версию приложения, сеть"
      },
      {
        "id": "AC-02",
        "text": "Прикладываю видео экрана и логи как доказательство"
      },
      {
        "id": "AC-03",
        "text": "Объясняю, почему без устройства/версии мобильный баг невоспроизводим (фрагментация)"
      },
      {
        "id": "AC-04",
        "text": "Оформляю мобильный баг-репорт по образцу"
      }
    ],
    "istqb": [],
    "skills": [
      "Mobile Testing",
      "Defect Management"
    ],
    "quickCheck": {
      "id": "QC-MOB-08",
      "prompt": "Quick check",
      "question": "Разработчик пишет «у меня не воспроизводится». Чего, скорее всего, не хватило в мобильном баг-репорте?",
      "options": [
        {
          "id": "a",
          "text": "Цвета кнопки"
        },
        {
          "id": "b",
          "text": "Имени тестировщика"
        },
        {
          "id": "c",
          "text": "Конкретного устройства и версии OS (баг может быть только на этой модели/версии)"
        },
        {
          "id": "d",
          "text": "Точного времени по часам"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Верно — вариант C: устройство и версия OS.</strong> Из-за фрагментации мобильный баг часто живёт на конкретной модели/версии. Без них разработчик проверяет на своём устройстве, не воспроизводит и закрывает тикет. Добавь модель, версию OS, версию приложения и видео — и «не воспроизводится» исчезает."
    }
  },
  {
    "id": "MOB-AI",
    "sprintId": "S13",
    "ord": 9,
    "type": "ai",
    "priority": "P0",
    "title": "AI-напарник в мобильном · генерация чек-листа условий + объяснение логов",
    "estimateMin": 16,
    "ac": [
      {
        "id": "AC-01",
        "text": "Использую AI для генерации чек-листа мобильных проверок и объяснения логов"
      },
      {
        "id": "AC-02",
        "text": "Дополняю AI-список мобайл-условиями, которые он пропустил (прерывания/сеть/ориентация)"
      },
      {
        "id": "AC-03",
        "text": "Понимаю, что AI думает «как про веб» и забывает мобильную специфику"
      },
      {
        "id": "AC-04",
        "text": "Держу правило: широта от AI, мобильный контекст и приоритет — от меня"
      }
    ],
    "istqb": [],
    "skills": [
      "AI for QA",
      "Mobile Testing"
    ],
    "quickCheck": {
      "id": "QC-MOB-AI",
      "prompt": "Quick check",
      "question": "AI сгенерировал чек-лист для мобильного экрана оплаты, но он «вебовый». Что добавить в первую очередь?",
      "options": [
        {
          "id": "a",
          "text": "Ничего, AI-список всегда полный"
        },
        {
          "id": "b",
          "text": "Мобайл-условия: прерывание (звонок), смена/пропажа сети, поворот экрана, фон→возврат"
        },
        {
          "id": "c",
          "text": "Убрать негативные кейсы, чтобы было короче"
        },
        {
          "id": "d",
          "text": "Только поменять цвета в макете"
        }
      ],
      "answer": "b",
      "explanation": "<strong>Верно — вариант B.</strong> AI думает «как про веб» и забывает, что это телефон: даёт разумные, но общие проверки и пропускает мобайл-специфику. Твоя ценность — добавить условия из чек-листа «а что если...» (MOB-05): прерывания, сеть, ориентация, возврат из фона. Широта — от AI, мобильный контекст и приоритет — от тебя."
    }
  },
  {
    "id": "MOB-MISSION",
    "sprintId": "S13",
    "ord": 10,
    "type": "mission",
    "priority": "P0",
    "title": "Миссия · device-mode сессия + чек-лист условий + мобильный баг-репорт",
    "estimateMin": 22,
    "ac": [
      {
        "id": "AC-01",
        "text": "Провожу мини-сессию мобильного тестирования demoblaze в device-mode (несколько устройств)"
      },
      {
        "id": "AC-02",
        "text": "Проверяю адаптив, поворот, поведение при Offline/Slow 3G"
      },
      {
        "id": "AC-03",
        "text": "Прохожу по чек-листу мобайл-условий и фиксирую находку как мобильный баг-репорт"
      },
      {
        "id": "AC-04",
        "text": "Понимаю, что мобильную автоматизацию (Appium) свяжем с блоком автоматизации впереди"
      }
    ],
    "istqb": [],
    "skills": [
      "Mobile Testing",
      "Defect Management"
    ],
    "quickCheck": {
      "id": "QC-MOB-MISSION",
      "prompt": "Quick check",
      "question": "Мини-сессию мобильного тестирования demoblaze ты проводишь в device-mode. Чего этот режим НЕ покажет?",
      "options": [
        {
          "id": "a",
          "text": "Адаптив вёрстки на узком экране"
        },
        {
          "id": "b",
          "text": "Поведение при Offline / Slow 3G"
        },
        {
          "id": "c",
          "text": "Реальные сенсоры, настоящие жесты и истинную производительность устройства"
        },
        {
          "id": "d",
          "text": "Как сайт выглядит на разных размерах экрана"
        }
      ],
      "answer": "c",
      "explanation": "<strong>Верно — вариант C.</strong> Device-mode отлично показывает адаптив, поворот и поведение при эмуляции сети для мобайл-веба — этого хватает для миссии без реального телефона. Но он не воспроизводит настоящие жесты, сенсоры (камера/GPS) и реальную производительность — для этого нужно реальное устройство (или облачная ферма из MOB-07)."
    },
    "mission": {
      "gwt": {
        "given": "demoblaze.com, DevTools device-mode, чек-лист мобайл-условий (MOB-05) и форма мобильного баг-репорта (MOB-08).",
        "when": "Пройди сценарий (каталог, товар, корзина) в device-mode на 2-3 устройствах; поверни экран и проверь адаптив; эмулируй Offline/Slow 3G через Network throttling; пройди по чек-листу «а что если...».",
        "then": "Зафиксируй минимум одну находку (адаптив / поведение при офлайне / мелкие цели) как мобильный баг-репорт с устройством и краткий вывод «что мобайл-специфичного бросилось в глаза»."
      },
      "sample": "Сессия: demoblaze в device-mode (iPhone SE / Pixel 5 / Galaxy A12). Находка: [device-mode / iPhone SE] кнопки каталога мелкие для пальца на узком экране (375px), цели тапа меньше ~44px, легко промахнуться. При Offline — вечный спиннер вместо понятной ошибки. Поворот вёрстку не ломает. Доказательство: скриншот. Вывод: основная мобайл-специфика на demoblaze — мелкие цели тапа и слабая обработка офлайна.",
      "reflectionPrompts": [
        "Что мобайл-специфичного бросилось в глаза, чего не встретить в обычном вебе?",
        "Какое условие из чек-листа «а что если...» оказалось самым полезным на demoblaze?",
        "Чего device-mode НЕ покажет, и для чего понадобилось бы реальное устройство?"
      ],
      "cta": "Открой demoblaze в DevTools device-mode, пройди сценарий на 2-3 устройствах, прогони чек-лист условий и оформи находку как мобильный баг-репорт с устройством.",
      "acceptanceText": "Сессия пройдена на 2-3 устройствах, проверены адаптив/поворот/сеть (Offline/Slow 3G), зафиксирована минимум одна находка по форме мобильного баг-репорта с указанием устройства."
    }
  }
];
